(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree84d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree84d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hT5KM", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return Color; });
$parcel$export(module.exports, "darker", function () { return darker; });
$parcel$export(module.exports, "brighter", function () { return brighter; });
$parcel$export(module.exports, "default", function () { return color; });
$parcel$export(module.exports, "hslConvert", function () { return hslConvert; });
$parcel$export(module.exports, "Rgb", function () { return Rgb; });
$parcel$export(module.exports, "rgbConvert", function () { return rgbConvert; });
$parcel$export(module.exports, "rgb", function () { return rgb; });
$parcel$export(module.exports, "hsl", function () { return hsl; });

var $cHXDo = parcelRequire("cHXDo");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $cHXDo.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $cHXDo.default)(Rgb, rgb, (0, $cHXDo.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $cHXDo.default)(Hsl, hsl, (0, $cHXDo.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("cHXDo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9407c2598a809906$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $9407c2598a809906$export$8b58be045bf06082; });
function $9407c2598a809906$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $9407c2598a809906$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


/* eslint-disable */ /**
 * public/js/index.js
 * Fő kliensoldali belépési pont (Pug nézetekhez).
 * - Minden eseménykötés őrizve van (guard), így nincs "Cannot read property addEventListener of null".
 * - Axios import (ha Parcel bundle-ölsz → 'axios', ha nem → CDN-es import).
 * - Vizualizátor integráció: duplikáció-mentes rajzolás, frakciók, export.
 * - Kereső oldal: similarity UI guard, SMILES → CAS feloldás (POST /api/compounds/smiles/).
 */ // --- Axios import: válassz üzemmód szerint ---
//import axios from 'https://cdn.jsdelivr.net/npm/axios@1.9.0/+esm'; // ha közvetlenül a böngésző tölti
'use strict';
function $50bf470c4f6c40fc$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $4149b3c0d0254d8f$var$toString } = Object.prototype;
const { getPrototypeOf: $4149b3c0d0254d8f$var$getPrototypeOf } = Object;
const { iterator: $4149b3c0d0254d8f$var$iterator, toStringTag: $4149b3c0d0254d8f$var$toStringTag } = Symbol;
const $4149b3c0d0254d8f$var$kindOf = ((cache)=>(thing)=>{
        const str = $4149b3c0d0254d8f$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $4149b3c0d0254d8f$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$4149b3c0d0254d8f$var$kindOf(thing) === type;
};
const $4149b3c0d0254d8f$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $4149b3c0d0254d8f$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $4149b3c0d0254d8f$var$isUndefined = $4149b3c0d0254d8f$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $4149b3c0d0254d8f$var$isBuffer(val) {
    return val !== null && !$4149b3c0d0254d8f$var$isUndefined(val) && val.constructor !== null && !$4149b3c0d0254d8f$var$isUndefined(val.constructor) && $4149b3c0d0254d8f$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $4149b3c0d0254d8f$var$isArrayBuffer = $4149b3c0d0254d8f$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $4149b3c0d0254d8f$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $4149b3c0d0254d8f$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $4149b3c0d0254d8f$var$isString = $4149b3c0d0254d8f$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $4149b3c0d0254d8f$var$isFunction = $4149b3c0d0254d8f$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $4149b3c0d0254d8f$var$isNumber = $4149b3c0d0254d8f$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $4149b3c0d0254d8f$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $4149b3c0d0254d8f$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $4149b3c0d0254d8f$var$isPlainObject = (val)=>{
    if ($4149b3c0d0254d8f$var$kindOf(val) !== 'object') return false;
    const prototype = $4149b3c0d0254d8f$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($4149b3c0d0254d8f$var$toStringTag in val) && !($4149b3c0d0254d8f$var$iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $4149b3c0d0254d8f$var$isDate = $4149b3c0d0254d8f$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $4149b3c0d0254d8f$var$isFile = $4149b3c0d0254d8f$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $4149b3c0d0254d8f$var$isBlob = $4149b3c0d0254d8f$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $4149b3c0d0254d8f$var$isFileList = $4149b3c0d0254d8f$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $4149b3c0d0254d8f$var$isStream = (val)=>$4149b3c0d0254d8f$var$isObject(val) && $4149b3c0d0254d8f$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $4149b3c0d0254d8f$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $4149b3c0d0254d8f$var$isFunction(thing.append) && ((kind = $4149b3c0d0254d8f$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $4149b3c0d0254d8f$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $4149b3c0d0254d8f$var$isURLSearchParams = $4149b3c0d0254d8f$var$kindOfTest('URLSearchParams');
const [$4149b3c0d0254d8f$var$isReadableStream, $4149b3c0d0254d8f$var$isRequest, $4149b3c0d0254d8f$var$isResponse, $4149b3c0d0254d8f$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($4149b3c0d0254d8f$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $4149b3c0d0254d8f$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $4149b3c0d0254d8f$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($4149b3c0d0254d8f$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $4149b3c0d0254d8f$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $4149b3c0d0254d8f$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $4149b3c0d0254d8f$var$isContextDefined = (context)=>!$4149b3c0d0254d8f$var$isUndefined(context) && context !== $4149b3c0d0254d8f$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $4149b3c0d0254d8f$var$merge() {
    const { caseless: caseless } = $4149b3c0d0254d8f$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $4149b3c0d0254d8f$var$findKey(result, key) || key;
        if ($4149b3c0d0254d8f$var$isPlainObject(result[targetKey]) && $4149b3c0d0254d8f$var$isPlainObject(val)) result[targetKey] = $4149b3c0d0254d8f$var$merge(result[targetKey], val);
        else if ($4149b3c0d0254d8f$var$isPlainObject(val)) result[targetKey] = $4149b3c0d0254d8f$var$merge({}, val);
        else if ($4149b3c0d0254d8f$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $4149b3c0d0254d8f$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $4149b3c0d0254d8f$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $4149b3c0d0254d8f$var$forEach(b, (val, key)=>{
        if (thisArg && $4149b3c0d0254d8f$var$isFunction(val)) a[key] = (0, $50bf470c4f6c40fc$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $4149b3c0d0254d8f$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $4149b3c0d0254d8f$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $4149b3c0d0254d8f$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $4149b3c0d0254d8f$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $4149b3c0d0254d8f$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $4149b3c0d0254d8f$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($4149b3c0d0254d8f$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$4149b3c0d0254d8f$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $4149b3c0d0254d8f$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $4149b3c0d0254d8f$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $4149b3c0d0254d8f$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$4149b3c0d0254d8f$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $4149b3c0d0254d8f$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $4149b3c0d0254d8f$var$isHTMLForm = $4149b3c0d0254d8f$var$kindOfTest('HTMLFormElement');
const $4149b3c0d0254d8f$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $4149b3c0d0254d8f$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $4149b3c0d0254d8f$var$isRegExp = $4149b3c0d0254d8f$var$kindOfTest('RegExp');
const $4149b3c0d0254d8f$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $4149b3c0d0254d8f$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $4149b3c0d0254d8f$var$freezeMethods = (obj)=>{
    $4149b3c0d0254d8f$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($4149b3c0d0254d8f$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$4149b3c0d0254d8f$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $4149b3c0d0254d8f$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $4149b3c0d0254d8f$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $4149b3c0d0254d8f$var$noop = ()=>{};
const $4149b3c0d0254d8f$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $4149b3c0d0254d8f$var$isSpecCompliantForm(thing) {
    return !!(thing && $4149b3c0d0254d8f$var$isFunction(thing.append) && thing[$4149b3c0d0254d8f$var$toStringTag] === 'FormData' && thing[$4149b3c0d0254d8f$var$iterator]);
}
const $4149b3c0d0254d8f$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($4149b3c0d0254d8f$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $4149b3c0d0254d8f$var$isArray(source) ? [] : {};
                $4149b3c0d0254d8f$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$4149b3c0d0254d8f$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $4149b3c0d0254d8f$var$isAsyncFn = $4149b3c0d0254d8f$var$kindOfTest('AsyncFunction');
const $4149b3c0d0254d8f$var$isThenable = (thing)=>thing && ($4149b3c0d0254d8f$var$isObject(thing) || $4149b3c0d0254d8f$var$isFunction(thing)) && $4149b3c0d0254d8f$var$isFunction(thing.then) && $4149b3c0d0254d8f$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $4149b3c0d0254d8f$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $4149b3c0d0254d8f$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $4149b3c0d0254d8f$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $4149b3c0d0254d8f$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $4149b3c0d0254d8f$var$isFunction($4149b3c0d0254d8f$var$_global.postMessage));
const $4149b3c0d0254d8f$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($4149b3c0d0254d8f$var$_global) : $4149b3c0d0254d8f$var$_setImmediate;
// *********************
const $4149b3c0d0254d8f$var$isIterable = (thing)=>thing != null && $4149b3c0d0254d8f$var$isFunction(thing[$4149b3c0d0254d8f$var$iterator]);
var $4149b3c0d0254d8f$export$2e2bcd8739ae039 = {
    isArray: $4149b3c0d0254d8f$var$isArray,
    isArrayBuffer: $4149b3c0d0254d8f$var$isArrayBuffer,
    isBuffer: $4149b3c0d0254d8f$var$isBuffer,
    isFormData: $4149b3c0d0254d8f$var$isFormData,
    isArrayBufferView: $4149b3c0d0254d8f$var$isArrayBufferView,
    isString: $4149b3c0d0254d8f$var$isString,
    isNumber: $4149b3c0d0254d8f$var$isNumber,
    isBoolean: $4149b3c0d0254d8f$var$isBoolean,
    isObject: $4149b3c0d0254d8f$var$isObject,
    isPlainObject: $4149b3c0d0254d8f$var$isPlainObject,
    isReadableStream: $4149b3c0d0254d8f$var$isReadableStream,
    isRequest: $4149b3c0d0254d8f$var$isRequest,
    isResponse: $4149b3c0d0254d8f$var$isResponse,
    isHeaders: $4149b3c0d0254d8f$var$isHeaders,
    isUndefined: $4149b3c0d0254d8f$var$isUndefined,
    isDate: $4149b3c0d0254d8f$var$isDate,
    isFile: $4149b3c0d0254d8f$var$isFile,
    isBlob: $4149b3c0d0254d8f$var$isBlob,
    isRegExp: $4149b3c0d0254d8f$var$isRegExp,
    isFunction: $4149b3c0d0254d8f$var$isFunction,
    isStream: $4149b3c0d0254d8f$var$isStream,
    isURLSearchParams: $4149b3c0d0254d8f$var$isURLSearchParams,
    isTypedArray: $4149b3c0d0254d8f$var$isTypedArray,
    isFileList: $4149b3c0d0254d8f$var$isFileList,
    forEach: $4149b3c0d0254d8f$var$forEach,
    merge: $4149b3c0d0254d8f$var$merge,
    extend: $4149b3c0d0254d8f$var$extend,
    trim: $4149b3c0d0254d8f$var$trim,
    stripBOM: $4149b3c0d0254d8f$var$stripBOM,
    inherits: $4149b3c0d0254d8f$var$inherits,
    toFlatObject: $4149b3c0d0254d8f$var$toFlatObject,
    kindOf: $4149b3c0d0254d8f$var$kindOf,
    kindOfTest: $4149b3c0d0254d8f$var$kindOfTest,
    endsWith: $4149b3c0d0254d8f$var$endsWith,
    toArray: $4149b3c0d0254d8f$var$toArray,
    forEachEntry: $4149b3c0d0254d8f$var$forEachEntry,
    matchAll: $4149b3c0d0254d8f$var$matchAll,
    isHTMLForm: $4149b3c0d0254d8f$var$isHTMLForm,
    hasOwnProperty: $4149b3c0d0254d8f$var$hasOwnProperty,
    hasOwnProp: $4149b3c0d0254d8f$var$hasOwnProperty,
    reduceDescriptors: $4149b3c0d0254d8f$var$reduceDescriptors,
    freezeMethods: $4149b3c0d0254d8f$var$freezeMethods,
    toObjectSet: $4149b3c0d0254d8f$var$toObjectSet,
    toCamelCase: $4149b3c0d0254d8f$var$toCamelCase,
    noop: $4149b3c0d0254d8f$var$noop,
    toFiniteNumber: $4149b3c0d0254d8f$var$toFiniteNumber,
    findKey: $4149b3c0d0254d8f$var$findKey,
    global: $4149b3c0d0254d8f$var$_global,
    isContextDefined: $4149b3c0d0254d8f$var$isContextDefined,
    isSpecCompliantForm: $4149b3c0d0254d8f$var$isSpecCompliantForm,
    toJSONObject: $4149b3c0d0254d8f$var$toJSONObject,
    isAsyncFn: $4149b3c0d0254d8f$var$isAsyncFn,
    isThenable: $4149b3c0d0254d8f$var$isThenable,
    setImmediate: $4149b3c0d0254d8f$var$_setImmediate,
    asap: $4149b3c0d0254d8f$var$asap,
    isIterable: $4149b3c0d0254d8f$var$isIterable
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $2dd5fba2ea5eebbf$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).inherits($2dd5fba2ea5eebbf$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $2dd5fba2ea5eebbf$var$prototype = $2dd5fba2ea5eebbf$var$AxiosError.prototype;
const $2dd5fba2ea5eebbf$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $2dd5fba2ea5eebbf$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($2dd5fba2ea5eebbf$var$AxiosError, $2dd5fba2ea5eebbf$var$descriptors);
Object.defineProperty($2dd5fba2ea5eebbf$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$2dd5fba2ea5eebbf$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($2dd5fba2ea5eebbf$var$prototype);
    (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $2dd5fba2ea5eebbf$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $2dd5fba2ea5eebbf$export$2e2bcd8739ae039 = $2dd5fba2ea5eebbf$var$AxiosError;


// eslint-disable-next-line strict
var $77c5c5d1798bbe47$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $530710020ff94d08$export$a143d493d941bafc;
var $530710020ff94d08$export$e4cf37d7f6fb9e0a;
var $530710020ff94d08$export$f99ded8fe4b79145;
var $530710020ff94d08$export$599f31c3813fae4d;
'use strict';
var $3d92faa58f5a5001$export$a48f0734ac7c2329;
var $3d92faa58f5a5001$export$d622b2ad8d90c771;
var $3d92faa58f5a5001$export$6100ba28696e12de;
'use strict';
$3d92faa58f5a5001$export$a48f0734ac7c2329 = $3d92faa58f5a5001$var$byteLength;
$3d92faa58f5a5001$export$d622b2ad8d90c771 = $3d92faa58f5a5001$var$toByteArray;
$3d92faa58f5a5001$export$6100ba28696e12de = $3d92faa58f5a5001$var$fromByteArray;
var $3d92faa58f5a5001$var$lookup = [];
var $3d92faa58f5a5001$var$revLookup = [];
var $3d92faa58f5a5001$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $3d92faa58f5a5001$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $3d92faa58f5a5001$var$i = 0, $3d92faa58f5a5001$var$len = $3d92faa58f5a5001$var$code.length; $3d92faa58f5a5001$var$i < $3d92faa58f5a5001$var$len; ++$3d92faa58f5a5001$var$i){
    $3d92faa58f5a5001$var$lookup[$3d92faa58f5a5001$var$i] = $3d92faa58f5a5001$var$code[$3d92faa58f5a5001$var$i];
    $3d92faa58f5a5001$var$revLookup[$3d92faa58f5a5001$var$code.charCodeAt($3d92faa58f5a5001$var$i)] = $3d92faa58f5a5001$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3d92faa58f5a5001$var$revLookup['-'.charCodeAt(0)] = 62;
$3d92faa58f5a5001$var$revLookup['_'.charCodeAt(0)] = 63;
function $3d92faa58f5a5001$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $3d92faa58f5a5001$var$byteLength(b64) {
    var lens = $3d92faa58f5a5001$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3d92faa58f5a5001$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3d92faa58f5a5001$var$toByteArray(b64) {
    var tmp;
    var lens = $3d92faa58f5a5001$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3d92faa58f5a5001$var$Arr($3d92faa58f5a5001$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3d92faa58f5a5001$var$revLookup[b64.charCodeAt(i)] << 18 | $3d92faa58f5a5001$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3d92faa58f5a5001$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3d92faa58f5a5001$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3d92faa58f5a5001$var$revLookup[b64.charCodeAt(i)] << 2 | $3d92faa58f5a5001$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3d92faa58f5a5001$var$revLookup[b64.charCodeAt(i)] << 10 | $3d92faa58f5a5001$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3d92faa58f5a5001$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3d92faa58f5a5001$var$tripletToBase64(num) {
    return $3d92faa58f5a5001$var$lookup[num >> 18 & 0x3F] + $3d92faa58f5a5001$var$lookup[num >> 12 & 0x3F] + $3d92faa58f5a5001$var$lookup[num >> 6 & 0x3F] + $3d92faa58f5a5001$var$lookup[num & 0x3F];
}
function $3d92faa58f5a5001$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3d92faa58f5a5001$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $3d92faa58f5a5001$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3d92faa58f5a5001$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3d92faa58f5a5001$var$lookup[tmp >> 2] + $3d92faa58f5a5001$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3d92faa58f5a5001$var$lookup[tmp >> 10] + $3d92faa58f5a5001$var$lookup[tmp >> 4 & 0x3F] + $3d92faa58f5a5001$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $f992f24348ca07e3$export$aafa59e2e03f2942;
var $f992f24348ca07e3$export$68d8715fc104d294;
$f992f24348ca07e3$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$f992f24348ca07e3$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $530710020ff94d08$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$530710020ff94d08$export$a143d493d941bafc = $530710020ff94d08$var$Buffer;
$530710020ff94d08$export$e4cf37d7f6fb9e0a = $530710020ff94d08$var$SlowBuffer;
$530710020ff94d08$export$f99ded8fe4b79145 = 50;
var $530710020ff94d08$var$K_MAX_LENGTH = 0x7fffffff;
$530710020ff94d08$export$599f31c3813fae4d = $530710020ff94d08$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $530710020ff94d08$var$Buffer.TYPED_ARRAY_SUPPORT = $530710020ff94d08$var$typedArraySupport();
if (!$530710020ff94d08$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $530710020ff94d08$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($530710020ff94d08$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$530710020ff94d08$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($530710020ff94d08$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$530710020ff94d08$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $530710020ff94d08$var$createBuffer(length) {
    if (length > $530710020ff94d08$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $530710020ff94d08$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $530710020ff94d08$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $530710020ff94d08$var$allocUnsafe(arg);
    }
    return $530710020ff94d08$var$from(arg, encodingOrOffset, length);
}
$530710020ff94d08$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $530710020ff94d08$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $530710020ff94d08$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $530710020ff94d08$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($530710020ff94d08$var$isInstance(value, ArrayBuffer) || value && $530710020ff94d08$var$isInstance(value.buffer, ArrayBuffer)) return $530710020ff94d08$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($530710020ff94d08$var$isInstance(value, SharedArrayBuffer) || value && $530710020ff94d08$var$isInstance(value.buffer, SharedArrayBuffer))) return $530710020ff94d08$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $530710020ff94d08$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $530710020ff94d08$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $530710020ff94d08$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $530710020ff94d08$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $530710020ff94d08$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($530710020ff94d08$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($530710020ff94d08$var$Buffer, Uint8Array);
function $530710020ff94d08$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $530710020ff94d08$var$alloc(size, fill, encoding) {
    $530710020ff94d08$var$assertSize(size);
    if (size <= 0) return $530710020ff94d08$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $530710020ff94d08$var$createBuffer(size).fill(fill, encoding) : $530710020ff94d08$var$createBuffer(size).fill(fill);
    return $530710020ff94d08$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $530710020ff94d08$var$Buffer.alloc = function(size, fill, encoding) {
    return $530710020ff94d08$var$alloc(size, fill, encoding);
};
function $530710020ff94d08$var$allocUnsafe(size) {
    $530710020ff94d08$var$assertSize(size);
    return $530710020ff94d08$var$createBuffer(size < 0 ? 0 : $530710020ff94d08$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $530710020ff94d08$var$Buffer.allocUnsafe = function(size) {
    return $530710020ff94d08$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $530710020ff94d08$var$Buffer.allocUnsafeSlow = function(size) {
    return $530710020ff94d08$var$allocUnsafe(size);
};
function $530710020ff94d08$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$530710020ff94d08$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $530710020ff94d08$var$byteLength(string, encoding) | 0;
    var buf = $530710020ff94d08$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $530710020ff94d08$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $530710020ff94d08$var$checked(array.length) | 0;
    var buf = $530710020ff94d08$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $530710020ff94d08$var$fromArrayView(arrayView) {
    if ($530710020ff94d08$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $530710020ff94d08$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $530710020ff94d08$var$fromArrayLike(arrayView);
}
function $530710020ff94d08$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $530710020ff94d08$var$Buffer.prototype);
    return buf;
}
function $530710020ff94d08$var$fromObject(obj) {
    if ($530710020ff94d08$var$Buffer.isBuffer(obj)) {
        var len = $530710020ff94d08$var$checked(obj.length) | 0;
        var buf = $530710020ff94d08$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $530710020ff94d08$var$numberIsNaN(obj.length)) return $530710020ff94d08$var$createBuffer(0);
        return $530710020ff94d08$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $530710020ff94d08$var$fromArrayLike(obj.data);
}
function $530710020ff94d08$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $530710020ff94d08$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $530710020ff94d08$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $530710020ff94d08$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $530710020ff94d08$var$Buffer.alloc(+length);
}
$530710020ff94d08$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $530710020ff94d08$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$530710020ff94d08$var$Buffer.compare = function compare(a, b) {
    if ($530710020ff94d08$var$isInstance(a, Uint8Array)) a = $530710020ff94d08$var$Buffer.from(a, a.offset, a.byteLength);
    if ($530710020ff94d08$var$isInstance(b, Uint8Array)) b = $530710020ff94d08$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$530710020ff94d08$var$Buffer.isBuffer(a) || !$530710020ff94d08$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$530710020ff94d08$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$530710020ff94d08$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $530710020ff94d08$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $530710020ff94d08$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($530710020ff94d08$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $530710020ff94d08$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$530710020ff94d08$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $530710020ff94d08$var$byteLength(string, encoding) {
    if ($530710020ff94d08$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $530710020ff94d08$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $530710020ff94d08$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $530710020ff94d08$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $530710020ff94d08$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$530710020ff94d08$var$Buffer.byteLength = $530710020ff94d08$var$byteLength;
function $530710020ff94d08$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $530710020ff94d08$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $530710020ff94d08$var$utf8Slice(this, start, end);
        case 'ascii':
            return $530710020ff94d08$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $530710020ff94d08$var$latin1Slice(this, start, end);
        case 'base64':
            return $530710020ff94d08$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $530710020ff94d08$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$530710020ff94d08$var$Buffer.prototype._isBuffer = true;
function $530710020ff94d08$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$530710020ff94d08$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$530710020ff94d08$var$swap(this, i, i + 1);
    return this;
};
$530710020ff94d08$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $530710020ff94d08$var$swap(this, i, i + 3);
        $530710020ff94d08$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$530710020ff94d08$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $530710020ff94d08$var$swap(this, i, i + 7);
        $530710020ff94d08$var$swap(this, i + 1, i + 6);
        $530710020ff94d08$var$swap(this, i + 2, i + 5);
        $530710020ff94d08$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$530710020ff94d08$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $530710020ff94d08$var$utf8Slice(this, 0, length);
    return $530710020ff94d08$var$slowToString.apply(this, arguments);
};
$530710020ff94d08$var$Buffer.prototype.toLocaleString = $530710020ff94d08$var$Buffer.prototype.toString;
$530710020ff94d08$var$Buffer.prototype.equals = function equals(b) {
    if (!$530710020ff94d08$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $530710020ff94d08$var$Buffer.compare(this, b) === 0;
};
$530710020ff94d08$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $530710020ff94d08$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($530710020ff94d08$var$customInspectSymbol) $530710020ff94d08$var$Buffer.prototype[$530710020ff94d08$var$customInspectSymbol] = $530710020ff94d08$var$Buffer.prototype.inspect;
$530710020ff94d08$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($530710020ff94d08$var$isInstance(target, Uint8Array)) target = $530710020ff94d08$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$530710020ff94d08$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $530710020ff94d08$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($530710020ff94d08$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $530710020ff94d08$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($530710020ff94d08$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $530710020ff94d08$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $530710020ff94d08$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $530710020ff94d08$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$530710020ff94d08$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$530710020ff94d08$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $530710020ff94d08$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$530710020ff94d08$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $530710020ff94d08$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $530710020ff94d08$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($530710020ff94d08$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $530710020ff94d08$var$utf8Write(buf, string, offset, length) {
    return $530710020ff94d08$var$blitBuffer($530710020ff94d08$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $530710020ff94d08$var$asciiWrite(buf, string, offset, length) {
    return $530710020ff94d08$var$blitBuffer($530710020ff94d08$var$asciiToBytes(string), buf, offset, length);
}
function $530710020ff94d08$var$base64Write(buf, string, offset, length) {
    return $530710020ff94d08$var$blitBuffer($530710020ff94d08$var$base64ToBytes(string), buf, offset, length);
}
function $530710020ff94d08$var$ucs2Write(buf, string, offset, length) {
    return $530710020ff94d08$var$blitBuffer($530710020ff94d08$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$530710020ff94d08$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $530710020ff94d08$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $530710020ff94d08$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $530710020ff94d08$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $530710020ff94d08$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $530710020ff94d08$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$530710020ff94d08$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $530710020ff94d08$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $3d92faa58f5a5001$export$6100ba28696e12de(buf);
    else return $3d92faa58f5a5001$export$6100ba28696e12de(buf.slice(start, end));
}
function $530710020ff94d08$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $530710020ff94d08$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $530710020ff94d08$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $530710020ff94d08$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $530710020ff94d08$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $530710020ff94d08$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $530710020ff94d08$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $530710020ff94d08$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $530710020ff94d08$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $530710020ff94d08$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $530710020ff94d08$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$530710020ff94d08$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $530710020ff94d08$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $530710020ff94d08$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$530710020ff94d08$var$Buffer.prototype.readUintLE = $530710020ff94d08$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$530710020ff94d08$var$Buffer.prototype.readUintBE = $530710020ff94d08$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$530710020ff94d08$var$Buffer.prototype.readUint8 = $530710020ff94d08$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$530710020ff94d08$var$Buffer.prototype.readUint16LE = $530710020ff94d08$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$530710020ff94d08$var$Buffer.prototype.readUint16BE = $530710020ff94d08$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$530710020ff94d08$var$Buffer.prototype.readUint32LE = $530710020ff94d08$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$530710020ff94d08$var$Buffer.prototype.readUint32BE = $530710020ff94d08$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$530710020ff94d08$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$530710020ff94d08$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$530710020ff94d08$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$530710020ff94d08$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$530710020ff94d08$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$530710020ff94d08$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$530710020ff94d08$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$530710020ff94d08$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkOffset(offset, 4, this.length);
    return $f992f24348ca07e3$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$530710020ff94d08$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkOffset(offset, 4, this.length);
    return $f992f24348ca07e3$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$530710020ff94d08$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkOffset(offset, 8, this.length);
    return $f992f24348ca07e3$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$530710020ff94d08$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkOffset(offset, 8, this.length);
    return $f992f24348ca07e3$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $530710020ff94d08$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$530710020ff94d08$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$530710020ff94d08$var$Buffer.prototype.writeUintLE = $530710020ff94d08$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $530710020ff94d08$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$530710020ff94d08$var$Buffer.prototype.writeUintBE = $530710020ff94d08$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $530710020ff94d08$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$530710020ff94d08$var$Buffer.prototype.writeUint8 = $530710020ff94d08$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$530710020ff94d08$var$Buffer.prototype.writeUint16LE = $530710020ff94d08$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$530710020ff94d08$var$Buffer.prototype.writeUint16BE = $530710020ff94d08$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$530710020ff94d08$var$Buffer.prototype.writeUint32LE = $530710020ff94d08$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$530710020ff94d08$var$Buffer.prototype.writeUint32BE = $530710020ff94d08$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$530710020ff94d08$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $530710020ff94d08$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$530710020ff94d08$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $530710020ff94d08$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$530710020ff94d08$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$530710020ff94d08$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$530710020ff94d08$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$530710020ff94d08$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$530710020ff94d08$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $530710020ff94d08$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $530710020ff94d08$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $f992f24348ca07e3$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$530710020ff94d08$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $530710020ff94d08$var$writeFloat(this, value, offset, true, noAssert);
};
$530710020ff94d08$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $530710020ff94d08$var$writeFloat(this, value, offset, false, noAssert);
};
function $530710020ff94d08$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $530710020ff94d08$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $f992f24348ca07e3$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$530710020ff94d08$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $530710020ff94d08$var$writeDouble(this, value, offset, true, noAssert);
};
$530710020ff94d08$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $530710020ff94d08$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$530710020ff94d08$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$530710020ff94d08$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$530710020ff94d08$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$530710020ff94d08$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $530710020ff94d08$var$Buffer.isBuffer(val) ? val : $530710020ff94d08$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $530710020ff94d08$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $530710020ff94d08$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($530710020ff94d08$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $530710020ff94d08$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $530710020ff94d08$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $530710020ff94d08$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $530710020ff94d08$var$base64ToBytes(str) {
    return $3d92faa58f5a5001$export$d622b2ad8d90c771($530710020ff94d08$var$base64clean(str));
}
function $530710020ff94d08$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $530710020ff94d08$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $530710020ff94d08$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $530710020ff94d08$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $d4971b3b43de0c5e$require$Buffer = $530710020ff94d08$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $d4971b3b43de0c5e$var$isVisitable(thing) {
    return (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $d4971b3b43de0c5e$var$removeBrackets(key) {
    return (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $d4971b3b43de0c5e$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $d4971b3b43de0c5e$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $d4971b3b43de0c5e$var$isFlatArray(arr) {
    return (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isArray(arr) && !arr.some($d4971b3b43de0c5e$var$isVisitable);
}
const $d4971b3b43de0c5e$var$predicates = (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).toFlatObject((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $d4971b3b43de0c5e$var$toFormData(obj, formData, options) {
    if (!(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $77c5c5d1798bbe47$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $d4971b3b43de0c5e$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isArray(value) && $d4971b3b43de0c5e$var$isFlatArray(value) || ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isFileList(value) || (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $d4971b3b43de0c5e$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $d4971b3b43de0c5e$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($d4971b3b43de0c5e$var$isVisitable(value)) return true;
        formData.append($d4971b3b43de0c5e$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($d4971b3b43de0c5e$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $d4971b3b43de0c5e$var$isVisitable
    });
    function build(value, path) {
        if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $d4971b3b43de0c5e$export$2e2bcd8739ae039 = $d4971b3b43de0c5e$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $24109fc34e8d304f$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $24109fc34e8d304f$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $d4971b3b43de0c5e$export$2e2bcd8739ae039)(params, this, options);
}
const $24109fc34e8d304f$var$prototype = $24109fc34e8d304f$var$AxiosURLSearchParams.prototype;
$24109fc34e8d304f$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$24109fc34e8d304f$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $24109fc34e8d304f$var$encode);
    } : $24109fc34e8d304f$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $24109fc34e8d304f$export$2e2bcd8739ae039 = $24109fc34e8d304f$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $34e298963efbc70a$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $34e298963efbc70a$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $34e298963efbc70a$var$encode;
    if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $24109fc34e8d304f$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $ed43ea8051e3c504$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $ed43ea8051e3c504$export$2e2bcd8739ae039 = $ed43ea8051e3c504$var$InterceptorManager;





'use strict';
var $6e8be51f4c202714$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






'use strict';
var $ea7e3bb6ef411540$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $24109fc34e8d304f$export$2e2bcd8739ae039);


'use strict';
var $e29f52d52025f62f$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $feda8707e35d9288$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $f02793a5b833a13d$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $ea7e3bb6ef411540$export$2e2bcd8739ae039,
        FormData: $e29f52d52025f62f$export$2e2bcd8739ae039,
        Blob: $feda8707e35d9288$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $621ce590ec883292$exports = {};

$parcel$export($621ce590ec883292$exports, "hasBrowserEnv", function () { return $621ce590ec883292$export$c4996c4b7b93b0bf; });
$parcel$export($621ce590ec883292$exports, "navigator", function () { return $621ce590ec883292$export$ec7c8efa7f5790ae; });
$parcel$export($621ce590ec883292$exports, "hasStandardBrowserEnv", function () { return $621ce590ec883292$export$c0bcc9250309d66; });
$parcel$export($621ce590ec883292$exports, "hasStandardBrowserWebWorkerEnv", function () { return $621ce590ec883292$export$c81692cf5af97dac; });
$parcel$export($621ce590ec883292$exports, "origin", function () { return $621ce590ec883292$export$f710a83a91838a36; });
const $621ce590ec883292$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $621ce590ec883292$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $621ce590ec883292$export$c0bcc9250309d66 = $621ce590ec883292$export$c4996c4b7b93b0bf && (!$621ce590ec883292$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($621ce590ec883292$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $621ce590ec883292$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $621ce590ec883292$export$f710a83a91838a36 = $621ce590ec883292$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $67d427cf79672094$export$2e2bcd8739ae039 = {
    ...$621ce590ec883292$exports,
    ...(0, $f02793a5b833a13d$export$2e2bcd8739ae039)
};


'use strict';
function $9b211a9aeac82933$export$2e2bcd8739ae039(data, options) {
    return (0, $d4971b3b43de0c5e$export$2e2bcd8739ae039)(data, new (0, $67d427cf79672094$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $67d427cf79672094$export$2e2bcd8739ae039).isNode && (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $d7335ca17b44849d$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $d7335ca17b44849d$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $d7335ca17b44849d$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $d7335ca17b44849d$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isFormData(formData) && (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($d7335ca17b44849d$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $d7335ca17b44849d$export$2e2bcd8739ae039 = $d7335ca17b44849d$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $2fad963dbc8397a4$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $2fad963dbc8397a4$var$defaults = {
    transitional: (0, $6e8be51f4c202714$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $d7335ca17b44849d$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isBuffer(data) || (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isStream(data) || (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isFile(data) || (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isBlob(data) || (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $9b211a9aeac82933$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $d4971b3b43de0c5e$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $2fad963dbc8397a4$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $2fad963dbc8397a4$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isResponse(data) || (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039).from(e, (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $67d427cf79672094$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $67d427cf79672094$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $2fad963dbc8397a4$var$defaults.headers[method] = {};
});
var $2fad963dbc8397a4$export$2e2bcd8739ae039 = $2fad963dbc8397a4$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $cb041d9f5649d584$var$ignoreDuplicateOf = (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $cb041d9f5649d584$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $cb041d9f5649d584$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $4317b0e28aa66150$var$$internals = Symbol('internals');
function $4317b0e28aa66150$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $4317b0e28aa66150$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isArray(value) ? value.map($4317b0e28aa66150$var$normalizeValue) : String(value);
}
function $4317b0e28aa66150$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $4317b0e28aa66150$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $4317b0e28aa66150$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $4317b0e28aa66150$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $4317b0e28aa66150$var$buildAccessors(obj, header) {
    const accessorName = (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $4317b0e28aa66150$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $4317b0e28aa66150$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $4317b0e28aa66150$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$4317b0e28aa66150$var$isValidHeaderName(header)) setHeaders((0, $cb041d9f5649d584$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isObject(header) && (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $4317b0e28aa66150$var$normalizeHeader(header);
        if (header) {
            const key = (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $4317b0e28aa66150$var$parseTokens(value);
                if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $4317b0e28aa66150$var$normalizeHeader(header);
        if (header) {
            const key = (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $4317b0e28aa66150$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $4317b0e28aa66150$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $4317b0e28aa66150$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $4317b0e28aa66150$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $4317b0e28aa66150$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $4317b0e28aa66150$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $4317b0e28aa66150$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$4317b0e28aa66150$var$$internals] = this[$4317b0e28aa66150$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $4317b0e28aa66150$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $4317b0e28aa66150$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$4317b0e28aa66150$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).reduceDescriptors($4317b0e28aa66150$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).freezeMethods($4317b0e28aa66150$var$AxiosHeaders);
var $4317b0e28aa66150$export$2e2bcd8739ae039 = $4317b0e28aa66150$var$AxiosHeaders;


'use strict';
function $32c83eaa9c10994c$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $2fad963dbc8397a4$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $4317b0e28aa66150$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $1b9de5d24a483fe4$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $808f1e75a3f7dbe3$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).inherits($808f1e75a3f7dbe3$var$CanceledError, (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $808f1e75a3f7dbe3$export$2e2bcd8739ae039 = $808f1e75a3f7dbe3$var$CanceledError;







'use strict';
function $f4198aeb2c23ec5f$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $1631ceda46144ed9$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $70dfad11aa6e60af$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $70dfad11aa6e60af$export$2e2bcd8739ae039 = $70dfad11aa6e60af$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $8ab12f02d9357f89$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $8ab12f02d9357f89$export$2e2bcd8739ae039 = $8ab12f02d9357f89$var$throttle;



const $dc35769843ae4abf$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $70dfad11aa6e60af$export$2e2bcd8739ae039)(50, 250);
    return (0, $8ab12f02d9357f89$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $dc35769843ae4abf$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $dc35769843ae4abf$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $5c367faf79b4b42c$export$2e2bcd8739ae039 = (0, $67d427cf79672094$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $67d427cf79672094$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $67d427cf79672094$export$2e2bcd8739ae039).origin), (0, $67d427cf79672094$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $67d427cf79672094$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $7a483335f8fea03e$export$2e2bcd8739ae039 = (0, $67d427cf79672094$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isString(path) && cookie.push('path=' + path);
        (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $d4f637265aaeaf5b$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $c482b5456a20e183$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $517d63c1c7282f35$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $d4f637265aaeaf5b$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $c482b5456a20e183$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $4fac6de9639ddda3$var$headersToObject = (thing)=>thing instanceof (0, $4317b0e28aa66150$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $4fac6de9639ddda3$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isPlainObject(target) && (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($4fac6de9639ddda3$var$headersToObject(a), $4fac6de9639ddda3$var$headersToObject(b), prop, true)
    };
    (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $a121688ecfb5348b$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $4fac6de9639ddda3$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $4317b0e28aa66150$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $34e298963efbc70a$export$2e2bcd8739ae039)((0, $517d63c1c7282f35$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $67d427cf79672094$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $67d427cf79672094$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $67d427cf79672094$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $5c367faf79b4b42c$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $7a483335f8fea03e$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $795e35fcb2940886$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $795e35fcb2940886$export$2e2bcd8739ae039 = $795e35fcb2940886$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $a121688ecfb5348b$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $4317b0e28aa66150$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $4317b0e28aa66150$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $f4198aeb2c23ec5f$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039)('Request aborted', (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039)('Network Error', (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $6e8be51f4c202714$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039).ETIMEDOUT : (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $dc35769843ae4abf$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $dc35769843ae4abf$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $808f1e75a3f7dbe3$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $1631ceda46144ed9$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $67d427cf79672094$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $60bc203449f2bc94$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039) ? err : new (0, $808f1e75a3f7dbe3$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $60bc203449f2bc94$export$2e2bcd8739ae039 = $60bc203449f2bc94$var$composeSignals;


const $4716bdbe211900e4$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $4716bdbe211900e4$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $4716bdbe211900e4$var$readStream(iterable))yield* $4716bdbe211900e4$export$71b051935044bd5d(chunk, chunkSize);
};
const $4716bdbe211900e4$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $4716bdbe211900e4$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $4716bdbe211900e4$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $d53d5a402fbdafab$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const $d53d5a402fbdafab$var$isReadableStreamSupported = $d53d5a402fbdafab$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const $d53d5a402fbdafab$var$encodeText = $d53d5a402fbdafab$var$isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $d53d5a402fbdafab$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $d53d5a402fbdafab$var$supportsRequestStream = $d53d5a402fbdafab$var$isReadableStreamSupported && $d53d5a402fbdafab$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $67d427cf79672094$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const $d53d5a402fbdafab$var$DEFAULT_CHUNK_SIZE = 65536;
const $d53d5a402fbdafab$var$supportsResponseStream = $d53d5a402fbdafab$var$isReadableStreamSupported && $d53d5a402fbdafab$var$test(()=>(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
const $d53d5a402fbdafab$var$resolvers = {
    stream: $d53d5a402fbdafab$var$supportsResponseStream && ((res)=>res.body)
};
$d53d5a402fbdafab$var$isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !$d53d5a402fbdafab$var$resolvers[type] && ($d53d5a402fbdafab$var$resolvers[type] = (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $d53d5a402fbdafab$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $67d427cf79672094$export$2e2bcd8739ae039).origin, {
            method: 'POST',
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
    if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isString(body)) return (await $d53d5a402fbdafab$var$encodeText(body)).byteLength;
};
const $d53d5a402fbdafab$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $d53d5a402fbdafab$var$getBodyLength(body) : length;
};
var $d53d5a402fbdafab$export$2e2bcd8739ae039 = $d53d5a402fbdafab$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $a121688ecfb5348b$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, $60bc203449f2bc94$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $d53d5a402fbdafab$var$supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await $d53d5a402fbdafab$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $dc35769843ae4abf$export$d9fadd12586c18d6)(requestContentLength, (0, $dc35769843ae4abf$export$c1b28109d46c3592)((0, $dc35769843ae4abf$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $4716bdbe211900e4$export$b0119225647bd83)(_request.body, $d53d5a402fbdafab$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $d53d5a402fbdafab$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if ($d53d5a402fbdafab$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, $dc35769843ae4abf$export$d9fadd12586c18d6)(responseContentLength, (0, $dc35769843ae4abf$export$c1b28109d46c3592)((0, $dc35769843ae4abf$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $4716bdbe211900e4$export$b0119225647bd83)(response.body, $d53d5a402fbdafab$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await $d53d5a402fbdafab$var$resolvers[(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).findKey($d53d5a402fbdafab$var$resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $f4198aeb2c23ec5f$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $4317b0e28aa66150$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039)('Network Error', (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $e924fb7052632768$var$knownAdapters = {
    http: (0, $77c5c5d1798bbe47$export$2e2bcd8739ae039),
    xhr: (0, $795e35fcb2940886$export$2e2bcd8739ae039),
    fetch: (0, $d53d5a402fbdafab$export$2e2bcd8739ae039)
};
(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).forEach($e924fb7052632768$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $e924fb7052632768$var$renderReason = (reason)=>`- ${reason}`;
const $e924fb7052632768$var$isResolvedHandle = (adapter)=>(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $e924fb7052632768$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$e924fb7052632768$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $e924fb7052632768$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($e924fb7052632768$var$renderReason).join('\n') : ' ' + $e924fb7052632768$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $e924fb7052632768$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $57be05c35a22af09$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $808f1e75a3f7dbe3$export$2e2bcd8739ae039)(null, config);
}
function $57be05c35a22af09$export$2e2bcd8739ae039(config) {
    $57be05c35a22af09$var$throwIfCancellationRequested(config);
    config.headers = (0, $4317b0e28aa66150$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $32c83eaa9c10994c$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $e924fb7052632768$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $2fad963dbc8397a4$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $57be05c35a22af09$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $32c83eaa9c10994c$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $4317b0e28aa66150$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $1b9de5d24a483fe4$export$2e2bcd8739ae039)(reason)) {
            $57be05c35a22af09$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $32c83eaa9c10994c$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $4317b0e28aa66150$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $6e2aae26750d4b0c$export$a4ad2735b021c132 = "1.9.0";



'use strict';
const $f707b115465f8657$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $f707b115465f8657$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $f707b115465f8657$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $f707b115465f8657$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $6e2aae26750d4b0c$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$f707b115465f8657$var$deprecatedWarnings[opt]) {
            $f707b115465f8657$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$f707b115465f8657$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $f707b115465f8657$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039)('options must be an object', (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $f707b115465f8657$export$2e2bcd8739ae039 = {
    assertOptions: $f707b115465f8657$var$assertOptions,
    validators: $f707b115465f8657$var$validators
};



'use strict';
const $2b17d3e592876718$var$validators = (0, $f707b115465f8657$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $2b17d3e592876718$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $ed43ea8051e3c504$export$2e2bcd8739ae039)(),
            response: new (0, $ed43ea8051e3c504$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $4fac6de9639ddda3$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $f707b115465f8657$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $2b17d3e592876718$var$validators.transitional($2b17d3e592876718$var$validators.boolean),
            forcedJSONParsing: $2b17d3e592876718$var$validators.transitional($2b17d3e592876718$var$validators.boolean),
            clarifyTimeoutError: $2b17d3e592876718$var$validators.transitional($2b17d3e592876718$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $f707b115465f8657$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $2b17d3e592876718$var$validators.function,
                serialize: $2b17d3e592876718$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $f707b115465f8657$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $2b17d3e592876718$var$validators.spelling('baseURL'),
            withXsrfToken: $2b17d3e592876718$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $4317b0e28aa66150$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $57be05c35a22af09$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $57be05c35a22af09$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $4fac6de9639ddda3$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $517d63c1c7282f35$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $34e298963efbc70a$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $2b17d3e592876718$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $4fac6de9639ddda3$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $4fac6de9639ddda3$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $2b17d3e592876718$var$Axios.prototype[method] = generateHTTPMethod();
    $2b17d3e592876718$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $2b17d3e592876718$export$2e2bcd8739ae039 = $2b17d3e592876718$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $11ad3cb5da65cbe1$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $808f1e75a3f7dbe3$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $11ad3cb5da65cbe1$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $11ad3cb5da65cbe1$export$2e2bcd8739ae039 = $11ad3cb5da65cbe1$var$CancelToken;






'use strict';
function $9c396f84e83e3d2c$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $6ad8f649dce1a3e2$export$2e2bcd8739ae039(payload) {
    return (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $2350b91217483157$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($2350b91217483157$var$HttpStatusCode).forEach(([key, value])=>{
    $2350b91217483157$var$HttpStatusCode[value] = key;
});
var $2350b91217483157$export$2e2bcd8739ae039 = $2350b91217483157$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $040e0e9a6d6c1341$var$createInstance(defaultConfig) {
    const context = new (0, $2b17d3e592876718$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $50bf470c4f6c40fc$export$2e2bcd8739ae039)((0, $2b17d3e592876718$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).extend(instance, (0, $2b17d3e592876718$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $040e0e9a6d6c1341$var$createInstance((0, $4fac6de9639ddda3$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $040e0e9a6d6c1341$var$axios = $040e0e9a6d6c1341$var$createInstance((0, $2fad963dbc8397a4$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$040e0e9a6d6c1341$var$axios.Axios = (0, $2b17d3e592876718$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$040e0e9a6d6c1341$var$axios.CanceledError = (0, $808f1e75a3f7dbe3$export$2e2bcd8739ae039);
$040e0e9a6d6c1341$var$axios.CancelToken = (0, $11ad3cb5da65cbe1$export$2e2bcd8739ae039);
$040e0e9a6d6c1341$var$axios.isCancel = (0, $1b9de5d24a483fe4$export$2e2bcd8739ae039);
$040e0e9a6d6c1341$var$axios.VERSION = (0, $6e2aae26750d4b0c$export$a4ad2735b021c132);
$040e0e9a6d6c1341$var$axios.toFormData = (0, $d4971b3b43de0c5e$export$2e2bcd8739ae039);
// Expose AxiosError class
$040e0e9a6d6c1341$var$axios.AxiosError = (0, $2dd5fba2ea5eebbf$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$040e0e9a6d6c1341$var$axios.Cancel = $040e0e9a6d6c1341$var$axios.CanceledError;
// Expose all/spread
$040e0e9a6d6c1341$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$040e0e9a6d6c1341$var$axios.spread = (0, $9c396f84e83e3d2c$export$2e2bcd8739ae039);
// Expose isAxiosError
$040e0e9a6d6c1341$var$axios.isAxiosError = (0, $6ad8f649dce1a3e2$export$2e2bcd8739ae039);
// Expose mergeConfig
$040e0e9a6d6c1341$var$axios.mergeConfig = (0, $4fac6de9639ddda3$export$2e2bcd8739ae039);
$040e0e9a6d6c1341$var$axios.AxiosHeaders = (0, $4317b0e28aa66150$export$2e2bcd8739ae039);
$040e0e9a6d6c1341$var$axios.formToJSON = (thing)=>(0, $d7335ca17b44849d$export$2e2bcd8739ae039)((0, $4149b3c0d0254d8f$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$040e0e9a6d6c1341$var$axios.getAdapter = (0, $e924fb7052632768$export$2e2bcd8739ae039).getAdapter;
$040e0e9a6d6c1341$var$axios.HttpStatusCode = (0, $2350b91217483157$export$2e2bcd8739ae039);
$040e0e9a6d6c1341$var$axios.default = $040e0e9a6d6c1341$var$axios;
var // this module should only have a default export
$040e0e9a6d6c1341$export$2e2bcd8739ae039 = $040e0e9a6d6c1341$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $cc5d4790c8bde7bc$export$1c00760e9e5a4e95, AxiosError: $cc5d4790c8bde7bc$export$c1fbed17c2f6a328, CanceledError: $cc5d4790c8bde7bc$export$1ab0c6b20d94fa14, isCancel: $cc5d4790c8bde7bc$export$3b22524397b493c6, CancelToken: $cc5d4790c8bde7bc$export$fd08e3cb425f0d61, VERSION: $cc5d4790c8bde7bc$export$a4ad2735b021c132, all: $cc5d4790c8bde7bc$export$84bf76cd7afc7469, Cancel: $cc5d4790c8bde7bc$export$848c9b7ead0df967, isAxiosError: $cc5d4790c8bde7bc$export$fbafdbe06a5b5a9a, spread: $cc5d4790c8bde7bc$export$3ae0fd4797ed47c8, toFormData: $cc5d4790c8bde7bc$export$10ae0d317ea97f8b, AxiosHeaders: $cc5d4790c8bde7bc$export$4e7d6ff0f3e6520, HttpStatusCode: $cc5d4790c8bde7bc$export$a972f69c851492b3, formToJSON: $cc5d4790c8bde7bc$export$86d7c59254d6a2c9, getAdapter: $cc5d4790c8bde7bc$export$17ddc20a97d669e2, mergeConfig: $cc5d4790c8bde7bc$export$7ec1ebcfa9d8bd6a } = (0, $040e0e9a6d6c1341$export$2e2bcd8739ae039);


/* eslint-disable */ 
/* eslint-disable */ const $2606f95105a1350e$export$516836c6a9dfc573 = ()=>{
    const el = document.querySelector('.alert');
    if (el) el.parentElement.removeChild(el);
};
const $2606f95105a1350e$export$de026b00723010c1 = (type, msg)=>{
    $2606f95105a1350e$export$516836c6a9dfc573();
    const markup = `<div class="alert alert--${type}">${msg}</div>`;
    document.querySelector('body').insertAdjacentHTML('afterbegin', markup);
    window.setTimeout($2606f95105a1350e$export$516836c6a9dfc573, 5000);
};


const $cd3113bade57e75e$export$596d806903d1f59e = async (email, password)=>{
    try {
        const res = await (0, $040e0e9a6d6c1341$export$2e2bcd8739ae039)({
            method: 'POST',
            url: '/api/users/login',
            data: {
                email: email,
                password: password
            },
            withCredentials: true
        });
        if (res.data.status === 'success') {
            (0, $2606f95105a1350e$export$de026b00723010c1)('success', 'Logged in succesfully!');
            window.setTimeout(()=>{
                location.assign('/');
            }, 1500);
        }
    } catch (err) {
        (0, $2606f95105a1350e$export$de026b00723010c1)('error', err.response.data.message);
    }
};
const $cd3113bade57e75e$export$a0973bcfe11b05c9 = async ()=>{
    try {
        const res = await (0, $040e0e9a6d6c1341$export$2e2bcd8739ae039)({
            method: 'GET',
            url: '/api/users/logout'
        });
        res.data.status = 'success';
        //reload from server
        location.assign('/');
    } catch (err) {
        console.log(err);
        (0, $2606f95105a1350e$export$de026b00723010c1)('error', 'Error logging out! Try again.');
    }
};


/* eslint-disable */ 

const $9d6115ff614a714d$export$f558026a994b6051 = async (data, type)=>{
    try {
        const url = type === 'password' ? '/api/users/updateMyPassword' : '/api/users/updateMe';
        const res = await (0, $040e0e9a6d6c1341$export$2e2bcd8739ae039)({
            method: 'PATCH',
            url: url,
            data: data
        });
        if (res.data.status === 'success') (0, $2606f95105a1350e$export$de026b00723010c1)('success', `${type.toUpperCase()} updated successfully!`);
    } catch (err) {
        (0, $2606f95105a1350e$export$de026b00723010c1)('error', err.response.data.message);
    }
};


/* eslint-disable */ 
function $838803f8bd34dfa1$export$2e2bcd8739ae039(x) {
    return x;
}


var $d85dbadc51fe476f$var$top = 1, $d85dbadc51fe476f$var$right = 2, $d85dbadc51fe476f$var$bottom = 3, $d85dbadc51fe476f$var$left = 4, $d85dbadc51fe476f$var$epsilon = 1e-6;
function $d85dbadc51fe476f$var$translateX(x) {
    return "translate(" + x + ",0)";
}
function $d85dbadc51fe476f$var$translateY(y) {
    return "translate(0," + y + ")";
}
function $d85dbadc51fe476f$var$number(scale) {
    return (d)=>+scale(d);
}
function $d85dbadc51fe476f$var$center(scale, offset) {
    offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
    if (scale.round()) offset = Math.round(offset);
    return (d)=>+scale(d) + offset;
}
function $d85dbadc51fe476f$var$entering() {
    return !this.__axis;
}
function $d85dbadc51fe476f$var$axis(orient, scale) {
    var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k = orient === $d85dbadc51fe476f$var$top || orient === $d85dbadc51fe476f$var$left ? -1 : 1, x = orient === $d85dbadc51fe476f$var$left || orient === $d85dbadc51fe476f$var$right ? "x" : "y", transform = orient === $d85dbadc51fe476f$var$top || orient === $d85dbadc51fe476f$var$bottom ? $d85dbadc51fe476f$var$translateX : $d85dbadc51fe476f$var$translateY;
    function axis(context) {
        var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : (0, $838803f8bd34dfa1$export$2e2bcd8739ae039) : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + offset, range1 = +range[range.length - 1] + offset, position = (scale.bandwidth ? $d85dbadc51fe476f$var$center : $d85dbadc51fe476f$var$number)(scale.copy(), offset), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
            null
        ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
        path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
        tick = tick.merge(tickEnter);
        line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
        text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === $d85dbadc51fe476f$var$top ? "0em" : orient === $d85dbadc51fe476f$var$bottom ? "0.71em" : "0.32em"));
        if (context !== selection) {
            path = path.transition(context);
            tick = tick.transition(context);
            line = line.transition(context);
            text = text.transition(context);
            tickExit = tickExit.transition(context).attr("opacity", $d85dbadc51fe476f$var$epsilon).attr("transform", function(d) {
                return isFinite(d = position(d)) ? transform(d + offset) : this.getAttribute("transform");
            });
            tickEnter.attr("opacity", $d85dbadc51fe476f$var$epsilon).attr("transform", function(d) {
                var p = this.parentNode.__axis;
                return transform((p && isFinite(p = p(d)) ? p : position(d)) + offset);
            });
        }
        tickExit.remove();
        path.attr("d", orient === $d85dbadc51fe476f$var$left || orient === $d85dbadc51fe476f$var$right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1);
        tick.attr("opacity", 1).attr("transform", function(d) {
            return transform(position(d) + offset);
        });
        line.attr(x + "2", k * tickSizeInner);
        text.attr(x, k * spacing).text(format);
        selection.filter($d85dbadc51fe476f$var$entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === $d85dbadc51fe476f$var$right ? "start" : orient === $d85dbadc51fe476f$var$left ? "end" : "middle");
        selection.each(function() {
            this.__axis = position;
        });
    }
    axis.scale = function(_) {
        return arguments.length ? (scale = _, axis) : scale;
    };
    axis.ticks = function() {
        return tickArguments = Array.from(arguments), axis;
    };
    axis.tickArguments = function(_) {
        return arguments.length ? (tickArguments = _ == null ? [] : Array.from(_), axis) : tickArguments.slice();
    };
    axis.tickValues = function(_) {
        return arguments.length ? (tickValues = _ == null ? null : Array.from(_), axis) : tickValues && tickValues.slice();
    };
    axis.tickFormat = function(_) {
        return arguments.length ? (tickFormat = _, axis) : tickFormat;
    };
    axis.tickSize = function(_) {
        return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
    };
    axis.tickSizeInner = function(_) {
        return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
    };
    axis.tickSizeOuter = function(_) {
        return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
    };
    axis.tickPadding = function(_) {
        return arguments.length ? (tickPadding = +_, axis) : tickPadding;
    };
    axis.offset = function(_) {
        return arguments.length ? (offset = +_, axis) : offset;
    };
    return axis;
}
function $d85dbadc51fe476f$export$59b8cfab074bdeb1(scale) {
    return $d85dbadc51fe476f$var$axis($d85dbadc51fe476f$var$top, scale);
}
function $d85dbadc51fe476f$export$b0d2e24dc4f898f0(scale) {
    return $d85dbadc51fe476f$var$axis($d85dbadc51fe476f$var$right, scale);
}
function $d85dbadc51fe476f$export$e5cb22533a15e72e(scale) {
    return $d85dbadc51fe476f$var$axis($d85dbadc51fe476f$var$bottom, scale);
}
function $d85dbadc51fe476f$export$2749afb169a520d2(scale) {
    return $d85dbadc51fe476f$var$axis($d85dbadc51fe476f$var$left, scale);
}


var $cb0cee1ac6170bcd$var$noop = {
    value: ()=>{}
};
function $cb0cee1ac6170bcd$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $cb0cee1ac6170bcd$var$Dispatch(_);
}
function $cb0cee1ac6170bcd$var$Dispatch(_) {
    this._ = _;
}
function $cb0cee1ac6170bcd$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$cb0cee1ac6170bcd$var$Dispatch.prototype = $cb0cee1ac6170bcd$var$dispatch.prototype = {
    constructor: $cb0cee1ac6170bcd$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $cb0cee1ac6170bcd$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $cb0cee1ac6170bcd$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $cb0cee1ac6170bcd$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $cb0cee1ac6170bcd$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $cb0cee1ac6170bcd$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $cb0cee1ac6170bcd$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $cb0cee1ac6170bcd$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $cb0cee1ac6170bcd$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $cb0cee1ac6170bcd$export$2e2bcd8739ae039 = $cb0cee1ac6170bcd$var$dispatch;



function $80e330374f930727$var$none() {}
function $80e330374f930727$export$2e2bcd8739ae039(selector) {
    return selector == null ? $80e330374f930727$var$none : function() {
        return this.querySelector(selector);
    };
}


function $5166fae632d5fc4e$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $80e330374f930727$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $05a287e75fbd2bd2$export$52baac22726c72bf)(subgroups, this._parents);
}



// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
function $43b8b08c1b47c9a3$export$2e2bcd8739ae039(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}


function $21b24c1979918eec$var$empty() {
    return [];
}
function $21b24c1979918eec$export$2e2bcd8739ae039(selector) {
    return selector == null ? $21b24c1979918eec$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}


function $212ae40103770903$var$arrayAll(select) {
    return function() {
        return (0, $43b8b08c1b47c9a3$export$2e2bcd8739ae039)(select.apply(this, arguments));
    };
}
function $212ae40103770903$export$2e2bcd8739ae039(select) {
    if (typeof select === "function") select = $212ae40103770903$var$arrayAll(select);
    else select = (0, $21b24c1979918eec$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $05a287e75fbd2bd2$export$52baac22726c72bf)(subgroups, parents);
}


function $454fddaf82fd4237$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}
function $454fddaf82fd4237$export$90c2759c036528(selector) {
    return function(node) {
        return node.matches(selector);
    };
}


var $190cae6221063e09$var$find = Array.prototype.find;
function $190cae6221063e09$var$childFind(match) {
    return function() {
        return $190cae6221063e09$var$find.call(this.children, match);
    };
}
function $190cae6221063e09$var$childFirst() {
    return this.firstElementChild;
}
function $190cae6221063e09$export$2e2bcd8739ae039(match) {
    return this.select(match == null ? $190cae6221063e09$var$childFirst : $190cae6221063e09$var$childFind(typeof match === "function" ? match : (0, $454fddaf82fd4237$export$90c2759c036528)(match)));
}



var $ee7a2493d8f45b66$var$filter = Array.prototype.filter;
function $ee7a2493d8f45b66$var$children() {
    return Array.from(this.children);
}
function $ee7a2493d8f45b66$var$childrenFilter(match) {
    return function() {
        return $ee7a2493d8f45b66$var$filter.call(this.children, match);
    };
}
function $ee7a2493d8f45b66$export$2e2bcd8739ae039(match) {
    return this.selectAll(match == null ? $ee7a2493d8f45b66$var$children : $ee7a2493d8f45b66$var$childrenFilter(typeof match === "function" ? match : (0, $454fddaf82fd4237$export$90c2759c036528)(match)));
}




function $c01107c7b592419d$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $454fddaf82fd4237$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $05a287e75fbd2bd2$export$52baac22726c72bf)(subgroups, this._parents);
}



function $55961d2fc9f5c903$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}



function $21267f317e3fceb6$export$2e2bcd8739ae039() {
    return new (0, $05a287e75fbd2bd2$export$52baac22726c72bf)(this._enter || this._groups.map((0, $55961d2fc9f5c903$export$2e2bcd8739ae039)), this._parents);
}
function $21267f317e3fceb6$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$21267f317e3fceb6$export$67b01759a14cf6a4.prototype = {
    constructor: $21267f317e3fceb6$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};


function $aa40204e17e06679$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $41f2e8994d375671$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $21267f317e3fceb6$export$67b01759a14cf6a4)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $41f2e8994d375671$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, $21267f317e3fceb6$export$67b01759a14cf6a4)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function $41f2e8994d375671$var$datum(node) {
    return node.__data__;
}
function $41f2e8994d375671$export$2e2bcd8739ae039(value, key) {
    if (!arguments.length) return Array.from(this, $41f2e8994d375671$var$datum);
    var bind = key ? $41f2e8994d375671$var$bindKey : $41f2e8994d375671$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $aa40204e17e06679$export$2e2bcd8739ae039)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = $41f2e8994d375671$var$arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $05a287e75fbd2bd2$export$52baac22726c72bf)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function $41f2e8994d375671$var$arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}





function $c02012161b255b40$export$2e2bcd8739ae039() {
    return new (0, $05a287e75fbd2bd2$export$52baac22726c72bf)(this._exit || this._groups.map((0, $55961d2fc9f5c903$export$2e2bcd8739ae039)), this._parents);
}


function $aa5d80b1ca4c47f0$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    if (typeof onenter === "function") {
        enter = onenter(enter);
        if (enter) enter = enter.selection();
    } else enter = enter.append(onenter + "");
    if (onupdate != null) {
        update = onupdate(update);
        if (update) update = update.selection();
    }
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}



function $14b361c17480e9b5$export$2e2bcd8739ae039(context) {
    var selection = context.selection ? context.selection() : context;
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $05a287e75fbd2bd2$export$52baac22726c72bf)(merges, this._parents);
}


function $45b34cc4ecb704a3$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}



function $e2b9342310df997e$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $e2b9342310df997e$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $05a287e75fbd2bd2$export$52baac22726c72bf)(sortgroups, this._parents).order();
}
function $e2b9342310df997e$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $b7bd0d41c8b3609f$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}


function $27c7e132860ed755$export$2e2bcd8739ae039() {
    return Array.from(this);
}


function $61c6de2d29e942fc$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}


function $84b2a69b6dc214fb$export$2e2bcd8739ae039() {
    let size = 0;
    for (const node of this)++size; // eslint-disable-line no-unused-vars
    return size;
}


function $b53b540184038278$export$2e2bcd8739ae039() {
    return !this.node();
}


function $834fc93e80d33475$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}


var $fa80c3a608382725$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $fa80c3a608382725$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $fa80c3a608382725$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};


function $f718483478e35f10$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $fa80c3a608382725$export$2e2bcd8739ae039).hasOwnProperty(prefix) ? {
        space: (0, $fa80c3a608382725$export$2e2bcd8739ae039)[prefix],
        local: name
    } : name; // eslint-disable-line no-prototype-builtins
}


function $b8e9ee1601f3bd4d$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $b8e9ee1601f3bd4d$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $b8e9ee1601f3bd4d$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $b8e9ee1601f3bd4d$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $b8e9ee1601f3bd4d$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $b8e9ee1601f3bd4d$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $b8e9ee1601f3bd4d$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $f718483478e35f10$export$2e2bcd8739ae039)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $b8e9ee1601f3bd4d$var$attrRemoveNS : $b8e9ee1601f3bd4d$var$attrRemove : typeof value === "function" ? fullname.local ? $b8e9ee1601f3bd4d$var$attrFunctionNS : $b8e9ee1601f3bd4d$var$attrFunction : fullname.local ? $b8e9ee1601f3bd4d$var$attrConstantNS : $b8e9ee1601f3bd4d$var$attrConstant)(fullname, value));
}


function $bf65b9e2f15d3469$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}


function $b7816f432860dac6$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $b7816f432860dac6$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $b7816f432860dac6$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $b7816f432860dac6$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $b7816f432860dac6$var$styleRemove : typeof value === "function" ? $b7816f432860dac6$var$styleFunction : $b7816f432860dac6$var$styleConstant)(name, value, priority == null ? "" : priority)) : $b7816f432860dac6$export$5e3cec964f0b5efd(this.node(), name);
}
function $b7816f432860dac6$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $bf65b9e2f15d3469$export$2e2bcd8739ae039)(node).getComputedStyle(node, null).getPropertyValue(name);
}


function $dd1f9a271f12ed4f$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $dd1f9a271f12ed4f$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $dd1f9a271f12ed4f$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $dd1f9a271f12ed4f$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $dd1f9a271f12ed4f$var$propertyRemove : typeof value === "function" ? $dd1f9a271f12ed4f$var$propertyFunction : $dd1f9a271f12ed4f$var$propertyConstant)(name, value)) : this.node()[name];
}


function $eb16fe4b2cff03e1$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $eb16fe4b2cff03e1$var$classList(node) {
    return node.classList || new $eb16fe4b2cff03e1$var$ClassList(node);
}
function $eb16fe4b2cff03e1$var$ClassList(node) {
    this._node = node;
    this._names = $eb16fe4b2cff03e1$var$classArray(node.getAttribute("class") || "");
}
$eb16fe4b2cff03e1$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $eb16fe4b2cff03e1$var$classedAdd(node, names) {
    var list = $eb16fe4b2cff03e1$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $eb16fe4b2cff03e1$var$classedRemove(node, names) {
    var list = $eb16fe4b2cff03e1$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $eb16fe4b2cff03e1$var$classedTrue(names) {
    return function() {
        $eb16fe4b2cff03e1$var$classedAdd(this, names);
    };
}
function $eb16fe4b2cff03e1$var$classedFalse(names) {
    return function() {
        $eb16fe4b2cff03e1$var$classedRemove(this, names);
    };
}
function $eb16fe4b2cff03e1$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $eb16fe4b2cff03e1$var$classedAdd : $eb16fe4b2cff03e1$var$classedRemove)(this, names);
    };
}
function $eb16fe4b2cff03e1$export$2e2bcd8739ae039(name, value) {
    var names = $eb16fe4b2cff03e1$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $eb16fe4b2cff03e1$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $eb16fe4b2cff03e1$var$classedFunction : value ? $eb16fe4b2cff03e1$var$classedTrue : $eb16fe4b2cff03e1$var$classedFalse)(names, value));
}


function $5ed3d842bcc524bf$var$textRemove() {
    this.textContent = "";
}
function $5ed3d842bcc524bf$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $5ed3d842bcc524bf$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $5ed3d842bcc524bf$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $5ed3d842bcc524bf$var$textRemove : (typeof value === "function" ? $5ed3d842bcc524bf$var$textFunction : $5ed3d842bcc524bf$var$textConstant)(value)) : this.node().textContent;
}


function $c3580e5ba877e5d3$var$htmlRemove() {
    this.innerHTML = "";
}
function $c3580e5ba877e5d3$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $c3580e5ba877e5d3$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $c3580e5ba877e5d3$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $c3580e5ba877e5d3$var$htmlRemove : (typeof value === "function" ? $c3580e5ba877e5d3$var$htmlFunction : $c3580e5ba877e5d3$var$htmlConstant)(value)) : this.node().innerHTML;
}


function $fc05bedbf9ae517c$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $fc05bedbf9ae517c$export$2e2bcd8739ae039() {
    return this.each($fc05bedbf9ae517c$var$raise);
}


function $78b88104053f2700$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $78b88104053f2700$export$2e2bcd8739ae039() {
    return this.each($78b88104053f2700$var$lower);
}




function $f8c4fc7f150952c6$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $fa80c3a608382725$export$201a3f7520ccc326) && document.documentElement.namespaceURI === (0, $fa80c3a608382725$export$201a3f7520ccc326) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $f8c4fc7f150952c6$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $f8c4fc7f150952c6$export$2e2bcd8739ae039(name) {
    var fullname = (0, $f718483478e35f10$export$2e2bcd8739ae039)(name);
    return (fullname.local ? $f8c4fc7f150952c6$var$creatorFixed : $f8c4fc7f150952c6$var$creatorInherit)(fullname);
}


function $51b18158bba8710f$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $f8c4fc7f150952c6$export$2e2bcd8739ae039)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}




function $b84d373f979b8870$var$constantNull() {
    return null;
}
function $b84d373f979b8870$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $f8c4fc7f150952c6$export$2e2bcd8739ae039)(name), select = before == null ? $b84d373f979b8870$var$constantNull : typeof before === "function" ? before : (0, $80e330374f930727$export$2e2bcd8739ae039)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}


function $759daa53d80657fe$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $759daa53d80657fe$export$2e2bcd8739ae039() {
    return this.each($759daa53d80657fe$var$remove);
}


function $0492b8ae610a6e44$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $0492b8ae610a6e44$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $0492b8ae610a6e44$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $0492b8ae610a6e44$var$selection_cloneDeep : $0492b8ae610a6e44$var$selection_cloneShallow);
}


function $ce17aa0f45554bb1$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}


function $481c0910d7f20f34$var$contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function $481c0910d7f20f34$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $481c0910d7f20f34$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $481c0910d7f20f34$var$onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = $481c0910d7f20f34$var$contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $481c0910d7f20f34$export$2e2bcd8739ae039(typename, value, options) {
    var typenames = $481c0910d7f20f34$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $481c0910d7f20f34$var$onAdd : $481c0910d7f20f34$var$onRemove;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
    return this;
}



function $3391c24e849e7c00$var$dispatchEvent(node, type, params) {
    var window = (0, $bf65b9e2f15d3469$export$2e2bcd8739ae039)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $3391c24e849e7c00$var$dispatchConstant(type, params) {
    return function() {
        return $3391c24e849e7c00$var$dispatchEvent(this, type, params);
    };
}
function $3391c24e849e7c00$var$dispatchFunction(type, params) {
    return function() {
        return $3391c24e849e7c00$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $3391c24e849e7c00$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $3391c24e849e7c00$var$dispatchFunction : $3391c24e849e7c00$var$dispatchConstant)(type, params));
}


function* $7a228babe1df8b15$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
    }
}


var $05a287e75fbd2bd2$export$e8e78c978b129247 = [
    null
];
function $05a287e75fbd2bd2$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $05a287e75fbd2bd2$var$selection() {
    return new $05a287e75fbd2bd2$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $05a287e75fbd2bd2$export$e8e78c978b129247);
}
function $05a287e75fbd2bd2$var$selection_selection() {
    return this;
}
$05a287e75fbd2bd2$export$52baac22726c72bf.prototype = $05a287e75fbd2bd2$var$selection.prototype = {
    constructor: $05a287e75fbd2bd2$export$52baac22726c72bf,
    select: (0, $5166fae632d5fc4e$export$2e2bcd8739ae039),
    selectAll: (0, $212ae40103770903$export$2e2bcd8739ae039),
    selectChild: (0, $190cae6221063e09$export$2e2bcd8739ae039),
    selectChildren: (0, $ee7a2493d8f45b66$export$2e2bcd8739ae039),
    filter: (0, $c01107c7b592419d$export$2e2bcd8739ae039),
    data: (0, $41f2e8994d375671$export$2e2bcd8739ae039),
    enter: (0, $21267f317e3fceb6$export$2e2bcd8739ae039),
    exit: (0, $c02012161b255b40$export$2e2bcd8739ae039),
    join: (0, $aa5d80b1ca4c47f0$export$2e2bcd8739ae039),
    merge: (0, $14b361c17480e9b5$export$2e2bcd8739ae039),
    selection: $05a287e75fbd2bd2$var$selection_selection,
    order: (0, $45b34cc4ecb704a3$export$2e2bcd8739ae039),
    sort: (0, $e2b9342310df997e$export$2e2bcd8739ae039),
    call: (0, $b7bd0d41c8b3609f$export$2e2bcd8739ae039),
    nodes: (0, $27c7e132860ed755$export$2e2bcd8739ae039),
    node: (0, $61c6de2d29e942fc$export$2e2bcd8739ae039),
    size: (0, $84b2a69b6dc214fb$export$2e2bcd8739ae039),
    empty: (0, $b53b540184038278$export$2e2bcd8739ae039),
    each: (0, $834fc93e80d33475$export$2e2bcd8739ae039),
    attr: (0, $b8e9ee1601f3bd4d$export$2e2bcd8739ae039),
    style: (0, $b7816f432860dac6$export$2e2bcd8739ae039),
    property: (0, $dd1f9a271f12ed4f$export$2e2bcd8739ae039),
    classed: (0, $eb16fe4b2cff03e1$export$2e2bcd8739ae039),
    text: (0, $5ed3d842bcc524bf$export$2e2bcd8739ae039),
    html: (0, $c3580e5ba877e5d3$export$2e2bcd8739ae039),
    raise: (0, $fc05bedbf9ae517c$export$2e2bcd8739ae039),
    lower: (0, $78b88104053f2700$export$2e2bcd8739ae039),
    append: (0, $51b18158bba8710f$export$2e2bcd8739ae039),
    insert: (0, $b84d373f979b8870$export$2e2bcd8739ae039),
    remove: (0, $759daa53d80657fe$export$2e2bcd8739ae039),
    clone: (0, $0492b8ae610a6e44$export$2e2bcd8739ae039),
    datum: (0, $ce17aa0f45554bb1$export$2e2bcd8739ae039),
    on: (0, $481c0910d7f20f34$export$2e2bcd8739ae039),
    dispatch: (0, $3391c24e849e7c00$export$2e2bcd8739ae039),
    [Symbol.iterator]: (0, $7a228babe1df8b15$export$2e2bcd8739ae039)
};
var $05a287e75fbd2bd2$export$2e2bcd8739ae039 = $05a287e75fbd2bd2$var$selection;


function $212a85cfc656869b$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $05a287e75fbd2bd2$export$52baac22726c72bf)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $05a287e75fbd2bd2$export$52baac22726c72bf)([
        [
            selector
        ]
    ], (0, $05a287e75fbd2bd2$export$e8e78c978b129247));
}


// These are typically used in conjunction with noevent to ensure that we can
// preventDefault on the event.
const $678ed3358e81e5bd$export$524615cd03e458cc = {
    passive: false
};
const $678ed3358e81e5bd$export$35431a0e47022de1 = {
    capture: true,
    passive: false
};
function $678ed3358e81e5bd$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $678ed3358e81e5bd$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


function $53c33dda764ea7c9$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $212a85cfc656869b$export$2e2bcd8739ae039)(view).on("dragstart.drag", (0, $678ed3358e81e5bd$export$2e2bcd8739ae039), (0, $678ed3358e81e5bd$export$35431a0e47022de1));
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $678ed3358e81e5bd$export$2e2bcd8739ae039), (0, $678ed3358e81e5bd$export$35431a0e47022de1));
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $53c33dda764ea7c9$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $212a85cfc656869b$export$2e2bcd8739ae039)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $678ed3358e81e5bd$export$2e2bcd8739ae039), (0, $678ed3358e81e5bd$export$35431a0e47022de1));
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}



var $hT5KM = parcelRequire("hT5KM");

var $hT5KM = parcelRequire("hT5KM");
function $973285c893e3f642$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $973285c893e3f642$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $973285c893e3f642$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $50919f05d286557e$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $973285c893e3f642$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $e5e81b64218caf2c$export$2e2bcd8739ae039 = (x)=>()=>x;


function $2da4b2dfee176711$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $2da4b2dfee176711$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $2da4b2dfee176711$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $2da4b2dfee176711$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $e5e81b64218caf2c$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $2da4b2dfee176711$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $2da4b2dfee176711$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $2da4b2dfee176711$var$exponential(a, b, y) : (0, $e5e81b64218caf2c$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $2da4b2dfee176711$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $2da4b2dfee176711$var$linear(a, d) : (0, $e5e81b64218caf2c$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $eaa0ccaf30fbc7fc$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $2da4b2dfee176711$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $hT5KM.rgb)(start)).r, (end = (0, $hT5KM.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $2da4b2dfee176711$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $eaa0ccaf30fbc7fc$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $hT5KM.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $eaa0ccaf30fbc7fc$export$2c0e28f2e2852d3f = $eaa0ccaf30fbc7fc$var$rgbSpline((0, $973285c893e3f642$export$2e2bcd8739ae039));
var $eaa0ccaf30fbc7fc$export$53d5214f625ccd4c = $eaa0ccaf30fbc7fc$var$rgbSpline((0, $50919f05d286557e$export$2e2bcd8739ae039));



function $51166a4a74f21cdd$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $51166a4a74f21cdd$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $6e1ab316d5bc81ab$export$2e2bcd8739ae039(a, b) {
    return ((0, $51166a4a74f21cdd$export$5cd576d1827d40c8)(b) ? (0, $51166a4a74f21cdd$export$2e2bcd8739ae039) : $6e1ab316d5bc81ab$export$15d09067c6a5ee49)(a, b);
}
function $6e1ab316d5bc81ab$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $35e12ce753d06bd2$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $ed9380038cc83b24$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}


function $70d62b51757d6461$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}



function $6834e595454675d0$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $35e12ce753d06bd2$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $5d558b9209189368$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $5d558b9209189368$var$reB = new RegExp($5d558b9209189368$var$reA.source, "g");
function $5d558b9209189368$var$zero(b) {
    return function() {
        return b;
    };
}
function $5d558b9209189368$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $5d558b9209189368$export$2e2bcd8739ae039(a, b) {
    var bi = $5d558b9209189368$var$reA.lastIndex = $5d558b9209189368$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $5d558b9209189368$var$reA.exec(a)) && (bm = $5d558b9209189368$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $70d62b51757d6461$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $5d558b9209189368$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $5d558b9209189368$var$one(q[0].x) : $5d558b9209189368$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}




function $35e12ce753d06bd2$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $e5e81b64218caf2c$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $70d62b51757d6461$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $hT5KM.default)(b)) ? (b = c, $eaa0ccaf30fbc7fc$export$2e2bcd8739ae039) : (0, $5d558b9209189368$export$2e2bcd8739ae039) : b instanceof (0, $hT5KM.default) ? (0, $eaa0ccaf30fbc7fc$export$2e2bcd8739ae039) : b instanceof Date ? (0, $ed9380038cc83b24$export$2e2bcd8739ae039) : (0, $51166a4a74f21cdd$export$5cd576d1827d40c8)(b) ? (0, $51166a4a74f21cdd$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $6e1ab316d5bc81ab$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $6834e595454675d0$export$2e2bcd8739ae039) : (0, $70d62b51757d6461$export$2e2bcd8739ae039))(a, b);
}


function $eebf3fccd23efc99$export$2e2bcd8739ae039(event) {
    let sourceEvent;
    while(sourceEvent = event.sourceEvent)event = sourceEvent;
    return event;
}


function $0f410bdad463c15a$export$2e2bcd8739ae039(event, node) {
    event = (0, $eebf3fccd23efc99$export$2e2bcd8739ae039)(event);
    if (node === undefined) node = event.currentTarget;
    if (node) {
        var svg = node.ownerSVGElement || node;
        if (svg.createSVGPoint) {
            var point = svg.createSVGPoint();
            point.x = event.clientX, point.y = event.clientY;
            point = point.matrixTransform(node.getScreenCTM().inverse());
            return [
                point.x,
                point.y
            ];
        }
        if (node.getBoundingClientRect) {
            var rect = node.getBoundingClientRect();
            return [
                event.clientX - rect.left - node.clientLeft,
                event.clientY - rect.top - node.clientTop
            ];
        }
    }
    return [
        event.pageX,
        event.pageY
    ];
}




var $04d68ee069f61df5$var$frame = 0, $04d68ee069f61df5$var$timeout = 0, $04d68ee069f61df5$var$interval = 0, $04d68ee069f61df5$var$pokeDelay = 1000, $04d68ee069f61df5$var$taskHead, $04d68ee069f61df5$var$taskTail, $04d68ee069f61df5$var$clockLast = 0, $04d68ee069f61df5$var$clockNow = 0, $04d68ee069f61df5$var$clockSkew = 0, $04d68ee069f61df5$var$clock = typeof performance === "object" && performance.now ? performance : Date, $04d68ee069f61df5$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $04d68ee069f61df5$export$461939dd4422153() {
    return $04d68ee069f61df5$var$clockNow || ($04d68ee069f61df5$var$setFrame($04d68ee069f61df5$var$clearNow), $04d68ee069f61df5$var$clockNow = $04d68ee069f61df5$var$clock.now() + $04d68ee069f61df5$var$clockSkew);
}
function $04d68ee069f61df5$var$clearNow() {
    $04d68ee069f61df5$var$clockNow = 0;
}
function $04d68ee069f61df5$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$04d68ee069f61df5$export$c57e9b2d8b9e4de.prototype = $04d68ee069f61df5$export$9dc4ecf953986f04.prototype = {
    constructor: $04d68ee069f61df5$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $04d68ee069f61df5$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $04d68ee069f61df5$var$taskTail !== this) {
            if ($04d68ee069f61df5$var$taskTail) $04d68ee069f61df5$var$taskTail._next = this;
            else $04d68ee069f61df5$var$taskHead = this;
            $04d68ee069f61df5$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $04d68ee069f61df5$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $04d68ee069f61df5$var$sleep();
        }
    }
};
function $04d68ee069f61df5$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $04d68ee069f61df5$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $04d68ee069f61df5$export$d60154c1d7f3990e() {
    $04d68ee069f61df5$export$461939dd4422153(); // Get the current time, if not already set.
    ++$04d68ee069f61df5$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $04d68ee069f61df5$var$taskHead, e;
    while(t){
        if ((e = $04d68ee069f61df5$var$clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --$04d68ee069f61df5$var$frame;
}
function $04d68ee069f61df5$var$wake() {
    $04d68ee069f61df5$var$clockNow = ($04d68ee069f61df5$var$clockLast = $04d68ee069f61df5$var$clock.now()) + $04d68ee069f61df5$var$clockSkew;
    $04d68ee069f61df5$var$frame = $04d68ee069f61df5$var$timeout = 0;
    try {
        $04d68ee069f61df5$export$d60154c1d7f3990e();
    } finally{
        $04d68ee069f61df5$var$frame = 0;
        $04d68ee069f61df5$var$nap();
        $04d68ee069f61df5$var$clockNow = 0;
    }
}
function $04d68ee069f61df5$var$poke() {
    var now = $04d68ee069f61df5$var$clock.now(), delay = now - $04d68ee069f61df5$var$clockLast;
    if (delay > $04d68ee069f61df5$var$pokeDelay) $04d68ee069f61df5$var$clockSkew -= delay, $04d68ee069f61df5$var$clockLast = now;
}
function $04d68ee069f61df5$var$nap() {
    var t0, t1 = $04d68ee069f61df5$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $04d68ee069f61df5$var$taskHead = t2;
    }
    $04d68ee069f61df5$var$taskTail = t0;
    $04d68ee069f61df5$var$sleep(time);
}
function $04d68ee069f61df5$var$sleep(time) {
    if ($04d68ee069f61df5$var$frame) return; // Soonest alarm already set, or will be.
    if ($04d68ee069f61df5$var$timeout) $04d68ee069f61df5$var$timeout = clearTimeout($04d68ee069f61df5$var$timeout);
    var delay = time - $04d68ee069f61df5$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $04d68ee069f61df5$var$timeout = setTimeout($04d68ee069f61df5$var$wake, time - $04d68ee069f61df5$var$clock.now() - $04d68ee069f61df5$var$clockSkew);
        if ($04d68ee069f61df5$var$interval) $04d68ee069f61df5$var$interval = clearInterval($04d68ee069f61df5$var$interval);
    } else {
        if (!$04d68ee069f61df5$var$interval) $04d68ee069f61df5$var$clockLast = $04d68ee069f61df5$var$clock.now(), $04d68ee069f61df5$var$interval = setInterval($04d68ee069f61df5$var$poke, $04d68ee069f61df5$var$pokeDelay);
        $04d68ee069f61df5$var$frame = 1, $04d68ee069f61df5$var$setFrame($04d68ee069f61df5$var$wake);
    }
}


function $5ba48478c0e6416f$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $04d68ee069f61df5$export$c57e9b2d8b9e4de);
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}


var $3f93bc5f26ea2209$var$emptyOn = (0, $cb0cee1ac6170bcd$export$2e2bcd8739ae039)("start", "end", "cancel", "interrupt");
var $3f93bc5f26ea2209$var$emptyTween = [];
var $3f93bc5f26ea2209$export$ff39ebd4bb12b718 = 0;
var $3f93bc5f26ea2209$export$584530fe98d14a84 = 1;
var $3f93bc5f26ea2209$export$a5d151aee16efd42 = 2;
var $3f93bc5f26ea2209$export$fb935ab5849a0db9 = 3;
var $3f93bc5f26ea2209$export$1573e22b087389af = 4;
var $3f93bc5f26ea2209$export$a2e792214ded83b2 = 5;
var $3f93bc5f26ea2209$export$9d38167254403955 = 6;
function $3f93bc5f26ea2209$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $3f93bc5f26ea2209$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $3f93bc5f26ea2209$var$emptyOn,
        tween: $3f93bc5f26ea2209$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $3f93bc5f26ea2209$export$ff39ebd4bb12b718
    });
}
function $3f93bc5f26ea2209$export$2cd8252107eb640b(node, id) {
    var schedule = $3f93bc5f26ea2209$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $3f93bc5f26ea2209$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $3f93bc5f26ea2209$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $3f93bc5f26ea2209$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $3f93bc5f26ea2209$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $3f93bc5f26ea2209$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $3f93bc5f26ea2209$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $04d68ee069f61df5$export$9dc4ecf953986f04)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $3f93bc5f26ea2209$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $3f93bc5f26ea2209$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $3f93bc5f26ea2209$export$fb935ab5849a0db9) return (0, $5ba48478c0e6416f$export$2e2bcd8739ae039)(start);
            // Interrupt the active transition, if any.
            if (o.state === $3f93bc5f26ea2209$export$1573e22b087389af) {
                o.state = $3f93bc5f26ea2209$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $3f93bc5f26ea2209$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $5ba48478c0e6416f$export$2e2bcd8739ae039)(function() {
            if (self.state === $3f93bc5f26ea2209$export$fb935ab5849a0db9) {
                self.state = $3f93bc5f26ea2209$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $3f93bc5f26ea2209$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $3f93bc5f26ea2209$export$a5d151aee16efd42) return; // interrupted
        self.state = $3f93bc5f26ea2209$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $3f93bc5f26ea2209$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $3f93bc5f26ea2209$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $3f93bc5f26ea2209$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}


function $244473f94df4a7bf$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $3f93bc5f26ea2209$export$a5d151aee16efd42) && schedule.state < (0, $3f93bc5f26ea2209$export$a2e792214ded83b2);
        schedule.state = (0, $3f93bc5f26ea2209$export$9d38167254403955);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}


function $cb63986807154416$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $244473f94df4a7bf$export$2e2bcd8739ae039)(this, name);
    });
}




var $a450eab89e773eee$var$degrees = 180 / Math.PI;
var $a450eab89e773eee$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $a450eab89e773eee$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $a450eab89e773eee$var$degrees,
        skewX: Math.atan(skewX) * $a450eab89e773eee$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}


var $0e9c2ae58ef92946$var$svgNode;
function $0e9c2ae58ef92946$export$59ad369bf4938177(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, $a450eab89e773eee$export$f0954fd7d5368655) : (0, $a450eab89e773eee$export$2e2bcd8739ae039)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $0e9c2ae58ef92946$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $a450eab89e773eee$export$f0954fd7d5368655;
    if (!$0e9c2ae58ef92946$var$svgNode) $0e9c2ae58ef92946$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $0e9c2ae58ef92946$var$svgNode.setAttribute("transform", value);
    if (!(value = $0e9c2ae58ef92946$var$svgNode.transform.baseVal.consolidate())) return 0, $a450eab89e773eee$export$f0954fd7d5368655;
    value = value.matrix;
    return (0, $a450eab89e773eee$export$2e2bcd8739ae039)(value.a, value.b, value.c, value.d, value.e, value.f);
}


function $b33ac66531e9f90a$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $70d62b51757d6461$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $70d62b51757d6461$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $70d62b51757d6461$export$2e2bcd8739ae039)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $70d62b51757d6461$export$2e2bcd8739ae039)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $70d62b51757d6461$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $70d62b51757d6461$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $b33ac66531e9f90a$export$56bec7123bb3589a = $b33ac66531e9f90a$var$interpolateTransform((0, $0e9c2ae58ef92946$export$59ad369bf4938177), "px, ", "px)", "deg)");
var $b33ac66531e9f90a$export$da8cba906d64c082 = $b33ac66531e9f90a$var$interpolateTransform((0, $0e9c2ae58ef92946$export$f9ef43f9a1d89a18), ", ", ")", ")");




function $e8ab9c88236a7eed$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $3f93bc5f26ea2209$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $e8ab9c88236a7eed$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $3f93bc5f26ea2209$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $e8ab9c88236a7eed$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $3f93bc5f26ea2209$export$3988ae62b71be9a3)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $e8ab9c88236a7eed$var$tweenRemove : $e8ab9c88236a7eed$var$tweenFunction)(id, name, value));
}
function $e8ab9c88236a7eed$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $3f93bc5f26ea2209$export$adaa4cf7ef1b65be)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $3f93bc5f26ea2209$export$3988ae62b71be9a3)(node, id).value[name];
    };
}



var $hT5KM = parcelRequire("hT5KM");

function $fe2c5f6a6c982274$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $70d62b51757d6461$export$2e2bcd8739ae039) : b instanceof (0, $hT5KM.default) ? (0, $eaa0ccaf30fbc7fc$export$2e2bcd8739ae039) : (c = (0, $hT5KM.default)(b)) ? (b = c, $eaa0ccaf30fbc7fc$export$2e2bcd8739ae039) : (0, $5d558b9209189368$export$2e2bcd8739ae039))(a, b);
}


function $c7d9302bd5f98a4e$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $c7d9302bd5f98a4e$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $c7d9302bd5f98a4e$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $c7d9302bd5f98a4e$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $c7d9302bd5f98a4e$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $c7d9302bd5f98a4e$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $c7d9302bd5f98a4e$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $f718483478e35f10$export$2e2bcd8739ae039)(name), i = fullname === "transform" ? (0, $b33ac66531e9f90a$export$da8cba906d64c082) : (0, $fe2c5f6a6c982274$export$2e2bcd8739ae039);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $c7d9302bd5f98a4e$var$attrFunctionNS : $c7d9302bd5f98a4e$var$attrFunction)(fullname, i, (0, $e8ab9c88236a7eed$export$f78ce6ab10405d82)(this, "attr." + name, value)) : value == null ? (fullname.local ? $c7d9302bd5f98a4e$var$attrRemoveNS : $c7d9302bd5f98a4e$var$attrRemove)(fullname) : (fullname.local ? $c7d9302bd5f98a4e$var$attrConstantNS : $c7d9302bd5f98a4e$var$attrConstant)(fullname, i, value));
}



function $e7132c4f66bfcd4f$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $e7132c4f66bfcd4f$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $e7132c4f66bfcd4f$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $e7132c4f66bfcd4f$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $e7132c4f66bfcd4f$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $e7132c4f66bfcd4f$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $e7132c4f66bfcd4f$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $f718483478e35f10$export$2e2bcd8739ae039)(name);
    return this.tween(key, (fullname.local ? $e7132c4f66bfcd4f$var$attrTweenNS : $e7132c4f66bfcd4f$var$attrTween)(fullname, value));
}



function $487c9a041b315540$var$delayFunction(id, value) {
    return function() {
        (0, $3f93bc5f26ea2209$export$2cd8252107eb640b)(this, id).delay = +value.apply(this, arguments);
    };
}
function $487c9a041b315540$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $3f93bc5f26ea2209$export$2cd8252107eb640b)(this, id).delay = value;
    };
}
function $487c9a041b315540$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $487c9a041b315540$var$delayFunction : $487c9a041b315540$var$delayConstant)(id, value)) : (0, $3f93bc5f26ea2209$export$3988ae62b71be9a3)(this.node(), id).delay;
}



function $50edf0bb8183bf19$var$durationFunction(id, value) {
    return function() {
        (0, $3f93bc5f26ea2209$export$adaa4cf7ef1b65be)(this, id).duration = +value.apply(this, arguments);
    };
}
function $50edf0bb8183bf19$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $3f93bc5f26ea2209$export$adaa4cf7ef1b65be)(this, id).duration = value;
    };
}
function $50edf0bb8183bf19$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $50edf0bb8183bf19$var$durationFunction : $50edf0bb8183bf19$var$durationConstant)(id, value)) : (0, $3f93bc5f26ea2209$export$3988ae62b71be9a3)(this.node(), id).duration;
}



function $f1dd4da4ea1e7732$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $3f93bc5f26ea2209$export$adaa4cf7ef1b65be)(this, id).ease = value;
    };
}
function $f1dd4da4ea1e7732$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($f1dd4da4ea1e7732$var$easeConstant(id, value)) : (0, $3f93bc5f26ea2209$export$3988ae62b71be9a3)(this.node(), id).ease;
}



function $4a818ac50e2fd952$var$easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, $3f93bc5f26ea2209$export$adaa4cf7ef1b65be)(this, id).ease = v;
    };
}
function $4a818ac50e2fd952$export$2e2bcd8739ae039(value) {
    if (typeof value !== "function") throw new Error;
    return this.each($4a818ac50e2fd952$var$easeVarying(this._id, value));
}




function $e7fa9016c8d88551$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $454fddaf82fd4237$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $bf2992c32f1a6a11$export$be58926105124dd4)(subgroups, this._parents, this._name, this._id);
}



function $37b6bfd8494ff01c$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $bf2992c32f1a6a11$export$be58926105124dd4)(merges, this._parents, this._name, this._id);
}



function $0049f87aadffe149$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $0049f87aadffe149$var$onFunction(id, name, listener) {
    var on0, on1, sit = $0049f87aadffe149$var$start(name) ? (0, $3f93bc5f26ea2209$export$2cd8252107eb640b) : (0, $3f93bc5f26ea2209$export$adaa4cf7ef1b65be);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $0049f87aadffe149$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $3f93bc5f26ea2209$export$3988ae62b71be9a3)(this.node(), id).on.on(name) : this.each($0049f87aadffe149$var$onFunction(id, name, listener));
}


function $1f3952ebf4bb9f1e$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $1f3952ebf4bb9f1e$export$2e2bcd8739ae039() {
    return this.on("end.remove", $1f3952ebf4bb9f1e$var$removeFunction(this._id));
}





function $622fefac60b58ce2$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $80e330374f930727$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $3f93bc5f26ea2209$export$2e2bcd8739ae039)(subgroup[i], name, id, i, subgroup, (0, $3f93bc5f26ea2209$export$3988ae62b71be9a3)(node, id));
        }
    }
    return new (0, $bf2992c32f1a6a11$export$be58926105124dd4)(subgroups, this._parents, name, id);
}





function $9bf0f210a6f1780b$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $21b24c1979918eec$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $3f93bc5f26ea2209$export$3988ae62b71be9a3)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $3f93bc5f26ea2209$export$2e2bcd8739ae039)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $bf2992c32f1a6a11$export$be58926105124dd4)(subgroups, parents, name, id);
}



var $8973cb2b5f44c258$var$Selection = (0, $05a287e75fbd2bd2$export$2e2bcd8739ae039).prototype.constructor;
function $8973cb2b5f44c258$export$2e2bcd8739ae039() {
    return new $8973cb2b5f44c258$var$Selection(this._groups, this._parents);
}







function $b2a55da643c9b1b4$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $b7816f432860dac6$export$5e3cec964f0b5efd)(this, name), string1 = (this.style.removeProperty(name), (0, $b7816f432860dac6$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $b2a55da643c9b1b4$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $b2a55da643c9b1b4$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $b7816f432860dac6$export$5e3cec964f0b5efd)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $b2a55da643c9b1b4$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $b7816f432860dac6$export$5e3cec964f0b5efd)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $b7816f432860dac6$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $b2a55da643c9b1b4$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $3f93bc5f26ea2209$export$adaa4cf7ef1b65be)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $b2a55da643c9b1b4$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $b2a55da643c9b1b4$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $b33ac66531e9f90a$export$56bec7123bb3589a) : (0, $fe2c5f6a6c982274$export$2e2bcd8739ae039);
    return value == null ? this.styleTween(name, $b2a55da643c9b1b4$var$styleNull(name, i)).on("end.style." + name, $b2a55da643c9b1b4$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $b2a55da643c9b1b4$var$styleFunction(name, i, (0, $e8ab9c88236a7eed$export$f78ce6ab10405d82)(this, "style." + name, value))).each($b2a55da643c9b1b4$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $b2a55da643c9b1b4$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}


function $7cb301a1edfc1af0$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $7cb301a1edfc1af0$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $7cb301a1edfc1af0$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $7cb301a1edfc1af0$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $7cb301a1edfc1af0$var$styleTween(name, value, priority == null ? "" : priority));
}



function $062ec2580c721867$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $062ec2580c721867$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $062ec2580c721867$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $062ec2580c721867$var$textFunction((0, $e8ab9c88236a7eed$export$f78ce6ab10405d82)(this, "text", value)) : $062ec2580c721867$var$textConstant(value == null ? "" : value + ""));
}


function $71baa3b58f2ffe05$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $71baa3b58f2ffe05$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $71baa3b58f2ffe05$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $71baa3b58f2ffe05$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $71baa3b58f2ffe05$var$textTween(value));
}




function $b0bfd5eb447b4983$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $bf2992c32f1a6a11$export$9ffd10a3fbdc175b)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $3f93bc5f26ea2209$export$3988ae62b71be9a3)(node, id0);
            (0, $3f93bc5f26ea2209$export$2e2bcd8739ae039)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $bf2992c32f1a6a11$export$be58926105124dd4)(groups, this._parents, name, id1);
}




function $3a4675f3fdf22425$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $3f93bc5f26ea2209$export$adaa4cf7ef1b65be)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
        // The selection was empty, resolve end immediately
        if (size === 0) resolve();
    });
}


var $bf2992c32f1a6a11$var$id = 0;
function $bf2992c32f1a6a11$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $bf2992c32f1a6a11$export$2e2bcd8739ae039(name) {
    return (0, $05a287e75fbd2bd2$export$2e2bcd8739ae039)().transition(name);
}
function $bf2992c32f1a6a11$export$9ffd10a3fbdc175b() {
    return ++$bf2992c32f1a6a11$var$id;
}
var $bf2992c32f1a6a11$var$selection_prototype = (0, $05a287e75fbd2bd2$export$2e2bcd8739ae039).prototype;
$bf2992c32f1a6a11$export$be58926105124dd4.prototype = $bf2992c32f1a6a11$export$2e2bcd8739ae039.prototype = {
    constructor: $bf2992c32f1a6a11$export$be58926105124dd4,
    select: (0, $622fefac60b58ce2$export$2e2bcd8739ae039),
    selectAll: (0, $9bf0f210a6f1780b$export$2e2bcd8739ae039),
    selectChild: $bf2992c32f1a6a11$var$selection_prototype.selectChild,
    selectChildren: $bf2992c32f1a6a11$var$selection_prototype.selectChildren,
    filter: (0, $e7fa9016c8d88551$export$2e2bcd8739ae039),
    merge: (0, $37b6bfd8494ff01c$export$2e2bcd8739ae039),
    selection: (0, $8973cb2b5f44c258$export$2e2bcd8739ae039),
    transition: (0, $b0bfd5eb447b4983$export$2e2bcd8739ae039),
    call: $bf2992c32f1a6a11$var$selection_prototype.call,
    nodes: $bf2992c32f1a6a11$var$selection_prototype.nodes,
    node: $bf2992c32f1a6a11$var$selection_prototype.node,
    size: $bf2992c32f1a6a11$var$selection_prototype.size,
    empty: $bf2992c32f1a6a11$var$selection_prototype.empty,
    each: $bf2992c32f1a6a11$var$selection_prototype.each,
    on: (0, $0049f87aadffe149$export$2e2bcd8739ae039),
    attr: (0, $c7d9302bd5f98a4e$export$2e2bcd8739ae039),
    attrTween: (0, $e7132c4f66bfcd4f$export$2e2bcd8739ae039),
    style: (0, $b2a55da643c9b1b4$export$2e2bcd8739ae039),
    styleTween: (0, $7cb301a1edfc1af0$export$2e2bcd8739ae039),
    text: (0, $062ec2580c721867$export$2e2bcd8739ae039),
    textTween: (0, $71baa3b58f2ffe05$export$2e2bcd8739ae039),
    remove: (0, $1f3952ebf4bb9f1e$export$2e2bcd8739ae039),
    tween: (0, $e8ab9c88236a7eed$export$2e2bcd8739ae039),
    delay: (0, $487c9a041b315540$export$2e2bcd8739ae039),
    duration: (0, $50edf0bb8183bf19$export$2e2bcd8739ae039),
    ease: (0, $f1dd4da4ea1e7732$export$2e2bcd8739ae039),
    easeVarying: (0, $4a818ac50e2fd952$export$2e2bcd8739ae039),
    end: (0, $3a4675f3fdf22425$export$2e2bcd8739ae039),
    [Symbol.iterator]: $bf2992c32f1a6a11$var$selection_prototype[Symbol.iterator]
};



function $2c35545f6299b93c$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $2c35545f6299b93c$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $2c35545f6299b93c$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}



var $2b037973fffd7210$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $2c35545f6299b93c$export$89238d3bc79d3ada)
};
function $2b037973fffd7210$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}
function $2b037973fffd7210$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $bf2992c32f1a6a11$export$be58926105124dd4)) id = name._id, name = name._name;
    else id = (0, $bf2992c32f1a6a11$export$9ffd10a3fbdc175b)(), (timing = $2b037973fffd7210$var$defaultTiming).time = (0, $04d68ee069f61df5$export$461939dd4422153)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $3f93bc5f26ea2209$export$2e2bcd8739ae039)(node, name, id, i, group, timing || $2b037973fffd7210$var$inherit(node, id));
    }
    return new (0, $bf2992c32f1a6a11$export$be58926105124dd4)(groups, this._parents, name, id);
}


(0, $05a287e75fbd2bd2$export$2e2bcd8739ae039).prototype.interrupt = (0, $cb63986807154416$export$2e2bcd8739ae039);
(0, $05a287e75fbd2bd2$export$2e2bcd8739ae039).prototype.transition = (0, $2b037973fffd7210$export$2e2bcd8739ae039);







var $8cfa0d9caac96b12$export$2e2bcd8739ae039 = (x)=>()=>x;


function $e90cdeed68c65c98$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, selection: selection, mode: mode, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        selection: {
            value: selection,
            enumerable: true,
            configurable: true
        },
        mode: {
            value: mode,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $897a8055c7316d93$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $897a8055c7316d93$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


var $7527caa84d698281$var$MODE_DRAG = {
    name: "drag"
}, $7527caa84d698281$var$MODE_SPACE = {
    name: "space"
}, $7527caa84d698281$var$MODE_HANDLE = {
    name: "handle"
}, $7527caa84d698281$var$MODE_CENTER = {
    name: "center"
};
const { abs: $7527caa84d698281$var$abs, max: $7527caa84d698281$var$max, min: $7527caa84d698281$var$min } = Math;
function $7527caa84d698281$var$number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function $7527caa84d698281$var$number2(e) {
    return [
        $7527caa84d698281$var$number1(e[0]),
        $7527caa84d698281$var$number1(e[1])
    ];
}
var $7527caa84d698281$var$X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map($7527caa84d698281$var$type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $7527caa84d698281$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($7527caa84d698281$var$type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $7527caa84d698281$var$XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map($7527caa84d698281$var$type),
    input: function(xy) {
        return xy == null ? null : $7527caa84d698281$var$number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var $7527caa84d698281$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $7527caa84d698281$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $7527caa84d698281$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $7527caa84d698281$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $7527caa84d698281$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $7527caa84d698281$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $7527caa84d698281$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $7527caa84d698281$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function $7527caa84d698281$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $7527caa84d698281$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $7527caa84d698281$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $7527caa84d698281$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $7527caa84d698281$export$979ace6c88860aa8() {
    return $7527caa84d698281$var$brush($7527caa84d698281$var$X);
}
function $7527caa84d698281$export$468748b530991c54() {
    return $7527caa84d698281$var$brush($7527caa84d698281$var$Y);
}
function $7527caa84d698281$export$2e2bcd8739ae039() {
    return $7527caa84d698281$var$brush($7527caa84d698281$var$XY);
}
function $7527caa84d698281$var$brush(dim) {
    var extent = $7527caa84d698281$var$defaultExtent, filter = $7527caa84d698281$var$defaultFilter, touchable = $7527caa84d698281$var$defaultTouchable, keys = true, listeners = (0, $cb0cee1ac6170bcd$export$2e2bcd8739ae039)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $7527caa84d698281$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $7527caa84d698281$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $7527caa84d698281$var$local(this).extent;
            (0, $212a85cfc656869b$export$2e2bcd8739ae039)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $7527caa84d698281$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $7527caa84d698281$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $7527caa84d698281$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection, event) {
        if (group.tween) group.on("start.brush", function(event) {
            emitter(this, arguments).beforestart().start(event);
        }).on("interrupt.brush end.brush", function(event) {
            emitter(this, arguments).end(event);
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $35e12ce753d06bd2$export$2e2bcd8739ae039)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $244473f94df4a7bf$export$2e2bcd8739ae039)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start(event).brush(event).end(event);
        });
    };
    brush.clear = function(group, event) {
        brush.move(group, null, event);
    };
    function redraw() {
        var group = (0, $212a85cfc656869b$export$2e2bcd8739ae039)(this), selection = $7527caa84d698281$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function(event, mode) {
            if (this.starting) this.starting = false, this.emit("start", event, mode);
            else this.emit("brush", event);
            return this;
        },
        brush: function(event, mode) {
            this.emit("brush", event, mode);
            return this;
        },
        end: function(event, mode) {
            if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
            return this;
        },
        emit: function(type, event, mode) {
            var d = (0, $212a85cfc656869b$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $e90cdeed68c65c98$export$2e2bcd8739ae039)(type, {
                sourceEvent: event,
                target: brush,
                selection: dim.output(this.state.selection),
                mode: mode,
                dispatch: listeners
            }), d);
        }
    };
    function started(event) {
        if (touchending && !event.touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? $7527caa84d698281$var$MODE_DRAG : keys && event.altKey ? $7527caa84d698281$var$MODE_CENTER : $7527caa84d698281$var$MODE_HANDLE, signX = dim === $7527caa84d698281$var$Y ? null : $7527caa84d698281$var$signsX[type], signY = dim === $7527caa84d698281$var$X ? null : $7527caa84d698281$var$signsY[type], state = $7527caa84d698281$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
            event
        ], (t)=>{
            const i = t.identifier;
            t = (0, $0f410bdad463c15a$export$2e2bcd8739ae039)(t, that);
            t.point0 = t.slice();
            t.identifier = i;
            return t;
        });
        (0, $244473f94df4a7bf$export$2e2bcd8739ae039)(that);
        var emit = emitter(that, arguments, true).beforestart();
        if (type === "overlay") {
            if (selection) moving = true;
            const pts = [
                points[0],
                points[1] || points[0]
            ];
            state.selection = selection = [
                [
                    w0 = dim === $7527caa84d698281$var$Y ? W : $7527caa84d698281$var$min(pts[0][0], pts[1][0]),
                    n0 = dim === $7527caa84d698281$var$X ? N : $7527caa84d698281$var$min(pts[0][1], pts[1][1])
                ],
                [
                    e0 = dim === $7527caa84d698281$var$Y ? E : $7527caa84d698281$var$max(pts[0][0], pts[1][0]),
                    s0 = dim === $7527caa84d698281$var$X ? S : $7527caa84d698281$var$max(pts[0][1], pts[1][1])
                ]
            ];
            if (points.length > 1) move(event);
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $212a85cfc656869b$export$2e2bcd8739ae039)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $7527caa84d698281$var$cursors[type]);
        if (event.touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, $212a85cfc656869b$export$2e2bcd8739ae039)(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, $53c33dda764ea7c9$export$2e2bcd8739ae039)(event.view);
        }
        redraw.call(that);
        emit.start(event, mode.name);
        function moved(event) {
            for (const p of event.changedTouches || [
                event
            ]){
                for (const d of points)if (d.identifier === p.identifier) d.cur = (0, $0f410bdad463c15a$export$2e2bcd8739ae039)(p, that);
            }
            if (shifting && !lockX && !lockY && points.length === 1) {
                const point = points[0];
                if ($7527caa84d698281$var$abs(point.cur[0] - point[0]) > $7527caa84d698281$var$abs(point.cur[1] - point[1])) lockY = true;
                else lockX = true;
            }
            for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
            moving = true;
            (0, $897a8055c7316d93$export$2e2bcd8739ae039)(event);
            move(event);
        }
        function move(event) {
            const point = points[0], point0 = point.point0;
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $7527caa84d698281$var$MODE_SPACE:
                case $7527caa84d698281$var$MODE_DRAG:
                    if (signX) dx = $7527caa84d698281$var$max(W - w0, $7527caa84d698281$var$min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = $7527caa84d698281$var$max(N - n0, $7527caa84d698281$var$min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $7527caa84d698281$var$MODE_HANDLE:
                    if (points[1]) {
                        if (signX) w1 = $7527caa84d698281$var$max(W, $7527caa84d698281$var$min(E, points[0][0])), e1 = $7527caa84d698281$var$max(W, $7527caa84d698281$var$min(E, points[1][0])), signX = 1;
                        if (signY) n1 = $7527caa84d698281$var$max(N, $7527caa84d698281$var$min(S, points[0][1])), s1 = $7527caa84d698281$var$max(N, $7527caa84d698281$var$min(S, points[1][1])), signY = 1;
                    } else {
                        if (signX < 0) dx = $7527caa84d698281$var$max(W - w0, $7527caa84d698281$var$min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                        else if (signX > 0) dx = $7527caa84d698281$var$max(W - e0, $7527caa84d698281$var$min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                        if (signY < 0) dy = $7527caa84d698281$var$max(N - n0, $7527caa84d698281$var$min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                        else if (signY > 0) dy = $7527caa84d698281$var$max(N - s0, $7527caa84d698281$var$min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    }
                    break;
                case $7527caa84d698281$var$MODE_CENTER:
                    if (signX) w1 = $7527caa84d698281$var$max(W, $7527caa84d698281$var$min(E, w0 - dx * signX)), e1 = $7527caa84d698281$var$max(W, $7527caa84d698281$var$min(E, e0 + dx * signX));
                    if (signY) n1 = $7527caa84d698281$var$max(N, $7527caa84d698281$var$min(S, n0 - dy * signY)), s1 = $7527caa84d698281$var$max(N, $7527caa84d698281$var$min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $7527caa84d698281$var$flipX) overlay.attr("cursor", $7527caa84d698281$var$cursors[type = $7527caa84d698281$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $7527caa84d698281$var$flipY) overlay.attr("cursor", $7527caa84d698281$var$cursors[type = $7527caa84d698281$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush(event, mode.name);
            }
        }
        function ended(event) {
            (0, $897a8055c7316d93$export$2e2561858db9bf47)(event);
            if (event.touches) {
                if (event.touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, $53c33dda764ea7c9$export$833237748009e1e1)(event.view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $7527caa84d698281$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($7527caa84d698281$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end(event, mode.name);
        }
        function keydowned(event) {
            switch(event.keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $7527caa84d698281$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $7527caa84d698281$var$MODE_CENTER;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $7527caa84d698281$var$MODE_HANDLE || mode === $7527caa84d698281$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $7527caa84d698281$var$MODE_SPACE;
                        overlay.attr("cursor", $7527caa84d698281$var$cursors.selection);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $897a8055c7316d93$export$2e2bcd8739ae039)(event);
        }
        function keyupped(event) {
            switch(event.keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move(event);
                    }
                    break;
                case 18:
                    if (mode === $7527caa84d698281$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $7527caa84d698281$var$MODE_HANDLE;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $7527caa84d698281$var$MODE_SPACE) {
                        if (event.altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $7527caa84d698281$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $7527caa84d698281$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $7527caa84d698281$var$cursors[type]);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $897a8055c7316d93$export$2e2bcd8739ae039)(event);
        }
    }
    function touchmoved(event) {
        emitter(this, arguments).moved(event);
    }
    function touchended(event) {
        emitter(this, arguments).ended(event);
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = $7527caa84d698281$var$number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $8cfa0d9caac96b12$export$2e2bcd8739ae039)($7527caa84d698281$var$number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $8cfa0d9caac96b12$export$2e2bcd8739ae039)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $8cfa0d9caac96b12$export$2e2bcd8739ae039)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}






















const $db27481a2c586ed3$var$e10 = Math.sqrt(50), $db27481a2c586ed3$var$e5 = Math.sqrt(10), $db27481a2c586ed3$var$e2 = Math.sqrt(2);
function $db27481a2c586ed3$var$tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= $db27481a2c586ed3$var$e10 ? 10 : error >= $db27481a2c586ed3$var$e5 ? 5 : error >= $db27481a2c586ed3$var$e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return $db27481a2c586ed3$var$tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function $db27481a2c586ed3$export$2e2bcd8739ae039(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? $db27481a2c586ed3$var$tickSpec(stop, start, count) : $db27481a2c586ed3$var$tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function $db27481a2c586ed3$export$bc64d00cc98e7e95(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return $db27481a2c586ed3$var$tickSpec(start, stop, count)[2];
}
function $db27481a2c586ed3$export$81087d9b915d4ede(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? $db27481a2c586ed3$export$bc64d00cc98e7e95(stop, start, count) : $db27481a2c586ed3$export$bc64d00cc98e7e95(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}


function $84e620269a766aa7$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



function $70ff2b1d4af80691$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $a0bc7fa717a1c978$export$2e2bcd8739ae039(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, $84e620269a766aa7$export$2e2bcd8739ae039);
        compare2 = (d, x)=>(0, $84e620269a766aa7$export$2e2bcd8739ae039)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, $84e620269a766aa7$export$2e2bcd8739ae039) || f === (0, $70ff2b1d4af80691$export$2e2bcd8739ae039) ? f : $a0bc7fa717a1c978$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $a0bc7fa717a1c978$var$zero() {
    return 0;
}


function $60e961adb6242310$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $60e961adb6242310$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}


const $3e97e90896914ea6$var$ascendingBisect = (0, $a0bc7fa717a1c978$export$2e2bcd8739ae039)((0, $84e620269a766aa7$export$2e2bcd8739ae039));
const $3e97e90896914ea6$export$4d945ad3ad5751b0 = $3e97e90896914ea6$var$ascendingBisect.right;
const $3e97e90896914ea6$export$df7d25c84ebd12a5 = $3e97e90896914ea6$var$ascendingBisect.left;
const $3e97e90896914ea6$export$c1cb828b1117c77b = (0, $a0bc7fa717a1c978$export$2e2bcd8739ae039)((0, $60e961adb6242310$export$2e2bcd8739ae039)).center;
var $3e97e90896914ea6$export$2e2bcd8739ae039 = $3e97e90896914ea6$export$4d945ad3ad5751b0;


function $4a40f366978d8095$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}


function $72700a82db04f439$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $008a37d28fc9a87d$export$2e2bcd8739ae039(x) {
    return +x;
}


var $cdaf693540c93821$var$unit = [
    0,
    1
];
function $cdaf693540c93821$export$f0954fd7d5368655(x) {
    return x;
}
function $cdaf693540c93821$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $72700a82db04f439$export$2e2bcd8739ae039)(isNaN(b) ? NaN : 0.5);
}
function $cdaf693540c93821$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $cdaf693540c93821$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $cdaf693540c93821$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $cdaf693540c93821$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $cdaf693540c93821$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $cdaf693540c93821$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $3e97e90896914ea6$export$2e2bcd8739ae039)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $cdaf693540c93821$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $cdaf693540c93821$export$6b468dcfb64c653c() {
    var domain = $cdaf693540c93821$var$unit, range = $cdaf693540c93821$var$unit, interpolate = (0, $35e12ce753d06bd2$export$2e2bcd8739ae039), transform, untransform, unknown, clamp = $cdaf693540c93821$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $cdaf693540c93821$export$f0954fd7d5368655) clamp = $cdaf693540c93821$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $cdaf693540c93821$var$polymap : $cdaf693540c93821$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $70d62b51757d6461$export$2e2bcd8739ae039))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $008a37d28fc9a87d$export$2e2bcd8739ae039)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $4a40f366978d8095$export$2e2bcd8739ae039), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $cdaf693540c93821$export$f0954fd7d5368655, rescale()) : clamp !== $cdaf693540c93821$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $cdaf693540c93821$export$2e2bcd8739ae039() {
    return $cdaf693540c93821$export$6b468dcfb64c653c()($cdaf693540c93821$export$f0954fd7d5368655, $cdaf693540c93821$export$f0954fd7d5368655);
}


function $af0f60d7d428cc7a$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $af0f60d7d428cc7a$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}



function $c1f4785e4255f1f5$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $c1f4785e4255f1f5$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}


function $6f58b9f5260ce133$export$2e2bcd8739ae039(x) {
    return x = (0, $c1f4785e4255f1f5$export$8f8e23dd27dc19f5)(Math.abs(x)), x ? x[1] : NaN;
}


function $561ddc5da967ef33$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}


function $3202bfe2850148a6$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}


// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $8d787175e9f1e699$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $8d787175e9f1e699$export$2e2bcd8739ae039(specifier) {
    if (!(match = $8d787175e9f1e699$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $8d787175e9f1e699$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$8d787175e9f1e699$export$2e2bcd8739ae039.prototype = $8d787175e9f1e699$export$963aac351db36ed4.prototype; // instanceof
function $8d787175e9f1e699$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$8d787175e9f1e699$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};


// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $32dab81d997ff1ae$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}




var $d6cc0e5dc421683e$export$6863724d9a42263;
function $d6cc0e5dc421683e$export$2e2bcd8739ae039(x, p) {
    var d = (0, $c1f4785e4255f1f5$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($d6cc0e5dc421683e$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $c1f4785e4255f1f5$export$8f8e23dd27dc19f5)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}



function $e021e9c5c6ec1119$export$2e2bcd8739ae039(x, p) {
    var d = (0, $c1f4785e4255f1f5$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}


var $bb1c3c71f071395b$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $c1f4785e4255f1f5$export$2e2bcd8739ae039),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $e021e9c5c6ec1119$export$2e2bcd8739ae039)(x * 100, p),
    "r": (0, $e021e9c5c6ec1119$export$2e2bcd8739ae039),
    "s": (0, $d6cc0e5dc421683e$export$2e2bcd8739ae039),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};



function $6be46c1c44b58d1e$export$2e2bcd8739ae039(x) {
    return x;
}


var $72151b803a463d6b$var$map = Array.prototype.map, $72151b803a463d6b$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $72151b803a463d6b$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $6be46c1c44b58d1e$export$2e2bcd8739ae039) : (0, $561ddc5da967ef33$export$2e2bcd8739ae039)($72151b803a463d6b$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $6be46c1c44b58d1e$export$2e2bcd8739ae039) : (0, $3202bfe2850148a6$export$2e2bcd8739ae039)($72151b803a463d6b$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $8d787175e9f1e699$export$2e2bcd8739ae039)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $bb1c3c71f071395b$export$2e2bcd8739ae039)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $bb1c3c71f071395b$export$2e2bcd8739ae039)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $32dab81d997ff1ae$export$2e2bcd8739ae039)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $72151b803a463d6b$var$prefixes[8 + (0, $d6cc0e5dc421683e$export$6863724d9a42263) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $8d787175e9f1e699$export$2e2bcd8739ae039)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $6f58b9f5260ce133$export$2e2bcd8739ae039)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $72151b803a463d6b$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}


var $093e209ad44084f8$var$locale;
var $093e209ad44084f8$export$d9468344d3651243;
var $093e209ad44084f8$export$8d85692a469dde6f;
$093e209ad44084f8$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $093e209ad44084f8$export$2e2bcd8739ae039(definition) {
    $093e209ad44084f8$var$locale = (0, $72151b803a463d6b$export$2e2bcd8739ae039)(definition);
    $093e209ad44084f8$export$d9468344d3651243 = $093e209ad44084f8$var$locale.format;
    $093e209ad44084f8$export$8d85692a469dde6f = $093e209ad44084f8$var$locale.formatPrefix;
    return $093e209ad44084f8$var$locale;
}


function $2d43e8cad1cbfc09$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $6f58b9f5260ce133$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $b964796478fe5fdb$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $6f58b9f5260ce133$export$2e2bcd8739ae039)(value) / 3))) * 3 - (0, $6f58b9f5260ce133$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $6e3d737ad782ab2f$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $6f58b9f5260ce133$export$2e2bcd8739ae039)(max) - (0, $6f58b9f5260ce133$export$2e2bcd8739ae039)(step)) + 1;
}


function $9754d5ef4ae75e6e$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $db27481a2c586ed3$export$81087d9b915d4ede)(start, stop, count), precision;
    specifier = (0, $8d787175e9f1e699$export$2e2bcd8739ae039)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $b964796478fe5fdb$export$2e2bcd8739ae039)(step, value))) specifier.precision = precision;
            return (0, $093e209ad44084f8$export$8d85692a469dde6f)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $6e3d737ad782ab2f$export$2e2bcd8739ae039)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $2d43e8cad1cbfc09$export$2e2bcd8739ae039)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $093e209ad44084f8$export$d9468344d3651243)(specifier);
}


function $ac80d87e25190b96$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $db27481a2c586ed3$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $9754d5ef4ae75e6e$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $db27481a2c586ed3$export$bc64d00cc98e7e95)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $ac80d87e25190b96$export$2e2bcd8739ae039() {
    var scale = (0, $cdaf693540c93821$export$2e2bcd8739ae039)();
    scale.copy = function() {
        return (0, $cdaf693540c93821$export$784d13d8ee351f07)(scale, $ac80d87e25190b96$export$2e2bcd8739ae039());
    };
    (0, $af0f60d7d428cc7a$export$23c7bb9e6558da2a).apply(scale, arguments);
    return $ac80d87e25190b96$export$16a5d4b4a61a274d(scale);
}





function $263642882ec4c1e0$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $05a287e75fbd2bd2$export$52baac22726c72bf)([
        document.querySelectorAll(selector)
    ], [
        document.documentElement
    ]) : new (0, $05a287e75fbd2bd2$export$52baac22726c72bf)([
        (0, $43b8b08c1b47c9a3$export$2e2bcd8739ae039)(selector)
    ], (0, $05a287e75fbd2bd2$export$e8e78c978b129247));
}


var $81de4af94902983c$export$58adb3bec8346d0f = Array.prototype.slice;
function $81de4af94902983c$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}


function $08595964676ff9e0$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}


function $92bac4f2e5a649e2$var$Linear(context) {
    this._context = context;
}
$92bac4f2e5a649e2$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $92bac4f2e5a649e2$export$2e2bcd8739ae039(context) {
    return new $92bac4f2e5a649e2$var$Linear(context);
}


const $c90edb9af1ba375e$var$pi = Math.PI, $c90edb9af1ba375e$var$tau = 2 * $c90edb9af1ba375e$var$pi, $c90edb9af1ba375e$var$epsilon = 1e-6, $c90edb9af1ba375e$var$tauEpsilon = $c90edb9af1ba375e$var$tau - $c90edb9af1ba375e$var$epsilon;
function $c90edb9af1ba375e$var$append(strings) {
    this._ += strings[0];
    for(let i = 1, n = strings.length; i < n; ++i)this._ += arguments[i] + strings[i];
}
function $c90edb9af1ba375e$var$appendRound(digits) {
    let d = Math.floor(digits);
    if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
    if (d > 15) return $c90edb9af1ba375e$var$append;
    const k = 10 ** d;
    return function(strings) {
        this._ += strings[0];
        for(let i = 1, n = strings.length; i < n; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
    };
}
class $c90edb9af1ba375e$export$4b2950bdac9b6ee9 {
    constructor(digits){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
        this._append = digits == null ? $c90edb9af1ba375e$var$append : $c90edb9af1ba375e$var$appendRound(digits);
    }
    moveTo(x, y) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._append`Z`;
        }
    }
    lineTo(x, y) {
        this._append`L${this._x1 = +x},${this._y1 = +y}`;
    }
    quadraticCurveTo(x1, y1, x, y) {
        this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
    }
    bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
    }
    arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._append`M${this._x1 = x1},${this._y1 = y1}`;
        else if (!(l01_2 > $c90edb9af1ba375e$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $c90edb9af1ba375e$var$epsilon) || !r) this._append`L${this._x1 = x1},${this._y1 = y1}`;
        else {
            let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($c90edb9af1ba375e$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $c90edb9af1ba375e$var$epsilon) this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
            this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
        }
    }
    arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._append`M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $c90edb9af1ba375e$var$epsilon || Math.abs(this._y1 - y0) > $c90edb9af1ba375e$var$epsilon) this._append`L${x0},${y0}`;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $c90edb9af1ba375e$var$tau + $c90edb9af1ba375e$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $c90edb9af1ba375e$var$tauEpsilon) this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
        else if (da > $c90edb9af1ba375e$var$epsilon) this._append`A${r},${r},0,${+(da >= $c90edb9af1ba375e$var$pi)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
    }
    rect(x, y, w, h) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
    }
    toString() {
        return this._;
    }
}
function $c90edb9af1ba375e$export$bb654e07daaf8c3a() {
    return new $c90edb9af1ba375e$export$4b2950bdac9b6ee9;
}
// Allow instanceof d3.path
$c90edb9af1ba375e$export$bb654e07daaf8c3a.prototype = $c90edb9af1ba375e$export$4b2950bdac9b6ee9.prototype;
function $c90edb9af1ba375e$export$e181c6ece8d9cc5f(digits = 3) {
    return new $c90edb9af1ba375e$export$4b2950bdac9b6ee9(+digits);
}


function $1260c7216e69c096$export$fb6e83118a5dcd45(shape) {
    let digits = 3;
    shape.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        return shape;
    };
    return ()=>new (0, $c90edb9af1ba375e$export$4b2950bdac9b6ee9)(digits);
}


function $a202512d6b0c5771$export$d141bba7fdc215a3(p) {
    return p[0];
}
function $a202512d6b0c5771$export$4a5767248b18ef41(p) {
    return p[1];
}


function $6664383897565d87$export$2e2bcd8739ae039(x, y) {
    var defined = (0, $08595964676ff9e0$export$2e2bcd8739ae039)(true), context = null, curve = (0, $92bac4f2e5a649e2$export$2e2bcd8739ae039), output = null, path = (0, $1260c7216e69c096$export$fb6e83118a5dcd45)(line);
    x = typeof x === "function" ? x : x === undefined ? (0, $a202512d6b0c5771$export$d141bba7fdc215a3) : (0, $08595964676ff9e0$export$2e2bcd8739ae039)(x);
    y = typeof y === "function" ? y : y === undefined ? (0, $a202512d6b0c5771$export$4a5767248b18ef41) : (0, $08595964676ff9e0$export$2e2bcd8739ae039)(y);
    function line(data) {
        var i, n = (data = (0, $81de4af94902983c$export$2e2bcd8739ae039)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = path());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $08595964676ff9e0$export$2e2bcd8739ae039)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $08595964676ff9e0$export$2e2bcd8739ae039)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $08595964676ff9e0$export$2e2bcd8739ae039)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}








var $da9f0a586366466f$var$epsilon2 = 1e-12;
function $da9f0a586366466f$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $da9f0a586366466f$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $da9f0a586366466f$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $da9f0a586366466f$export$2e2bcd8739ae039 = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $da9f0a586366466f$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $da9f0a586366466f$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $da9f0a586366466f$var$tanh(rho * s + r0) - $da9f0a586366466f$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $da9f0a586366466f$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);




var $fd347e1596901c32$export$2e2bcd8739ae039 = (x)=>()=>x;


function $01306c35ccfaa7eb$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $76dbf7a3a6ccfc96$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$76dbf7a3a6ccfc96$export$563a914cafbdc389.prototype = {
    constructor: $76dbf7a3a6ccfc96$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $76dbf7a3a6ccfc96$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $76dbf7a3a6ccfc96$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $76dbf7a3a6ccfc96$export$f0954fd7d5368655 = new $76dbf7a3a6ccfc96$export$563a914cafbdc389(1, 0, 0);
$76dbf7a3a6ccfc96$export$2e2bcd8739ae039.prototype = $76dbf7a3a6ccfc96$export$563a914cafbdc389.prototype;
function $76dbf7a3a6ccfc96$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $76dbf7a3a6ccfc96$export$f0954fd7d5368655;
    return node.__zoom;
}


function $a0775623abe0c15d$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $a0775623abe0c15d$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function $61ab383d0ce02f15$var$defaultFilter(event) {
    return (!event.ctrlKey || event.type === 'wheel') && !event.button;
}
function $61ab383d0ce02f15$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $61ab383d0ce02f15$var$defaultTransform() {
    return this.__zoom || (0, $76dbf7a3a6ccfc96$export$f0954fd7d5368655);
}
function $61ab383d0ce02f15$var$defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function $61ab383d0ce02f15$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $61ab383d0ce02f15$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $61ab383d0ce02f15$export$2e2bcd8739ae039() {
    var filter = $61ab383d0ce02f15$var$defaultFilter, extent = $61ab383d0ce02f15$var$defaultExtent, constrain = $61ab383d0ce02f15$var$defaultConstrain, wheelDelta = $61ab383d0ce02f15$var$defaultWheelDelta, touchable = $61ab383d0ce02f15$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $da9f0a586366466f$export$2e2bcd8739ae039), listeners = (0, $cb0cee1ac6170bcd$export$2e2bcd8739ae039)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
    function zoom(selection) {
        selection.property("__zoom", $61ab383d0ce02f15$var$defaultTransform).on("wheel.zoom", wheeled, {
            passive: false
        }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point, event) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $61ab383d0ce02f15$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point, event);
        else selection.interrupt().each(function() {
            gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p, event) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p, event);
    };
    zoom.scaleTo = function(selection, k, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p, event);
    };
    zoom.translateBy = function(selection, x, y, event) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        }, null, event);
    };
    zoom.translateTo = function(selection, x, y, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $76dbf7a3a6ccfc96$export$f0954fd7d5368655).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p, event);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $76dbf7a3a6ccfc96$export$563a914cafbdc389)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $76dbf7a3a6ccfc96$export$563a914cafbdc389)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point, event) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).event(event).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).event(event).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $76dbf7a3a6ccfc96$export$563a914cafbdc389)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.sourceEvent = null;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        event: function(event) {
            if (event) this.sourceEvent = event;
            return this;
        },
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            var d = (0, $212a85cfc656869b$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $01306c35ccfaa7eb$export$2e2bcd8739ae039)(type, {
                sourceEvent: this.sourceEvent,
                target: zoom,
                type: type,
                transform: this.that.__zoom,
                dispatch: listeners
            }), d);
        }
    };
    function wheeled(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $0f410bdad463c15a$export$2e2bcd8739ae039)(event);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $244473f94df4a7bf$export$2e2bcd8739ae039)(this);
            g.start();
        }
        (0, $a0775623abe0c15d$export$2e2bcd8739ae039)(event);
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned(event, ...args) {
        if (touchending || !filter.apply(this, arguments)) return;
        var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = (0, $212a85cfc656869b$export$2e2bcd8739ae039)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $0f410bdad463c15a$export$2e2bcd8739ae039)(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
        (0, $53c33dda764ea7c9$export$2e2bcd8739ae039)(event.view);
        (0, $a0775623abe0c15d$export$2e2561858db9bf47)(event);
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $244473f94df4a7bf$export$2e2bcd8739ae039)(this);
        g.start();
        function mousemoved(event) {
            (0, $a0775623abe0c15d$export$2e2bcd8739ae039)(event);
            if (!g.moved) {
                var dx = event.clientX - x0, dy = event.clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $0f410bdad463c15a$export$2e2bcd8739ae039)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped(event) {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $53c33dda764ea7c9$export$833237748009e1e1)(event.view, g.moved);
            (0, $a0775623abe0c15d$export$2e2bcd8739ae039)(event);
            g.event(event).end();
        }
    }
    function dblclicked(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $0f410bdad463c15a$export$2e2bcd8739ae039)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
        (0, $a0775623abe0c15d$export$2e2bcd8739ae039)(event);
        if (duration > 0) (0, $212a85cfc656869b$export$2e2bcd8739ae039)(this).transition().duration(duration).call(schedule, t1, p0, event);
        else (0, $212a85cfc656869b$export$2e2bcd8739ae039)(this).call(zoom.transform, t1, p0, event);
    }
    function touchstarted(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
        (0, $a0775623abe0c15d$export$2e2561858db9bf47)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $0f410bdad463c15a$export$2e2bcd8739ae039)(t, this);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $244473f94df4a7bf$export$2e2bcd8739ae039)(this);
            g.start();
        }
    }
    function touchmoved(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
        (0, $a0775623abe0c15d$export$2e2bcd8739ae039)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $0f410bdad463c15a$export$2e2bcd8739ae039)(t, this);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
        (0, $a0775623abe0c15d$export$2e2561858db9bf47)(event);
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                t = (0, $0f410bdad463c15a$export$2e2bcd8739ae039)(t, this);
                if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                    var p = (0, $212a85cfc656869b$export$2e2bcd8739ae039)(this).on("dblclick.zoom");
                    if (p) p.apply(this, arguments);
                }
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $fd347e1596901c32$export$2e2bcd8739ae039)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $fd347e1596901c32$export$2e2bcd8739ae039)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $fd347e1596901c32$export$2e2bcd8739ae039)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $fd347e1596901c32$export$2e2bcd8739ae039)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    zoom.tapDistance = function(_) {
        return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
    };
    return zoom;
}







const $99083ef44e423f70$export$2bbbe2756ad57c66 = function(target, plotSettings) {
    const { plot_id: plot_id, width: width, height: height, padding: padding, xMax: xMax, yMax: yMax, outClass: outClass, textClass: textClass } = plotSettings;
    const zoom = $61ab383d0ce02f15$export$2e2bcd8739ae039().scaleExtent([
        1,
        20
    ]) // This control how much you can unzoom (x0.5) and zoom (x20)
    .translateExtent([
        [
            0,
            0
        ],
        [
            width * 3,
            height
        ]
    ])//.extent([[0, 0], [PLOT_WIDTH, height]])
    .on('zoom', updateChart);
    // X tengely skála
    const xScale = $ac80d87e25190b96$export$2e2bcd8739ae039().domain([
        0,
        xMax
    ]).range([
        padding,
        width - padding
    ]);
    //Y tengely skála
    const yScale = $ac80d87e25190b96$export$2e2bcd8739ae039().domain([
        0,
        yMax
    ]).range([
        height - padding,
        padding
    ]);
    //SVG létrehozás
    $263642882ec4c1e0$export$2e2bcd8739ae039('svg').remove();
    const svg = $212a85cfc656869b$export$2e2bcd8739ae039(target).append('svg').attr('width', width).attr('height', height).attr('id', plot_id).attr('class', outClass);
    //X tengely létrehozás
    const xAxis = svg.append('g').attr('transform', 'translate(0,' + (height - padding) + ')').attr('class', `x-axis ${textClass}`).call($d85dbadc51fe476f$export$e5cb22533a15e72e(xScale));
    //Y tengely létrehozás
    const yAxis = svg.append('g').attr('transform', 'translate(' + padding + ',0)').attr('class', `y-axis ${textClass}`).call($d85dbadc51fe476f$export$2749afb169a520d2(yScale));
    function resetChart() {
        zoom.transform(svg, $76dbf7a3a6ccfc96$export$f0954fd7d5368655);
    }
    // tengely feliratok
    //x
    svg.append('text').attr('transform', 'translate(' + width / 2 + ' ,' + (height - padding / 4) + ')').attr('class', textClass).style('text-anchor', 'middle').text('Retention Time [min]');
    // y
    svg.append('text').attr('transform', 'rotate(-90)').attr('y', 0).attr('x', 0 - height / 2 + padding).attr('dy', '1em').style('text-anchor', 'middle').attr('class', textClass).text('Concentration [mg/ml]');
    const clip = svg.append('defs').append('SVG:clipPath').attr('id', 'clip').append('SVG:rect').attr('width', width - 2 * padding).attr('height', height - 2 * padding).attr('x', padding).attr('y', padding);
    const scatter = svg.append('g').attr('id', 'scatter').attr('clip-path', 'url(#clip)').call(zoom).on('dblclick.zoom', resetChart);
    function updateChart(event) {
        // recover the new scale
        const newX = event.transform.rescaleX(xScale);
        const newY = event.transform.rescaleY(yScale);
        // update axes with these new boundaries
        xAxis.call($d85dbadc51fe476f$export$e5cb22533a15e72e(newX));
        yAxis.call($d85dbadc51fe476f$export$2749afb169a520d2(newY));
        scatter.selectAll('path').attr('transform', event.transform);
        scatter.selectAll('circle').attr('transform', event.transform);
        scatter.selectAll('.labels').attr('transform', event.translate);
    }
};
const $99083ef44e423f70$export$7b3b530b37ddd649 = (name, datapoints, curveId, type, plotSettings)=>{
    const { plot_id: plot_id, width: width, height: height, colors: colors, textClass: textClass, padding: padding, xMax: xMax, yMax: yMax } = plotSettings;
    const svg = $212a85cfc656869b$export$2e2bcd8739ae039(`#${plot_id}`);
    // X tengely skála
    const xScale = $ac80d87e25190b96$export$2e2bcd8739ae039().domain([
        0,
        xMax
    ]).range([
        padding,
        width - padding
    ]);
    //Y tengely skála
    const yScale = $ac80d87e25190b96$export$2e2bcd8739ae039().domain([
        0,
        yMax
    ]).range([
        height - padding,
        padding
    ]);
    // const lineGenerator = d3
    //   .line()
    //   .x(function (d) {
    //     return xScale(d[0]);
    //   })
    //   .y(function (d) {
    //     return yScale(d[1]);
    //   });
    // //.curve(d3.curveCardinal);
    const scatter = svg.select('#scatter');
    const curve = scatter.append('g').attr('transform', function(d, i) {
        return 'translate(0,0)';
    }).attr('class', 'g_curves').attr('id', `g_curve_${name}`);
    if (type === 'line') curve.append('path').datum(datapoints).attr('fill', 'none').attr('stroke', colors[curveId]).attr('stroke-width', 0.5).attr('d', $6664383897565d87$export$2e2bcd8739ae039().x((d)=>xScale(d[0])).y((d)=>yScale(d[1])));
    if (type === 'path') curve.append('path').datum(datapoints).attr('class', 'compound').attr('d', $6664383897565d87$export$2e2bcd8739ae039().x((d)=>xScale(d[0])).y((d)=>yScale(d[1]))).style('fill', colors[curveId]).style('opacity', '80%').style('stroke', colors[0]).style('stroke-width', 0.25).style('stroke-linejoin', 'round');
    // .on('mouseover', onMouseOver)
    // .on('mouseout', onMouseOut)
    const legend = svg.append('g').attr('class', 'legend');
    legend.append('circle').attr('cx', width - padding - 150).attr('cy', padding + 10 + curveId * 25).attr('r', 6).style('fill', colors[curveId]);
    legend.append('text').attr('x', width - padding - 130).attr('y', padding + 10 + curveId * 25).attr('class', textClass).attr('alignment-baseline', 'middle').text(name).style('font-size', '1.2rem').style('opacity', '100%');
};
function $99083ef44e423f70$var$onMouseOver(d, i) {
    $212a85cfc656869b$export$2e2bcd8739ae039(this).style('opacity', '100%');
    $212a85cfc656869b$export$2e2bcd8739ae039(this.parentNode).selectAll('text').style('opacity', '100%');
    $212a85cfc656869b$export$2e2bcd8739ae039(this.parentNode).selectAll('rect').style('opacity', '100%');
}
function $99083ef44e423f70$var$onMouseOut(d, i) {
    $212a85cfc656869b$export$2e2bcd8739ae039(this).style('opacity', '75%');
    $212a85cfc656869b$export$2e2bcd8739ae039(this.parentNode).selectAll('text').style('opacity', '0%');
    $263642882ec4c1e0$export$2e2bcd8739ae039('.labels').style('opacity', '100%');
    $212a85cfc656869b$export$2e2bcd8739ae039(this.parentNode).selectAll('rect').style('opacity', '0%');
}
const $99083ef44e423f70$export$3f29bba4d5d998ed = (targetPlot)=>{
    const svg = $212a85cfc656869b$export$2e2bcd8739ae039(`#${targetPlot}`);
    svg.selectAll('.g_curves').remove();
    svg.selectAll('.legend').remove();
};
const $99083ef44e423f70$export$a6e8031964c4ff10 = (target, plot, compoundNames)=>{
    const options = [
        'overlay'
    ].concat(compoundNames);
    const select = $212a85cfc656869b$export$2e2bcd8739ae039(`${target}`);
    select.selectAll('.view-options').remove();
    select.selectAll('view-selector').data(options).enter().append('option').text(function(d) {
        return d;
    }) // text showed in the menu
    .attr('value', function(d) {
        return d;
    }).attr('class', 'view-options');
    $212a85cfc656869b$export$2e2bcd8739ae039(`${target}`).on('change', function(d) {
        // recover the option that has been chosen
        const selectedOption = $212a85cfc656869b$export$2e2bcd8739ae039(this).property('value');
        // run the updateChart function with this selected option
        update(selectedOption);
    });
    const update = (selectedOption)=>{
        //console.log(selectedOption);
        const svg = $212a85cfc656869b$export$2e2bcd8739ae039(`#${plot}`);
        if (selectedOption === 'overlay') svg.selectAll('.g_curves').style('opacity', '100%');
        else {
            svg.selectAll('.g_curves').style('opacity', '0%');
            //console.log(svg.selectAll('.g_curves'));
            svg.selectAll(`#g_curve_${selectedOption}`).style('opacity', '100%');
        }
    };
};
const $99083ef44e423f70$export$ec11cbed69d669e9 = (targetPlot, newY, height, padding)=>{
    const svg = $212a85cfc656869b$export$2e2bcd8739ae039(`#${targetPlot}`);
    const yScale = $ac80d87e25190b96$export$2e2bcd8739ae039().domain([
        0,
        newY
    ]).range([
        height - padding,
        padding
    ]);
    svg.select('.y-axis').call($d85dbadc51fe476f$export$2749afb169a520d2(yScale));
};
const $99083ef44e423f70$export$dd122e43ff938998 = (fractions, plotSettings)=>{
    const { plot_id: plot_id, width: width, height: height, padding: padding, xMax: xMax, yMax: yMax } = plotSettings;
    const svg = $212a85cfc656869b$export$2e2bcd8739ae039(`#${plot_id}`);
    svg.selectAll('.fr').remove();
    // X tengely skála
    const xScale = $ac80d87e25190b96$export$2e2bcd8739ae039().domain([
        0,
        xMax
    ]).range([
        padding,
        width - padding
    ]);
    //Y tengely skála
    const yScale = $ac80d87e25190b96$export$2e2bcd8739ae039().domain([
        0,
        yMax
    ]).range([
        height - padding,
        padding
    ]);
    const frLines = svg.append('g').attr('class', 'fr');
    fractions.forEach((element)=>{
        if (element[2]) frLines.append('rect').attr('x', xScale(element[0])).attr('y', yScale(yMax)).attr('width', xScale(element[1]) - xScale(element[0])).attr('height', height - 2 * padding).attr('stroke', 'black').attr('fill', '#25bdad').style('opacity', '20%');
        frLines.append('rect').attr('x', xScale(element[0])).attr('y', yScale(yMax)).attr('width', xScale(element[1]) - xScale(element[0])).attr('height', height - 2 * padding).attr('stroke', 'black').attr('fill', '#69a3b2').style('opacity', '5%');
    //.on("click", selFR);
    });
};
const $99083ef44e423f70$export$264a78fb3a6cde6f = (plotSettings)=>{
    const { plot_id: plot_id } = plotSettings;
    const svg = $212a85cfc656869b$export$2e2bcd8739ae039(`#${plot_id}`);
    svg.selectAll('.fr').remove();
};
const $99083ef44e423f70$export$3879f6c5439d8140 = (methodSettings, plotSettings)=>{
    const { plot_id: plot_id, width: width, height: height, padding: padding, xMax: xMax, yMax: yMax } = plotSettings;
    const svg = $212a85cfc656869b$export$2e2bcd8739ae039(`#${plot_id}`);
    // X tengely skála
    const xScale = $ac80d87e25190b96$export$2e2bcd8739ae039().domain([
        0,
        xMax
    ]).range([
        padding,
        width - padding
    ]);
    //Y tengely skála
    const yScale = $ac80d87e25190b96$export$2e2bcd8739ae039().domain([
        0,
        yMax
    ]).range([
        height - padding,
        padding
    ]);
    if (methodSettings.method == 'ex') {
        svg.selectAll('.exLines').remove();
        const exLines = svg.append('g').attr('class', 'exLines');
        exLines.append('line').attr('x1', xScale(methodSettings.tsw + methodSettings.t0)).attr('y1', yScale(0)).attr('x2', xScale(methodSettings.tsw + methodSettings.t0)).attr('y2', yScale(yMax)).style('stroke-width', 1).style('stroke', 'grey').style('fill', 'none');
        exLines.append('line').attr('x1', xScale(methodSettings.tss + methodSettings.t0)).attr('y1', yScale(0)).attr('x2', xScale(methodSettings.tss + methodSettings.t0)).attr('y2', yScale(yMax)).style('stroke-width', 1).style('stroke', 'grey').style('fill', 'none');
    }
};


// visualizer.js
// ============================================================================
// CPC Visualizer – logika a frontenden
// - UI frakciók kezelése
// - módszer beállítások olvasása (t0, tss, stb.)
// - komponensek beolvasása és backend számítás meghívása
// - csúcsparaméterek számítása + t0 korrekció
// - frakció integrálás (jelenlegi: fix lépcső, baloldali kvadratúra)
// - DUPLIKÁCIÓ ELLENI VÉDELEM: UI-lock + stale guard + AbortController
// ============================================================================


/* ============================================================================
   FUTÁS-KEZELŐ: UI-lock + stale guard + AbortController
   ----------------------------------------------------------------------------
   Miért kell?
   - Gyors egymás utáni input-eventek (pl. dead volume slider) több párhuzamos
     számítást indítanak → régi futások később írhatnak a DOM-ra → "duplázódás".
   Mit csinál?
   - beginRun(): leállítja az előző kérést, letiltja a UI-t, új runId/Abort signal
   - endRun(runId): csak a legfrissebb futás enged vissza UI-t
   - isLatestRun(runId): DOM-írás előtt ellenőrzés
   ========================================================================== */ // "14,29" → 14.29; trim; NaN esetén 0
const $ae486093709f123f$var$toNum = (v)=>{
    const n = Number(String(v ?? '').replace(',', '.').trim());
    return Number.isFinite(n) ? n : 0;
};
let $ae486093709f123f$var$__currentController = null;
let $ae486093709f123f$var$__currentRunId = 0;
let $ae486093709f123f$var$__isBusy = false;
const $ae486093709f123f$var$__disableUI = ()=>{
    if ($ae486093709f123f$var$__isBusy) return;
    $ae486093709f123f$var$__isBusy = true;
    document.querySelectorAll('.form__input--visualizer, .mass-prop-input, .btn, button, input[type="button"]').forEach((el)=>{
        el.disabled = true;
    });
    document.body.classList.add('busy-cursor'); // opcionális CSS: .busy-cursor, cursor: progress;
};
const $ae486093709f123f$var$__enableUI = ()=>{
    $ae486093709f123f$var$__isBusy = false;
    document.querySelectorAll('.form__input--visualizer, .mass-prop-input, .btn, button, input[type="button"]').forEach((el)=>{
        el.disabled = false;
    });
    document.body.classList.remove('busy-cursor');
};
const $ae486093709f123f$export$b6fb01e4bd9236ad = ()=>{
    if ($ae486093709f123f$var$__currentController) try {
        $ae486093709f123f$var$__currentController.abort(); // lelövi a futó HTTP-kéréseket
    } catch  {
    /* no-op */ }
    $ae486093709f123f$var$__currentController = new AbortController();
    $ae486093709f123f$var$__currentRunId += 1;
    $ae486093709f123f$var$__disableUI();
    return {
        runId: $ae486093709f123f$var$__currentRunId,
        signal: $ae486093709f123f$var$__currentController.signal
    };
};
const $ae486093709f123f$export$8b68d1c27cfb577e = (runId)=>{
    // Csak a legfrissebb futás oldhatja fel a UI-t
    if (runId !== $ae486093709f123f$var$__currentRunId) return;
    $ae486093709f123f$var$__enableUI();
};
const $ae486093709f123f$export$af0757c74f7ffed2 = (runId)=>runId === $ae486093709f123f$var$__currentRunId;
/* ============================================================================
   Helper: új frakció sor HTML-je
   ========================================================================== */ const $ae486093709f123f$var$newFraction = (ID, nComp, time)=>{
    let NF = `<tr class="fractions" id="row_${ID}">
<td>Fraction ${ID + 1}</td>
<td><input type="number" name="startTime" id="st_${ID}" class="start-time form__input form__input--visualizer" step="0.1" value="${(ID * time).toFixed(1)}"></td>
<td><input type="number" name="endTime" id="et_${ID}" class="end-time form__input form__input--visualizer" step="0.1" value="${((ID + 1) * time).toFixed(1)}"></td>`;
    for(let index = 0; index < nComp; index++)NF += `<td id="cFR_${ID}_${index}"></td>`;
    // Helyes: nincs "unchecked" attribútum
    NF += `<td><input type="checkbox" name="fraction_selected" class="fraction-selctor" id="frSel_${ID}"></td></tr>`;
    return NF;
};
/* ============================================================================
   Mass proportion normalizálás (Σ=1)
   - A táblázat "concentration" mezői tömegarányt tartalmaznak (nem mg/ml, nem %).
   - Itt normalizáljuk Σ=1-re, és ebből számoljuk a tényleges injektált mg-okat.
   ========================================================================== */ const $ae486093709f123f$var$readMassProportions = (rows)=>{
    const props = [];
    for (const r of rows){
        const raw = r.querySelector('input[name="concentration"]')?.value;
        let p = $ae486093709f123f$var$toNum(raw);
        if (p < 0) p = 0;
        props.push(p);
    }
    const sum = props.reduce((s, x)=>s + x, 0);
    if (sum <= 0) {
        const eq = 1 / Math.max(1, props.length);
        return props.map(()=>eq);
    }
    return props.map((p)=>p / sum);
};
/* ============================================================================
   UI: normalizált w/w% kiírása az input melletti spanba
   ========================================================================== */ const $ae486093709f123f$var$updateMassPercentUI = (rows, fractions)=>{
    Array.from(rows).forEach((r, idx)=>{
        const span = r.querySelector('.mass-prop-percent');
        if (!span) return;
        const p = fractions[idx] * 100; // fi ∈ [0..1] → %
        span.textContent = `${p.toLocaleString('hu-HU', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })} %`;
    });
};
const $ae486093709f123f$export$111505ab5aab402f = (compounds, settings, plotSettings, runId)=>{
    const b = document.getElementById('btnCreateFr');
    const frTableBody = document.getElementById('fraction_tablebody');
    const fractionTime = Math.floor(settings.runtime / 9);
    // Ez az event egyszerre többször ne drótozódjon fel
    b.replaceWith(b.cloneNode(true));
    const b2 = document.getElementById('btnCreateFr');
    b2.addEventListener('click', ()=>{
        if (!$ae486093709f123f$export$af0757c74f7ffed2(runId)) return; // stale védelem
        const head = document.querySelector('#fraction_table thead tr');
        head.innerHTML = '<th>Fraction</th><th>Start Time</th><th>End Time</th>';
        compounds.forEach((c)=>{
            const compoundHeading = document.createElement('th');
            compoundHeading.innerHTML = c.compoundName;
            head.appendChild(compoundHeading);
        });
        const selectHeading = document.createElement('th');
        selectHeading.innerHTML = 'Selected';
        head.appendChild(selectHeading);
        let bodyContent = '';
        for(let index = 0; index < 9; index++)bodyContent += $ae486093709f123f$var$newFraction(index, compounds.length, fractionTime.toFixed(1));
        frTableBody.innerHTML = bodyContent;
        const startTimes = document.querySelectorAll('.start-time');
        const endTimes = document.querySelectorAll('.end-time');
        const selectSwitch = document.querySelectorAll('.fraction-selctor');
        const lastId = startTimes.length - 1;
        for (const startTime of startTimes)startTime.addEventListener('input', (ev)=>{
            if (!$ae486093709f123f$export$af0757c74f7ffed2(runId)) return;
            const idx = ev.target.id.substring(3) * 1;
            const end = endTimes[idx];
            const prevEnd = idx > 0 ? endTimes[idx - 1].value : 0;
            end.setAttribute('min', ev.target.value);
            ev.target.setAttribute('max', end.value);
            ev.target.setAttribute('min', prevEnd);
            $99083ef44e423f70$export$dd122e43ff938998($ae486093709f123f$export$f744eee275aeedf9(compounds, settings), plotSettings);
            $ae486093709f123f$var$updateContent(compounds, settings, runId);
        });
        for (const endTime of endTimes)endTime.addEventListener('input', (ev)=>{
            if (!$ae486093709f123f$export$af0757c74f7ffed2(runId)) return;
            const idx = ev.target.id.substring(3) * 1;
            const start = startTimes[idx];
            if (idx === lastId) {
                ev.target.value = settings.runtime;
                ev.target.setAttribute('max', settings.runtime);
            } else {
                const nextStart = startTimes[idx + 1];
                nextStart.setAttribute('min', ev.target.value);
                ev.target.setAttribute('max', nextStart.value);
            }
            start.setAttribute('max', ev.target.value);
            ev.target.setAttribute('min', start.value);
            $99083ef44e423f70$export$dd122e43ff938998($ae486093709f123f$export$f744eee275aeedf9(compounds, settings), plotSettings);
            $ae486093709f123f$var$updateContent(compounds, settings, runId);
        });
        for (const s of selectSwitch)s.addEventListener('input', (ev)=>{
            // újrarajzolás
            $99083ef44e423f70$export$dd122e43ff938998($ae486093709f123f$export$f744eee275aeedf9(compounds, settings), plotSettings);
            const row = ev.target.closest('tr');
            if (row) row.style.background = ev.target.checked ? '#25bdad' : '#fff';
            // --- Summary panel biztosítása ---
            let summary = document.querySelector('.results');
            if (!summary) {
                // ha nincs, létrehozzuk és betesszük a frakciós dobozba
                const host = document.querySelector('.fraction-table') || document.body;
                summary = document.createElement('div');
                summary.className = 'results';
                summary.style.display = 'none';
                summary.innerHTML = `
        <div class="white-box" style="margin-top:12px">
          <h3>Selection summary</h3>
          <table class="table" id="summary-table">
            <thead>
              <tr>
                <th>Compound</th>
                <th>Injected (mg)</th>
                <th>Purity %</th>
                <th>Recovery %</th>
              </tr>
            </thead>
            <tbody></tbody>
          </table>
        </div>`;
                host.appendChild(summary);
            }
            // most már biztosan létezik
            summary.style.display = 'block';
            // --- kiválasztott frakciók eredményeinek számítása ---
            const selected = $ae486093709f123f$export$f744eee275aeedf9(compounds, settings).filter((d)=>d[2] === true);
            const results = [];
            for(let index = 0; index < compounds.length; index++){
                const compound = compounds[index];
                let recovered = 0;
                let total = 0;
                for(let i = 0; i < selected.length; i++){
                    recovered += selected[i][3][index][1][0];
                    total += selected[i][3][index][1][1];
                }
                results.push({
                    name: compound.compoundName,
                    purity: total > 0 ? recovered / total * 100 : 0,
                    recovery: compound.injAmount > 0 ? recovered * settings.flowRate / compound.injAmount * 100 : 0
                });
            }
            // táblázat feltöltése
            $ae486093709f123f$var$createSummary(results, compounds, settings);
        });
        if (!$ae486093709f123f$export$af0757c74f7ffed2(runId)) return;
        $99083ef44e423f70$export$dd122e43ff938998($ae486093709f123f$export$f744eee275aeedf9(compounds, settings), plotSettings);
        $ae486093709f123f$var$updateContent(compounds, settings, runId);
        b2.innerHTML = 'Reset fractions';
    });
};
const $ae486093709f123f$export$ccaf620e324f9da8 = ()=>{
    const flow = $ae486093709f123f$var$toNum(document.getElementById('flow-rate')?.value);
    const sfVal = $ae486093709f123f$var$toNum(document.getElementById('sf')?.value);
    const colVol = $ae486093709f123f$var$toNum(document.getElementById('column-volume')?.value);
    const deadVol = $ae486093709f123f$var$toNum(document.getElementById('dead-volume')?.value);
    const injVol = $ae486093709f123f$var$toNum(document.getElementById('injection-volume')?.value);
    const totConc = $ae486093709f123f$var$toNum(document.getElementById('total-concentration')?.value);
    const swMin = $ae486093709f123f$var$toNum(document.getElementById('switch-time')?.value);
    const runtime = $ae486093709f123f$var$toNum(document.getElementById('runtime')?.value);
    const Vcm = swMin * flow;
    const Vss = Vcm + (1 - sfVal / 100) * colVol;
    const tss = Vss / flow;
    const settings = {
        instrument: document.getElementById('instrument')?.value,
        columnVolume: colVol,
        sf: sfVal,
        flowRate: flow,
        mode: document.getElementById('mode')?.value,
        injectionVolume: injVol,
        sampleSolvent: document.getElementById('sample-solvent')?.value,
        totalConcentration: totConc,
        threshold: 0.01,
        method: document.getElementById('method')?.value,
        tsw: swMin,
        tss: tss,
        v0: deadVol,
        t0: flow > 0 ? deadVol / flow : 0
    };
    settings.totalAmount = injVol * totConc;
    settings.CELLS = 100;
    settings.tc = flow > 0 ? colVol / flow : 0;
    settings.dt = flow > 0 ? colVol * (1 - settings.sf / 100) / (settings.CELLS * flow) : 0;
    settings.runtime = runtime;
    return settings;
};
const $ae486093709f123f$export$c714d954d0ae1a89 = (id)=>{
    const table = document.getElementById('compounds-table');
    const newRow = table.insertRow(-1);
    newRow.id = `row-${id}`;
    newRow.innerHTML = `
    <td>
      <input type="text" name="compound-name" id="compound-${id}"
             class="table-input table-input--text" value="compound-${id + 1}">
    </td>

    <td>
      <input type="number" name="partition-coefficient" id="kd-${id}"
             class="table-input" min="0" max="10" step="0.1" value="1">
    </td>

    <!-- Mass proportion (w/w) \u{2192} egy darab input + a normaliz\xe1lt %-span -->
    <td>
      <div class="mass-prop-cell">
        <input type="number" name="concentration" id="concentration-${id}"
               class="table-input mass-prop-input" min="0" step="0.1" value="10">
        <span class="mass-prop-percent">(\u{2013} %)</span>
      </div>
    </td>

    <!-- Injected amount (mg) \u{2013} JS t\xf6lti ki -->
    <td>
      <div class="inj-amount" id="inj-amount-${id}">mg</div>
    </td>

    <td>
      <input type="number" class="table-input" name="solubility-up"
             id="sol-up-${id}" min="0" step="0.1" value="100">
    </td>

    <td>
      <input type="number" class="table-input" name="solubility-lp"
             id="sol-lp-${id}" min="0" step="0.1" value="100">
    </td>

    <td>
      <input type="button" value="Remove" id="delete-${id}"
             class="btn btn--blue btn--ct delete-btn">
    </td>
  `;
};
const $ae486093709f123f$export$d1e5b04bb29aee87 = async (compound, methodSettings, signal)=>{
    const res = await (0, $040e0e9a6d6c1341$export$2e2bcd8739ae039)({
        method: 'POST',
        url: '/api/calc',
        data: {
            compound: compound,
            methodSettings: methodSettings
        },
        withCredentials: true,
        signal: signal // <-- fontos: így megszakítható
    });
    if (res.data.status === 'success') return res.data.data; // [[t, c], ...] – t még t0 nélkül
    return [];
};
const $ae486093709f123f$export$c519fe7abce53a39 = async (compound, settings, signal)=>{
    const res = await (0, $040e0e9a6d6c1341$export$2e2bcd8739ae039)({
        method: 'POST',
        url: '/api/calc/analyse',
        data: {
            compound: compound,
            settings: settings
        },
        withCredentials: true,
        signal: signal // <-- fontos
    });
    if (res.data.status === 'success') return res.data.data;
    return null;
};
/* ============================================================================
   Segédfüggvények: csúcsparaméterek (t0-val korrigált RT)
   ========================================================================== */ const $ae486093709f123f$var$extractColumn = (arr, column)=>arr.map((x)=>x[column]);
const $ae486093709f123f$export$f864d8c98b8d9d6b = (compound, settings)=>{
    const height = Math.max(...$ae486093709f123f$var$extractColumn(compound.dataPoints, 1));
    const vr = settings.columnVolume * (1 + (compound.partitionCoefficient - 1) * settings.sf / 100);
    const rt = vr / settings.flowRate + settings.t0; // ✅ t0 hozzáadása
    return {
        height: height,
        vr: vr,
        rt: rt
    };
};
const $ae486093709f123f$export$648a8d2aa643424b = ()=>{
    document.getElementById('instrument').addEventListener('change', ()=>{
        const instrument = document.getElementById('instrument').value;
        if (instrument === 'labCPC') {
            document.getElementById('column-volume').value = 250;
            document.getElementById('sf').value = 80;
            document.getElementById('flow-rate').value = 20;
            document.getElementById('injection-volume').value = 10;
        }
        if (instrument === 'rCPC') {
            document.getElementById('column-volume').value = 2150;
            document.getElementById('sf').value = 80;
            document.getElementById('flow-rate').value = 220;
            document.getElementById('injection-volume').value = 80;
        }
        if (instrument === 'iCPC') {
            document.getElementById('column-volume').value = 22500;
            document.getElementById('sf').value = 80;
            document.getElementById('flow-rate').value = 2200;
            document.getElementById('injection-volume').value = 800;
        }
    });
};
const $ae486093709f123f$export$d298918d4e7cbf62 = ()=>{
    const sf = document.getElementById('sf');
    if (sf) sf.addEventListener('change', ()=>{
        document.querySelector('.sf-label').innerText = `${sf.value}%`;
    });
};
const $ae486093709f123f$export$8328d9d0a4c692ee = async (compoundTable, settings, signal, runId)=>{
    const compounds = [];
    const rows = compoundTable.querySelectorAll('tbody tr');
    // fi ∈ [0..1], Σ fi = 1
    const fractions = $ae486093709f123f$var$readMassProportions(rows);
    const totalInjectedMg = $ae486093709f123f$var$toNum(settings.injectionVolume) * $ae486093709f123f$var$toNum(settings.totalConcentration);
    let rowIdx = 0;
    for (const r of rows){
        // --- Kd beolvasás + üzemmód ---
        const kdInput = $ae486093709f123f$var$toNum(r.querySelector('input[name="partition-coefficient"]')?.value);
        let partitionCoefficient = kdInput;
        if (settings.mode === 'asc' && kdInput > 0) partitionCoefficient = 1 / kdInput; // ASC módban 1/Kd
        // --- meta ---
        const compoundName = (r.querySelector('input[name="compound-name"]')?.value || '').trim();
        const solubilityUp = $ae486093709f123f$var$toNum(r.querySelector('input[name="solubility-up"]')?.value);
        const solubilityLp = $ae486093709f123f$var$toNum(r.querySelector('input[name="solubility-lp"]')?.value);
        // --- normalizált hányad és injektált tömeg ---
        const fi = $ae486093709f123f$var$toNum(fractions[rowIdx]); // 0..1
        const injAmount = fi * totalInjectedMg; // mg
        // UI: injektált mg kiírása
        const injDiv = r.querySelector('div.inj-amount');
        if (injDiv) injDiv.innerText = `${injAmount.toFixed(2)} mg`;
        // --- compound objektum ---
        const compound = {
            compoundName: compoundName,
            partitionCoefficient: partitionCoefficient,
            k: partitionCoefficient,
            concentration: fi,
            solubilityUp: solubilityUp,
            solubilityLp: solubilityLp,
            injAmount: injAmount
        };
        // Backend datapontok → t0 hozzáadása
        const rawPoints = await $ae486093709f123f$export$d1e5b04bb29aee87(compound, settings, signal);
        if (!$ae486093709f123f$export$af0757c74f7ffed2(runId)) return []; // ha közben új futás indult, ne folytassuk
        compound.dataPoints = rawPoints.map(([t, c])=>[
                $ae486093709f123f$var$toNum(t) + $ae486093709f123f$var$toNum(settings.t0),
                $ae486093709f123f$var$toNum(c)
            ]);
        // Csúcsparaméterek
        const { height: height, vr: vr, rt: rt } = $ae486093709f123f$export$f864d8c98b8d9d6b(compound, settings);
        compound.height = height;
        compound.vr = vr;
        compound.rt = rt;
        compounds.push(compound);
        rowIdx += 1;
    }
    // GUI: normalizált %-ok kiírása
    $ae486093709f123f$var$updateMassPercentUI(rows, fractions);
    return compounds;
};
const $ae486093709f123f$export$23bb8f513680c73d = (compounds, runId)=>{
    if (!$ae486093709f123f$export$af0757c74f7ffed2(runId)) return;
    const tbody = document.querySelector('#peak-details tbody');
    if (!tbody) return;
    // 1) Biztos törlés
    tbody.replaceChildren();
    // 2) Új sorok beszúrása
    for (const compound of compounds){
        const tr = document.createElement('tr');
        tr.innerHTML = `
      <td>${compound.compoundName}</td>
      <td>${(compound.rt ?? 0).toFixed(2)}</td>
      <td>${(compound.vr ?? 0).toFixed(2)}</td>
      <td>${compound.widthVolume?.toFixed ? compound.widthVolume.toFixed(2) : 'N.A.'}</td>
      <td>${compound.thPlates?.toFixed ? compound.thPlates.toFixed(0) : 'N.A.'}</td>
      <td>${compound.rsNext ? compound.rsNext.toFixed(2) : 'N.A.'}</td>
    `;
        tbody.appendChild(tr);
    }
};
const $ae486093709f123f$export$bc0946f73995bccf = (compounds)=>{
    const pA = compounds.map((e)=>e.peakApex).slice().sort((a, b)=>a - b);
    let order = 1;
    for(let i = 0; i < pA.length; i += 1){
        compounds.forEach((el)=>{
            if (el.peakApex === pA[i]) el.orderNo = order;
        });
        order += 1;
    }
    return compounds;
};
const $ae486093709f123f$export$f744eee275aeedf9 = (compounds, settings)=>{
    const fractionTimes = [];
    const fractions = document.querySelectorAll('.fractions');
    for (const f of fractions){
        const start = $ae486093709f123f$var$toNum(f.querySelector('input[name="startTime"]')?.value);
        const end = $ae486093709f123f$var$toNum(f.querySelector('input[name="endTime"]')?.value);
        const selected = f.querySelector('input[name="fraction_selected"]').checked;
        const compositon = [];
        for(let index = 0; index < compounds.length; index++){
            const content = $ae486093709f123f$var$calcAreaPerc(compounds, index, Math.round(start / settings.dt), Math.round(end / settings.dt), settings.dt, 0.01);
            compositon.push([
                compounds[index].compoundName,
                content
            ]);
        }
        fractionTimes.push([
            start,
            end,
            selected,
            compositon
        ]);
    }
    return fractionTimes;
};
// Integrálás: egyszerű (baloldali) + dt-alapú; biztonságos indexekkel
const $ae486093709f123f$var$integrate = (dataPoints, start, end, step, threshold)=>{
    let sum = 0;
    const maxIndex = dataPoints.length - 1;
    const safeStart = Math.max(0, Math.min(start, maxIndex));
    const safeEnd = Math.max(0, Math.min(end, maxIndex));
    for(let index = safeStart; index < safeEnd; index += 1)if (dataPoints[index][1] >= threshold) {
        if (index > 0) sum += (dataPoints[index][0] - dataPoints[index - 1][0]) * dataPoints[index][1];
        else if (index + 1 <= maxIndex) sum += (dataPoints[index + 1][0] - dataPoints[index][0]) * dataPoints[index][1];
    }
    return sum;
};
// Integrálás több komponensre → [adott_komponens_területe, összterület]
const $ae486093709f123f$var$calcAreaPerc = (compounds, peakId, peakStart, peakEnd, step, threshold)=>{
    const areas = [];
    let totalArea = 0;
    for (const compound of compounds){
        const currentArea = $ae486093709f123f$var$integrate(compound.dataPoints, peakStart, peakEnd, step, threshold);
        areas.push(currentArea);
        totalArea += currentArea;
    }
    return [
        areas[peakId],
        totalArea
    ];
};
// Frakció tartalom cellák frissítése (mg)
const $ae486093709f123f$var$updateContent = (compounds, settings, runId)=>{
    if (!$ae486093709f123f$export$af0757c74f7ffed2(runId)) return;
    const contents = $ae486093709f123f$export$f744eee275aeedf9(compounds, settings);
    for(let i = 0; i < compounds.length; i++)for(let j = 0; j < contents.length; j++){
        const cell = document.getElementById(`cFR_${j}_${i}`);
        const mg = contents[j][3][i][1][0] * settings.flowRate; // terület × áramlás ≈ mennyiség
        if (cell) cell.innerHTML = `${mg.toFixed(2)} mg`;
    }
};
// (opcionális) Összefoglaló táblázat
const $ae486093709f123f$var$createSummary = (results, compounds, settings)=>{
    const summaryTable = document.querySelector('#summary-table tbody');
    if (!summaryTable) return;
    summaryTable.replaceChildren(); // biztos törlés
    results.forEach((res, i)=>{
        const row = document.createElement('tr');
        row.innerHTML = `
      <td>${res.name}</td>
      <td>${compounds[i].injAmount.toFixed(2)} mg</td>
      <td>${res.purity.toFixed(2)} %</td>
      <td>${res.recovery.toFixed(2)} %</td>
    `;
        summaryTable.appendChild(row);
    });
    const avgPurity = results.reduce((s, r)=>s + r.purity, 0) / results.length;
    const avgRecovery = results.reduce((s, r)=>s + r.recovery, 0) / results.length;
    const totalRow = document.createElement('tr');
    totalRow.innerHTML = `
    <td><b>\xc1tlag</b></td>
    <td>-</td>
    <td><b>${avgPurity.toFixed(2)} %</b></td>
    <td><b>${avgRecovery.toFixed(2)} %</b></td>
  `;
    summaryTable.appendChild(totalRow);
};
const $ae486093709f123f$export$61fc7d43ac8f84b0 = (fn, delay = 250)=>{
    let t;
    return (...args)=>{
        clearTimeout(t);
        t = setTimeout(()=>fn(...args), delay);
    };
};
const $ae486093709f123f$export$5e3bc6f9d5e187a3 = (exportRows)=>{
    if (!Array.isArray(exportRows) || exportRows.length === 0 || !Array.isArray(exportRows[0])) return;
    const rows = [];
    const rowCount = exportRows[0].length;
    for(let n = 0; n < rowCount; n += 1){
        const row = [];
        for(let index = 0; index < exportRows.length; index += 1)row.push((exportRows[index][n] || []).join(','));
        rows.push(row.join(','));
    }
    const blob = new Blob([
        rows.join('\n') + '\n'
    ], {
        type: 'text/csv;charset=utf-8'
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'cpc-simulation.csv';
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
};


var $033ff873cfd0f2e3$exports = {};
'use strict';
function $033ff873cfd0f2e3$var$parsePartitionCoefficient(value) {
    if (value === null || value === undefined) return null;
    const raw = String(value).trim();
    if (!raw) return null;
    if (!/^[+-]?(?:\d+(?:[.,]\d*)?|[.,]\d+)(?:[eE][+-]?\d+)?$/.test(raw)) return null;
    const parsed = Number(raw.replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : null;
}
function $033ff873cfd0f2e3$var$usableCpcRows(cpcData) {
    return (Array.isArray(cpcData) ? cpcData : []).map((row, index)=>({
            row: row,
            index: index,
            partitionCoefficient: $033ff873cfd0f2e3$var$parsePartitionCoefficient(row && row.Kd)
        }));
}
$033ff873cfd0f2e3$exports = {
    parsePartitionCoefficient: $033ff873cfd0f2e3$var$parsePartitionCoefficient,
    usableCpcRows: $033ff873cfd0f2e3$var$usableCpcRows
};


const { usableCpcRows: $62efd273bdced7a7$var$usableCpcRows } = (0, (/*@__PURE__*/$parcel$interopDefault($033ff873cfd0f2e3$exports)));
function $62efd273bdced7a7$var$showMessage(message) {
    let el = document.querySelector('.cmp-simulation-message');
    if (!el) {
        el = document.createElement('p');
        el.className = 'cmp-simulation-message';
        el.setAttribute('role', 'alert');
        document.querySelector('.cmp-wrap')?.prepend(el);
    }
    el.textContent = message;
}
function $62efd273bdced7a7$var$cpcSummary(choice) {
    const { row: row, partitionCoefficient: partitionCoefficient } = choice;
    return [
        row.solventSystem || 'Unknown solvent system',
        row.solventRatio || "\u2014",
        'Kd: ' + (row.Kd ?? "\u2014"),
        row.temp ? 'Temp: ' + row.temp : '',
        row.doi || row.reference ? 'Ref: ' + (row.doi || row.reference) : '',
        partitionCoefficient === null ? 'Unavailable: Kd is not a single numeric value' : ''
    ].filter(Boolean).join(" \xb7 ");
}
function $62efd273bdced7a7$var$chooseCpcData(choices) {
    return new Promise((resolve)=>{
        const overlay = document.createElement('div');
        overlay.className = 'cmp-cpc-selector';
        overlay.setAttribute('role', 'dialog');
        overlay.setAttribute('aria-modal', 'true');
        const panel = document.createElement('div');
        panel.className = 'cmp-cpc-selector__panel';
        const title = document.createElement('h3');
        title.textContent = 'Select CPC data for simulation';
        panel.appendChild(title);
        const list = document.createElement('div');
        list.className = 'cmp-cpc-selector__list';
        choices.forEach((choice)=>{
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'btn btn--blue btn--small';
            button.textContent = $62efd273bdced7a7$var$cpcSummary(choice);
            button.disabled = choice.partitionCoefficient === null;
            button.addEventListener('click', ()=>{
                document.body.classList.remove('cmp-modal-open');
                overlay.remove();
                resolve(choice);
            });
            list.appendChild(button);
        });
        panel.appendChild(list);
        const cancel = document.createElement('button');
        cancel.type = 'button';
        cancel.className = 'btn btn--small';
        cancel.textContent = 'Cancel';
        cancel.addEventListener('click', ()=>{
            document.body.classList.remove('cmp-modal-open');
            overlay.remove();
            resolve(null);
        });
        panel.appendChild(cancel);
        overlay.appendChild(panel);
        document.body.classList.add('cmp-modal-open');
        document.body.appendChild(overlay);
        const closeOnEscape = (event)=>{
            if (event.key === 'Escape') {
                document.removeEventListener('keydown', closeOnEscape);
                document.body.classList.remove('cmp-modal-open');
                overlay.remove();
                resolve(null);
            }
        };
        document.addEventListener('keydown', closeOnEscape, {
            once: true
        });
    });
}
function $62efd273bdced7a7$var$submitToVisualizer(compound, choice) {
    const selected = choice.row;
    const payload = {
        solventSystem: selected.solventSystem || '',
        solventRatio: selected.solventRatio || '',
        selectedCompound: {
            id: String(compound._id),
            slug: compound.slug || '',
            compoundName: compound.compoundName
        },
        selectedCpcData: {
            solventSystem: selected.solventSystem || '',
            solventRatio: selected.solventRatio || '',
            Kd: selected.Kd,
            temp: selected.temp ?? null,
            doi: selected.doi ?? null,
            reference: selected.reference ?? null
        },
        compounds: [
            {
                compoundName: compound.compoundName,
                kd: choice.partitionCoefficient
            }
        ]
    };
    const form = document.createElement('form');
    form.method = 'post';
    form.action = '/visualize';
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'data';
    input.value = JSON.stringify(payload);
    form.appendChild(input);
    document.body.appendChild(form);
    form.submit();
}
async function $62efd273bdced7a7$var$addDatabaseCompound(event) {
    const button = event.currentTarget;
    const id = button.dataset.compoundId;
    if (!id) return;
    const originalLabel = button.textContent;
    button.disabled = true;
    button.textContent = "Loading CPC data\u2026";
    try {
        const response = await fetch('/api/compounds/' + encodeURIComponent(id), {
            credentials: 'same-origin'
        });
        if (response.status === 401 || response.status === 403) {
            $62efd273bdced7a7$var$showMessage('Please log in to add a database compound to the simulation.');
            return;
        }
        if (!response.ok) throw new Error('Compound request failed with HTTP ' + response.status);
        const compound = (await response.json())?.data?.data;
        if (!compound || !compound._id) throw new Error('The compound API response is incomplete.');
        const choices = $62efd273bdced7a7$var$usableCpcRows(compound.cpcData);
        if (!choices.length) {
            $62efd273bdced7a7$var$showMessage('This compound has no CPC data to use for simulation.');
            return;
        }
        const selected = choices.length === 1 ? choices[0] : await $62efd273bdced7a7$var$chooseCpcData(choices);
        if (!selected) return;
        if (selected.partitionCoefficient === null) {
            $62efd273bdced7a7$var$showMessage('The selected CPC Kd is missing or not a single numeric value; it was not added.');
            return;
        }
        $62efd273bdced7a7$var$submitToVisualizer(compound, selected);
    } catch (error) {
        console.error('Database compound simulation selection failed:', error);
        $62efd273bdced7a7$var$showMessage('The compound could not be added to the simulation. Please try again.');
    } finally{
        button.disabled = false;
        button.textContent = originalLabel;
    }
}
document.querySelectorAll('.btn--use-in-simulation').forEach((button)=>button.addEventListener('click', $62efd273bdced7a7$var$addDatabaseCompound));


console.log('>>> EZ FUT: public/js/index.js');
/* ============================================================================
   Segédfüggvények: biztonságos event-kötések
   ========================================================================== */ const $09a4a460992a9e5e$var$on = (selectorOrEl, event, handler, options)=>{
    const el = typeof selectorOrEl === 'string' ? document.querySelector(selectorOrEl) : selectorOrEl;
    if (el) el.addEventListener(event, handler, options);
    return el;
};
const $09a4a460992a9e5e$var$onAll = (selector, event, handler, options)=>{
    document.querySelectorAll(selector).forEach((el)=>el.addEventListener(event, handler, options));
};
/* ============================================================================
   Általános DOM referenciák
   ========================================================================== */ const $09a4a460992a9e5e$var$loginForm = document.querySelector('.form--login');
const $09a4a460992a9e5e$var$logOutBtn = document.querySelector('.nav__el--logout');
const $09a4a460992a9e5e$var$userDataForm = document.querySelector('.form-user-settings');
const $09a4a460992a9e5e$var$userPasswordForm = document.querySelector('.form-user-password');
const $09a4a460992a9e5e$var$selectBtn = document.querySelectorAll('.btn--select');
const $09a4a460992a9e5e$var$selectedCompounds = document.querySelector('.selection');
const $09a4a460992a9e5e$var$chromatogram = document.querySelector('.plot');
const $09a4a460992a9e5e$var$tableButtons = document.querySelector('.buttons');
const $09a4a460992a9e5e$var$searchConatiner = document.querySelector('.search-body');
const $09a4a460992a9e5e$var$visualizerInput = document.querySelector('.input--visualizer');
const $09a4a460992a9e5e$var$totalAmount = document.getElementById('total-amount');
const $09a4a460992a9e5e$var$table = document.getElementById('compounds-table');
const $09a4a460992a9e5e$var$search = document.querySelector('.search-form');
const $09a4a460992a9e5e$var$searchBtn = document.getElementById('search-btn-r');
const $09a4a460992a9e5e$var$searchForm = document.querySelector('form[name="form"]');
const $09a4a460992a9e5e$var$method = document.getElementById('method');
/* ============================================================================
   Login / Logout / Profil űrlapok
   ========================================================================== */ if ($09a4a460992a9e5e$var$loginForm) $09a4a460992a9e5e$var$loginForm.addEventListener('submit', (e)=>{
    e.preventDefault();
    const email = document.getElementById('email')?.value || '';
    const password = document.getElementById('password')?.value || '';
    (0, $cd3113bade57e75e$export$596d806903d1f59e)(email, password);
});
if ($09a4a460992a9e5e$var$logOutBtn) $09a4a460992a9e5e$var$logOutBtn.addEventListener('click', (0, $cd3113bade57e75e$export$a0973bcfe11b05c9));
if ($09a4a460992a9e5e$var$userDataForm) $09a4a460992a9e5e$var$userDataForm.addEventListener('submit', (e)=>{
    e.preventDefault();
    const name = document.getElementById('name')?.value || '';
    const email = document.getElementById('email')?.value || '';
    (0, $9d6115ff614a714d$export$f558026a994b6051)({
        name: name,
        email: email
    }, 'data');
});
if ($09a4a460992a9e5e$var$userPasswordForm) $09a4a460992a9e5e$var$userPasswordForm.addEventListener('submit', async (e)=>{
    e.preventDefault();
    const saveBtn = document.querySelector('.btn--save-password');
    if (saveBtn) saveBtn.textContent = 'Updating...';
    const passwordCurrent = document.getElementById('password-current')?.value || '';
    const password = document.getElementById('password')?.value || '';
    const passwordConfirm = document.getElementById('password-confirm')?.value || '';
    await (0, $9d6115ff614a714d$export$f558026a994b6051)({
        passwordCurrent: passwordCurrent,
        password: password,
        passwordConfirm: passwordConfirm
    }, 'password');
    if (saveBtn) saveBtn.textContent = 'Save password';
    [
        'password-current',
        'password',
        'password-confirm'
    ].forEach((id)=>{
        const el = document.getElementById(id);
        if (el) el.value = '';
    });
});
/* ============================================================================
   Method mód (Elution / Elution-Extrusion) – Switch Time mező tiltása/engedése
   ========================================================================== */ if ($09a4a460992a9e5e$var$method) $09a4a460992a9e5e$var$method.addEventListener('change', ()=>{
    const switchTimeNodes = document.querySelectorAll('.switchT');
    if ($09a4a460992a9e5e$var$method.value === 'ex') switchTimeNodes.forEach((el)=>{
        el.classList.remove('form--disabled');
        el.disabled = false;
    });
    else {
        switchTimeNodes.forEach((el)=>{
            el.classList.add('form--disabled');
            el.disabled = true;
        });
        const st = document.getElementById('switch-time');
        if (st) st.value = 0;
    }
});
/* ============================================================================
   Kereső oldali "Select" gombok – kiválasztás + ajánlók + "Simulate"
   ========================================================================== */ if ($09a4a460992a9e5e$var$selectBtn && $09a4a460992a9e5e$var$selectedCompounds && $09a4a460992a9e5e$var$searchConatiner) {
    function handleClickSelect() {
        return async (e)=>{
            e.preventDefault();
            const rowNode = e.target.closest('tr');
            if (!rowNode) return;
            const cas = rowNode.closest('.card')?.querySelector('.cas')?.innerText || '';
            let coi = rowNode.closest('.card')?.querySelector('h3 span')?.textContent?.trim() || rowNode.closest('.card')?.querySelector('.heading-tertiary')?.textContent?.trim() || rowNode.closest('.card')?.querySelector('.card__title')?.textContent?.trim() || rowNode.children?.[0]?.textContent?.trim() || '';
            const cells = rowNode.children;
            const solventSystem = cells?.[0]?.textContent?.trim() || '';
            const solventRatio = cells?.[1]?.textContent?.trim() || '';
            const kd = cells?.[3]?.textContent?.trim() || '';
            const simulateData = {
                solventSystem: solventSystem,
                solventRatio: solventRatio,
                compounds: []
            };
            if (coi) simulateData.compounds.push({
                compoundName: coi,
                kd: kd
            });
            const h = document.createElement('h2');
            h.innerHTML = `Solvent System: ${solventSystem} in ${solventRatio} ratio <br> Sample Components:`;
            const list = document.createElement('ul');
            list.id = 'sample-components';
            if (coi) list.innerHTML = `<li><strong>${coi} (CoI), K<sub>D</sub>= ${kd || 'N.A.'}</strong></li>`;
            // töröld a korábbi keresési eredményt
            const oldResults = document.querySelector('.search-results.search-results--left');
            if (oldResults?.parentNode) oldResults.parentNode.removeChild(oldResults);
            try {
                const respSS = await (0, $040e0e9a6d6c1341$export$2e2bcd8739ae039).post('/api/compounds/sol-sys/', {
                    solSys: solventSystem,
                    solRatio: solventRatio,
                    selfCas: cas
                });
                if (respSS?.data?.status === 'success') {
                    const tbl = document.createElement('table');
                    tbl.classList.add('card__table-compound');
                    const head = '<thead><tr><th>Compound Name</th><th>Solvent System</th><th>Solvent Ratio</th><th>Kd</th><th>Select</th></tr></thead><tbody>';
                    const rows = [];
                    for (const c of respSS.data.data){
                        const k = c.kd ? Number(c.kd).toFixed(2) : '';
                        rows.push(`<tr>
                <td>${c.compoundName}</td>
                <td>${c.solSys}</td>
                <td>${c.ratio}</td>
                <td>${k}</td>
                <td><button class="btn btn--blue btn--xsmall btn--add-comp">Add</button></td>
              </tr>`);
                    }
                    rows.push('</tbody>');
                    tbl.innerHTML = `${head}${rows.join('')}`;
                    const container = document.createElement('div');
                    container.classList.add('search-results', 'search-results--left');
                    const heading = document.createElement('h2');
                    heading.classList.add('heading-secondary');
                    heading.textContent = 'CPC separations with the same solvent system';
                    container.appendChild(heading);
                    container.appendChild(tbl);
                    $09a4a460992a9e5e$var$searchConatiner.appendChild(container);
                    container.querySelectorAll('.btn--add-comp').forEach((btn)=>{
                        btn.addEventListener('click', (ev)=>{
                            const tr = ev.target.closest('tr');
                            const tds = tr?.children || [];
                            const compound = tds?.[0]?.textContent || '';
                            const kd2 = tds?.[3]?.textContent || '';
                            const li = document.createElement('li');
                            li.innerHTML = `${compound}, K<sub>D</sub>= ${kd2}`;
                            list.appendChild(li);
                            ev.target.disabled = true;
                            simulateData.compounds.push({
                                compoundName: compound,
                                kd: kd2
                            });
                        }, {
                            once: true
                        });
                    });
                }
            } catch (err) {
                console.error('sol-sys fetch hiba:', err);
            }
            $09a4a460992a9e5e$var$selectedCompounds.replaceChildren(h, list);
            const visForm = document.createElement('form');
            visForm.method = 'post';
            visForm.action = '/visualize';
            const visInput = document.createElement('input');
            visInput.type = 'hidden';
            visInput.name = 'data';
            const visBtn = document.createElement('button');
            visBtn.classList.add('btn', 'btn--blue', 'btn--simulate');
            visBtn.textContent = 'Simulate';
            visForm.appendChild(visInput);
            visForm.appendChild(visBtn);
            $09a4a460992a9e5e$var$selectedCompounds.appendChild(visForm);
            visBtn.addEventListener('click', (ev)=>{
                if (!simulateData.compounds.length) {
                    ev.preventDefault();
                    alert('Please add at least one compound.');
                    return;
                }
                visInput.value = JSON.stringify(simulateData);
            });
            document.querySelectorAll('.btn--select').forEach((button)=>{
                if (button === e.target) button.classList.add('btn--active');
                else {
                    button.disabled = true;
                    button.classList.add('btn--select:disabled');
                }
            });
        };
    }
    $09a4a460992a9e5e$var$selectBtn.forEach((btn)=>btn.addEventListener('click', handleClickSelect(), {
            once: true
        }));
}
/* ============================================================================
   Vizualizátor oldal – rajzolás, frakciók, export
   ========================================================================== */ if ($09a4a460992a9e5e$var$visualizerInput && $09a4a460992a9e5e$var$chromatogram && $09a4a460992a9e5e$var$table) {
    // Alap UI handlerek
    $ae486093709f123f$export$648a8d2aa643424b();
    $ae486093709f123f$export$d298918d4e7cbf62();
    const fractionsBox = document.querySelector('.fraction-table');
    if (fractionsBox) fractionsBox.style.display = 'none';
    // FRACTIONS PANEL MUTATÁSA
    $09a4a460992a9e5e$var$on('#show-ft', 'click', ()=>{
        if (!fractionsBox) return;
        if (fractionsBox.style.display === 'none') {
            fractionsBox.style.display = 'block';
            const blocker = document.getElementById('block-compound');
            if (blocker?.style) blocker.style.display = 'block';
            const compTable = document.getElementById('compounds-table');
            if (compTable?.style) compTable.style.opacity = 0.4;
            const btns = document.querySelector('.compounds .buttons');
            if (btns?.style) btns.style.opacity = 0.4;
        }
    });
    // VISSZA GOMB
    $09a4a460992a9e5e$var$on('.btn--back', 'click', ()=>{
        if (fractionsBox) fractionsBox.style.display = 'none';
        // frakciósávok törlése
        (0, $99083ef44e423f70$export$264a78fb3a6cde6f)({
            plot_id: 'plot-1'
        });
        const blocker = document.getElementById('block-compound');
        if (blocker?.style) blocker.style.display = 'none';
        const compTable = document.getElementById('compounds-table');
        if (compTable?.style) compTable.style.opacity = 1;
        const btns = document.querySelector('.compounds .buttons');
        if (btns?.style) btns.style.opacity = 1;
    });
    // ADD COMPOUND
    if ($09a4a460992a9e5e$var$tableButtons) {
        const addBtn = document.getElementById('add-button');
        if (addBtn) {
            let id = $09a4a460992a9e5e$var$table.rows.length - 1;
            addBtn.addEventListener('click', ()=>{
                $ae486093709f123f$export$c714d954d0ae1a89(id);
                id += 1;
                $09a4a460992a9e5e$var$visualizerInput.dispatchEvent(new Event('change'));
            });
        }
    }
    // REMOVE – delegált handler (mindenféle gombnévre)
    $09a4a460992a9e5e$var$table.addEventListener('click', (e)=>{
        const rm = e.target.closest('.delete-btn, .btn--remove, [data-action="remove"], [id^="delete-"]');
        if (!rm) return;
        e.preventDefault();
        rm.closest('tr')?.remove();
        $09a4a460992a9e5e$var$visualizerInput.dispatchEvent(new Event('change'));
    });
    // <<< DELEGÁLT INPUT/CHANGE FIGYELŐK A TÁBLÁRA >>>
    // Bármi lényeges mező változik → teljes újraszámítás + UI frissítés
    const reactIfCompoundField = (el)=>el.matches('.mass-prop-input, [name="concentration"], [name="partition-coefficient"], [name="solubility-up"], [name="solubility-lp"], [name="compound-name"]');
    $09a4a460992a9e5e$var$table.addEventListener('input', (ev)=>{
        if (reactIfCompoundField(ev.target)) $09a4a460992a9e5e$var$visualizerInput.dispatchEvent(new Event('change'));
    });
    $09a4a460992a9e5e$var$table.addEventListener('change', (ev)=>{
        if (reactIfCompoundField(ev.target)) $09a4a460992a9e5e$var$visualizerInput.dispatchEvent(new Event('change'));
    });
    // <<< EDDIG >>>
    // FŐ FUTTATÓ – runId + AbortController használat
    const runSimulation = async ()=>{
        const { runId: runId, signal: signal } = $ae486093709f123f$export$b6fb01e4bd9236ad();
        try {
            const settings = $ae486093709f123f$export$ccaf620e324f9da8();
            // Total injected amount (mg)
            if ($09a4a460992a9e5e$var$totalAmount) {
                const mg = settings.injectionVolume * settings.totalConcentration;
                $09a4a460992a9e5e$var$totalAmount.innerText = mg > 1000 ? `Total injected amount: ${(mg / 1000).toFixed(3)} g` : `Total injected amount: ${mg.toFixed(2)} mg`;
            }
            // Komponensek beolvasása
            const compounds = await $ae486093709f123f$export$8328d9d0a4c692ee($09a4a460992a9e5e$var$table, settings, signal, runId);
            if (!$ae486093709f123f$export$af0757c74f7ffed2(runId) || !Array.isArray(compounds) || compounds.length === 0) return;
            // --- Csúcselemzés (backend) + robusztus FWHM fallback ---
            const analyses = await Promise.all(compounds.map((c)=>$ae486093709f123f$export$c519fe7abce53a39(c, settings, signal).catch(()=>null)));
            // FWHM-ből számolt segéd (időben) – ha a backend nem adott mindent
            const fallbackFwhm = (pts)=>{
                if (!pts || pts.length < 3) return {
                    widthT: 0,
                    apexT: 0
                };
                let ymax = -Infinity, imax = 0;
                for(let i = 0; i < pts.length; i++)if (pts[i][1] > ymax) {
                    ymax = pts[i][1];
                    imax = i;
                }
                const half = ymax / 2;
                // bal félmagasság-idő
                let tL = pts[0][0];
                for(let i = imax; i > 0; i--)if (pts[i - 1][1] <= half && pts[i][1] >= half) {
                    const [t1, t2, y1, y2] = [
                        pts[i - 1][0],
                        pts[i][0],
                        pts[i - 1][1],
                        pts[i][1]
                    ];
                    tL = t1 + (half - y1) * (t2 - t1) / (y2 - y1);
                    break;
                }
                // jobb félmagasság-idő
                let tR = pts[pts.length - 1][0];
                for(let i = imax; i < pts.length - 1; i++)if (pts[i][1] >= half && pts[i + 1][1] <= half) {
                    const [t1, t2, y1, y2] = [
                        pts[i][0],
                        pts[i + 1][0],
                        pts[i][1],
                        pts[i + 1][1]
                    ];
                    tR = t1 + (half - y1) * (t2 - t1) / (y2 - y1);
                    break;
                }
                return {
                    widthT: Math.max(0, tR - tL),
                    apexT: pts[imax][0]
                };
            };
            // visszaírás a komponensekbe
            analyses.forEach((res, i)=>{
                const c = compounds[i];
                if (res && $ae486093709f123f$export$af0757c74f7ffed2(runId)) {
                    c.peakApex = res.peakApex ?? res.rtApex ?? res.apexRt ?? c.peakApex ?? null;
                    const wVol = res.widthVolume ?? res.peakWidthVol ?? res.Wv ?? null;
                    const wHalfT = res.widthHalfTime ?? res.fwhmTime ?? null; // ha időben jött
                    c.widthVolume = wVol ?? (wHalfT ? wHalfT * settings.flowRate : c.widthVolume ?? null);
                    c.thPlates = res.thPlates ?? res.N ?? c.thPlates ?? null;
                }
                // Fallback, ha hiányos
                if (!c.widthVolume || !c.peakApex || !c.thPlates) {
                    const { widthT: widthT, apexT: apexT } = fallbackFwhm(c.dataPoints);
                    if (!c.peakApex) c.peakApex = apexT;
                    const Wt = widthT; // [min]
                    const Wv = Wt * settings.flowRate; // [mL]
                    if (!c.widthVolume) c.widthVolume = Wv > 0 ? Wv : null;
                    // Lemezszám (FWHM képlet)
                    if (!c.thPlates && Wt > 0 && c.rt > 0) c.thPlates = 5.54 * Math.pow(c.rt / Wt, 2);
                }
            });
            // Max jel magasság a skálához
            const maxConc = Math.max(...compounds.map((d)=>d.height));
            // Plot beállítások
            const chromatogramSettings = {
                plot_id: 'plot-1',
                width: 800,
                height: 600,
                padding: 60,
                xMax: settings.runtime,
                yMax: maxConc + 5,
                outClass: 'chrom',
                textClass: 'plot__label',
                colors: [
                    'rgb(64,64,65)',
                    'rgb(0,81,127)',
                    'rgb(0,225,190)',
                    'rgb(109,110,113)',
                    'rgb(50,188,173)',
                    'yellow',
                    'orange',
                    'red'
                ]
            };
            // Alap plot
            (0, $99083ef44e423f70$export$2bbbe2756ad57c66)($09a4a460992a9e5e$var$chromatogram, chromatogramSettings);
            // Görbék + export + összeg görbe
            const eCompounds = [];
            const sumValues = [];
            let first = true;
            for (const [idx, c] of compounds.entries()){
                (0, $99083ef44e423f70$export$7b3b530b37ddd649)(c.compoundName, c.dataPoints, idx + 1, 'path', chromatogramSettings);
                const d = c.dataPoints.slice();
                d.unshift([
                    `Time_${c.compoundName}`,
                    `Concentration_${c.compoundName}`
                ]);
                eCompounds.push(d);
                for(let i = 0; i < c.dataPoints.length; i++){
                    const t = c.dataPoints[i][0];
                    const y = c.dataPoints[i][1];
                    if (first) sumValues.push([
                        t,
                        y
                    ]);
                    else sumValues[i][1] += y;
                }
                first = false;
            }
            // Metódus jelölések
            (0, $99083ef44e423f70$export$3879f6c5439d8140)(settings, chromatogramSettings);
            // Csúcssorrend + RS (már van widthVolume + k)
            $ae486093709f123f$export$bc0946f73995bccf(compounds);
            for (const el of compounds)for (const other of compounds){
                if (other.orderNo === el.orderNo + 1) {
                    el.rsNext = 2 * ((other.peakApex - el.peakApex) * settings.flowRate) / (el.widthVolume + other.widthVolume);
                    el.selNext = other.k / el.k;
                }
                if (other.orderNo === el.orderNo - 1) {
                    el.rsPrev = 2 * ((el.peakApex - other.peakApex) * settings.flowRate) / (el.widthVolume + other.widthVolume);
                    el.selPrev = el.k / other.k;
                }
            }
            // Peak details – teljes újrarajzolás
            $ae486093709f123f$export$23bb8f513680c73d(compounds, runId);
            // Összeg görbe
            (0, $99083ef44e423f70$export$7b3b530b37ddd649)('Sum Concentration', sumValues, 0, 'line', chromatogramSettings);
            // Frakciók + nézetválasztó
            const compNames = compounds.map((d)=>d.compoundName);
            $ae486093709f123f$export$111505ab5aab402f(compounds, settings, chromatogramSettings, runId);
            (0, $99083ef44e423f70$export$a6e8031964c4ff10)('#view-selector', 'plot-1', compNames);
            // Export gomb
            const exportBtn = document.querySelector('.btn--export');
            if (exportBtn) exportBtn.onclick = ()=>$ae486093709f123f$export$5e3bc6f9d5e187a3?.(eCompounds);
        } catch (err) {
            if (err?.name !== 'CanceledError' && err?.message !== 'canceled') console.error('Visualizer change hiba:', err);
        } finally{
            $ae486093709f123f$export$8b68d1c27cfb577e(runId);
        }
    };
    // Változásra futtassuk (debounce-olva is lehetne)
    $09a4a460992a9e5e$var$visualizerInput.addEventListener('change', runSimulation);
    // induló futás
    $09a4a460992a9e5e$var$visualizerInput.dispatchEvent(new Event('change'));
}
/* ============================================================================
   Kereső űrlap – similarity opció + SMILES → CAS feloldás
   ========================================================================== */ if ($09a4a460992a9e5e$var$search) {
    let similarity = false;
    const chkSimilarity = document.getElementById('similarity');
    const compName = document.querySelector('input[value="compoundName"]');
    const radioSmiles = document.querySelector('input[value="smiles"]');
    let searchByVal = document.querySelector('input[name="searchBy"]:checked')?.value;
    document.querySelectorAll('input[name="searchBy"]').forEach((r)=>r.addEventListener('change', ()=>{
            searchByVal = document.querySelector('input[name="searchBy"]:checked')?.value;
        }));
    if (chkSimilarity) chkSimilarity.addEventListener('change', (e)=>{
        if (!$09a4a460992a9e5e$var$searchForm) return;
        if (e.target.checked) {
            similarity = true;
            $09a4a460992a9e5e$var$searchForm.setAttribute('method', 'POST');
            if (compName) compName.disabled = true;
            if (radioSmiles) {
                radioSmiles.checked = true;
                radioSmiles.dispatchEvent(new Event('change'));
            }
            if (!document.getElementById('sim-cont')) {
                const threshold = document.createElement('input');
                threshold.type = 'number';
                threshold.classList.add('form__input', 'similarity', 'input--similarity');
                threshold.name = 'threshold';
                threshold.id = 'threshold';
                threshold.min = 0;
                threshold.max = 1;
                threshold.step = 0.01;
                threshold.value = 0.9;
                const label = document.createElement('label');
                label.classList.add('form__label--sim', 'similarity');
                label.setAttribute('for', 'threshold');
                label.innerText = 'Threshold:';
                const container = document.createElement('div');
                container.id = 'sim-cont';
                container.appendChild(label);
                container.appendChild(threshold);
                document.querySelector('.form__elem--similarity')?.appendChild(container);
            }
        } else {
            similarity = false;
            if (compName) compName.disabled = false;
            document.getElementById('sim-cont')?.remove();
            $09a4a460992a9e5e$var$searchForm.setAttribute('method', 'GET');
        }
    });
    if ($09a4a460992a9e5e$var$searchBtn) $09a4a460992a9e5e$var$searchBtn.addEventListener('click', async (e)=>{
        e.preventDefault();
        if (!$09a4a460992a9e5e$var$searchForm) return;
        if (similarity) // hasonlósági keresés szerveroldalon (POST)
        $09a4a460992a9e5e$var$searchForm.submit();
        else {
            // alap keresés – ha SMILES alapon keresünk, előbb feloldjuk CAS-re
            const searchByVal = document.querySelector('input[name="searchBy"]:checked')?.value;
            if (searchByVal === 'smiles') {
                const q = document.querySelector('input[name="q"]')?.value || '';
                const cas = await $09a4a460992a9e5e$var$getCasFromSmiles(q);
                if (cas) window.location.href = `/search/?q=${encodeURIComponent(cas)}&searchBy=cas`;
                else // ha nem sikerült CAS-t feloldani, essünk vissza a normál submitra
                $09a4a460992a9e5e$var$searchForm.submit();
            } else $09a4a460992a9e5e$var$searchForm.submit();
        }
    });
}
/* ============================================================================
   SMILES → CAS feloldás
   ========================================================================== */ const $09a4a460992a9e5e$var$getCasFromSmiles = async (s)=>{
    try {
        const resp = await (0, $040e0e9a6d6c1341$export$2e2bcd8739ae039)({
            method: 'POST',
            url: '/api/compounds/smiles/',
            data: {
                smiles: s
            }
        });
        if (resp?.data?.status === 'success') return resp.data.data.compound.cas;
    } catch (err) {
        console.error('getCasFromSmiles hiba:', err);
    }
    return '';
};

})();
//# sourceMappingURL=index.js.map
